(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  /* Wrap every <table> inside the article body with a scrollable
     container so wide tables (like Portl's "5 Modes" pricing table)
     get horizontal scroll on mobile instead of overflowing the
     viewport. Idempotent — safe to run on theme-editor section
     reloads. */
  (function () {
    var WRAP_CLASS = 'portl-article__table-wrap';
    function wrapTables(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.portl-article__body table').forEach(function (t) {
        var parent = t.parentElement;
        if (parent && parent.classList && parent.classList.contains(WRAP_CLASS)) return;
        var wrap = document.createElement('div');
        wrap.className = WRAP_CLASS;
        t.parentNode.insertBefore(wrap, t);
        wrap.appendChild(t);
      });
    }

    // Hide broken inline images so iOS Safari doesn't render its "?"
    // placeholder. CSS handles empty/missing src; this catches the
    // case where src IS valid but the resource 404s / fails to load.
    function attachBrokenImgHandler(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.portl-article__body img').forEach(function (img) {
        if (img.dataset.portlImgBound === '1') return;
        img.dataset.portlImgBound = '1';
        // If the image already failed before our handler attached
        // (cache-miss + DOMContentLoaded race), mark it broken now.
        // `complete && naturalWidth === 0` is the cross-browser test.
        if (img.complete && img.naturalWidth === 0) {
          img.classList.add('is-broken');
        }
        img.addEventListener('error', function () {
          img.classList.add('is-broken');
        });
      });
    }

    function boot() {
      wrapTables(document);
      attachBrokenImgHandler(document);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      wrapTables(e.target);
      attachBrokenImgHandler(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* ─── Cart quantity stepper (AJAX) ───────────────────────────
     Why this exists:
       The −/+ buttons (and the remove links) used to submit the
       cart form, which POSTed to /cart and triggered a FULL PAGE
       reload — the whole screen flashed/re-initialised on every
       click. This handler instead talks to Shopify's AJAX Cart API
       (`/cart/change.js`) and uses the Section Rendering API to swap
       just this section's markup in place, so totals and line items
       update without a reload.

     Scope:
       Listens at the section root and re-binds after each in-place
       swap (and on `shopify:section:load` in the theme editor) so
       freshly rendered buttons keep working.
  ─────────────────────────────────────────────────────────────── */
  (function () {
    var updating = false;

    function cartChangeUrl() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.replace(/\/$/, '') + '/cart/change.js';
    }

    /* Replace the current section's DOM with freshly rendered markup
       returned by the Section Rendering API, then re-bind handlers. */
    function refreshSection(sectionId, html) {
      var current = document.querySelector('.cart-page[data-section-id="' + sectionId + '"]');
      var fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.cart-page[data-section-id]');
      if (!current || !fresh) { window.location.reload(); return; }
      current.replaceWith(fresh);
      bind(fresh);
    }

    /* POST a new quantity for one line item, then swap in the result. */
    function updateLine(section, key, quantity) {
      if (updating || !key) return;
      updating = true;
      section.classList.add('is-updating');
      var sectionId = section.getAttribute('data-section-id');

      fetch(cartChangeUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.sections && data.sections[sectionId]) {
            refreshSection(sectionId, data.sections[sectionId]);
          } else {
            window.location.reload();
          }
          /* Keep the header cart-count badge in sync (no reload). */
          if (typeof window.portlRefreshCartCount === 'function') {
            window.portlRefreshCartCount();
          }
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { updating = false; });
    }

    function keyFor(el) {
      var row = el.closest('[data-cart-item-key]');
      return row ? row.getAttribute('data-cart-item-key') : null;
    }

    function bind(section) {
      if (!section || section.dataset.cartQtyInit === '1') return;
      section.dataset.cartQtyInit = '1';

      /* −/+ stepper buttons */
      section.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cart-qty-step]');
        if (!btn) return;
        e.preventDefault();

        var wrap = btn.closest('[data-cart-qty]');
        var input = wrap && wrap.querySelector('[data-cart-qty-input]');
        if (!input) return;

        var step    = parseInt(btn.getAttribute('data-cart-qty-step'), 10) || 0;
        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = 0;

        var next = current + step;
        if (next < 0) next = 0;
        if (next === current) return;

        input.value = next; /* optimistic; section swap confirms it */
        updateLine(section, keyFor(btn), next);
      });

      /* Manual quantity typing */
      section.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-qty-input]');
        if (!input) return;
        var next = parseInt(input.value, 10);
        if (isNaN(next) || next < 0) next = 0;
        updateLine(section, keyFor(input), next);
      });

      /* Remove links → quantity 0, AJAX instead of navigating */
      section.addEventListener('click', function (e) {
        var link = e.target.closest('.cart-item__remove');
        if (!link) return;
        e.preventDefault();
        updateLine(section, keyFor(link), 0);
      });
    }

    function init(root) {
      var section = (root || document).querySelector('.cart-page[data-section-id]');
      if (section) bind(section);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
  // Accordion behavior — single FAQ item open at a time, smooth toggle.
  // Compatible with the original data-pdp-faq / data-faq-toggle hooks.
  (function () {
    function init(root) {
      root = root || document;
      root.querySelectorAll('[data-pdp-faq]').forEach(function (list) {
        if (list.dataset.pdpFaqInit === '1') return;
        list.dataset.pdpFaqInit = '1';
        var items = list.querySelectorAll('[data-faq-item]');
        items.forEach(function (item) {
          var btn = item.querySelector('[data-faq-toggle]');
          if (!btn) return;
          btn.addEventListener('click', function () {
            var open = item.classList.contains('is-open');
            items.forEach(function (other) {
              other.classList.remove('is-open');
              var b = other.querySelector('[data-faq-toggle]');
              if (b) b.setAttribute('aria-expanded', 'false');
            });
            if (!open) {
              item.classList.add('is-open');
              btn.setAttribute('aria-expanded', 'true');
            }
          });
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero"] && !Shopify.designMode) return;
  try {
    
  // ─── Variant-aware "In The Box" list controller ─────────────
  // Listens for `portl:variant-change` (dispatched by
  // assets/portl-theme.js on PDP variant radio change), then
  // toggles each included_item's visibility + highlight based on
  // the per-block `variant_titles` setting embedded as
  // `data-variant-match` (case-insensitive substring match).
  //
  // Resolution: variantId → title via the data-variants-map JSON
  // on the parent <ul>, populated server-side from product.variants.
  (function () {
    // Sync list state (item visibility + accordion mode) to the
    // current variant. Two independent reasons an item may hide:
    //   1. variant_titles mismatch → .is-hidden
    //   2. accordion mode active AND item is a base item AND the
    //      accordion is closed → .is-accordion-collapsed
    function applyVisibility(list, currentTitle) {
      var summary = list.querySelector('[data-portl-accordion-summary]');
      var trigger = (list.getAttribute('data-accordion-trigger') || '').trim();
      var accordionActive = !!(trigger && currentTitle.indexOf(trigger) !== -1);

      if (summary) {
        if (accordionActive) {
          summary.classList.remove('is-hidden');
        } else {
          // Leaving accordion mode — hide summary AND collapse the
          // list so the next visit starts in the closed state.
          summary.classList.add('is-hidden');
          summary.setAttribute('aria-expanded', 'false');
          list.classList.remove('is-accordion-open');
        }
      }
      var isOpen = list.classList.contains('is-accordion-open');

      var items = list.querySelectorAll('[data-portl-included-item]');
      items.forEach(function (item) {
        var match = item.getAttribute('data-variant-match');
        var isBase = item.hasAttribute('data-portl-accordion-base');
        var visibleByVariant = true;

        if (match) {
          visibleByVariant = false;
          var parts = match.split(',');
          for (var i = 0; i < parts.length; i++) {
            var p = parts[i].trim();
            if (p && currentTitle.indexOf(p) !== -1) {
              visibleByVariant = true;
              break;
            }
          }
        }

        if (visibleByVariant) {
          item.classList.remove('is-hidden');
        } else {
          item.classList.add('is-hidden');
        }

        var collapsedByAccordion = isBase && accordionActive && !isOpen;
        if (collapsedByAccordion) {
          item.classList.add('is-accordion-collapsed');
        } else {
          item.classList.remove('is-accordion-collapsed');
        }
      });
    }

    // Set up the click + keyboard toggle for the accordion summary.
    // Idempotent — won't double-bind on shopify:section:load.
    function bindSummary(list) {
      var summary = list.querySelector('[data-portl-accordion-summary]');
      if (!summary || summary.dataset.portlSummaryBound === '1') return;
      summary.dataset.portlSummaryBound = '1';

      function toggle() {
        var open = list.classList.toggle('is-accordion-open');
        summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        var base = list.querySelectorAll('[data-portl-accordion-base]');
        base.forEach(function (item) {
          if (open) {
            item.classList.remove('is-accordion-collapsed');
          } else {
            item.classList.add('is-accordion-collapsed');
          }
        });
      }

      summary.addEventListener('click', toggle);
      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggle();
        }
      });
    }

    function init() {
      var lists = document.querySelectorAll('[data-portl-included]');
      if (!lists.length) return;

      lists.forEach(function (list) {
        if (list.dataset.portlIncludedInit === '1') return;
        list.dataset.portlIncludedInit = '1';

        bindSummary(list);

        var mapAttr = list.getAttribute('data-variants-map');
        if (!mapAttr) return;
        var map;
        try { map = JSON.parse(mapAttr); } catch (e) { return; }

        document.addEventListener('portl:variant-change', function (evt) {
          if (!evt || !evt.detail) return;
          var vid = String(evt.detail.variantId || '');
          if (!vid) return;
          var title = map[vid];
          if (typeof title !== 'string') return;
          applyVisibility(list, title.toLowerCase());
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-portl-included]')) {
        init();
      }
    });
  })();

  // ─── Mobile thumbnail overflow badge ─────────────────────────
  // On mobile (<768px), only the first 4 *visible* thumbs are shown
  // in a single row. The 4th gets a "+N" overlay where N is the
  // count of hidden visible thumbs (visibleCount - 4).
  //
  // "Visible" = thumbs not hidden by the variant-filter in
  // assets/portl-theme.js (which sets display:none directly on the
  // element style). We re-run on init, on `portl:variant-change`
  // (variant filter changed which thumbs are display:none), on
  // window resize (mobile/desktop crossover), and on
  // shopify:section:load.
  (function () {
    var MOBILE_MAX = 4;
    var MOBILE_BREAKPOINT = 768; // matches the CSS media query above

    function isThumbVisibleByFilter(btn) {
      // The variant filter in portl-theme.js sets style.display = 'none'
      // directly. We ignore CSS-driven media-query hides (those are us).
      // Walk up to make sure no ancestor hides it either.
      if (btn.style.display === 'none') return false;
      // Exclude any thumb we ourselves hid in a previous pass.
      if (btn.classList.contains('is-mobile-extra')) {
        // Temporarily treat it as visible for re-computation.
        return true;
      }
      return true;
    }

    function clearMarkers(thumbs) {
      thumbs.forEach(function (btn) {
        btn.classList.remove('is-mobile-extra');
        btn.classList.remove('has-overflow-badge');
        btn.removeAttribute('data-overflow-count');
      });
    }

    function applyOverflow(container) {
      if (!container) return;
      var all = Array.prototype.slice.call(
        container.querySelectorAll('.pdp-gallery__thumb')
      );
      if (!all.length) return;

      // Always clear first so we don't double-count our own
      // `is-mobile-extra` thumbs (which would mis-set display).
      clearMarkers(all);

      // Above the mobile breakpoint we want the normal grid back.
      if (window.innerWidth >= MOBILE_BREAKPOINT) return;

      var visible = all.filter(isThumbVisibleByFilter);
      var extra = visible.length - MOBILE_MAX;
      if (extra <= 0) return;

      // 4th visible thumb gets the badge with the extra count.
      var badgeThumb = visible[MOBILE_MAX - 1];
      badgeThumb.classList.add('has-overflow-badge');
      badgeThumb.setAttribute('data-overflow-count', String(extra));

      // 5th visible thumb onward gets hidden on mobile.
      for (var i = MOBILE_MAX; i < visible.length; i++) {
        visible[i].classList.add('is-mobile-extra');
      }
    }

    function applyAll() {
      var containers = document.querySelectorAll('[data-gallery-thumbs]');
      containers.forEach(applyOverflow);
    }

    function init() {
      // Defer so it runs AFTER assets/portl-theme.js has filtered the
      // thumbs for the initially selected variant.
      setTimeout(applyAll, 0);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    // Variant change → portl-theme.js re-runs filterForVariant
    // (sets display:none on filtered-out thumbs) then dispatches
    // this event. We re-apply the badge against the new visible set.
    document.addEventListener('portl:variant-change', function () {
      // setTimeout 0 to let portl-theme.js finish its sync work first.
      setTimeout(applyAll, 0);
    });

    // Viewport resize (mobile <-> desktop) — debounced.
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(applyAll, 150);
    });

    // Theme editor section reload.
    document.addEventListener('shopify:section:load', function (e) {
      if (
        e.target &&
        e.target.querySelector &&
        e.target.querySelector('[data-gallery-thumbs]')
      ) {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-portl-announce]');
    if (!bar) return;

    var dismissible = bar.getAttribute('data-dismissible') === 'true';
    var key = 'portl-announce-dismissed::' + bar.getAttribute('data-dismiss-key');

    // Helper: reset the bar-height var so the navbar slides up to top: 0
    function clearOffset() {
      document.documentElement.style.setProperty('--portl-bar-h', '0px');
    }

    // Hide if previously dismissed (and message hasn't changed)
    if (dismissible) {
      try {
        if (window.localStorage && localStorage.getItem(key) === '1') {
          bar.classList.add('portl-announce--dismissed');
          clearOffset();
          return;
        }
      } catch (e) { /* localStorage unavailable */ }
    }

    var btn = bar.querySelector('[data-portl-announce-close]');
    if (btn) {
      btn.addEventListener('click', function () {
        bar.classList.add('portl-announce--dismissed');
        clearOffset();
        try { if (window.localStorage) localStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-app-insights"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     Portl App Insights tab controller — fixed-phone variant
     - All videos live inside the same .screen overlay
     - Click tab → toggle .is-active on the matching video
     - Active highlight pill slides via translateX
     - Autoplay attempts on first user gesture if blocked by browser
     ============================================================ */
  (function () {
    function init() {
      var sections = document.querySelectorAll('[data-portl-app-insights]');
      sections.forEach(function (root) {
        if (root.dataset.paiInit === '1') return;
        root.dataset.paiInit = '1';

        var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-portl-app-insights-tab]'));
        var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-portl-app-insights-screen] > *'))
          .filter(function (m) { return m.getAttribute('data-tab-target'); });
        var wrap = root.querySelector('[data-portl-app-insights-wrap]');
        var screenEl = root.querySelector('[data-portl-app-insights-screen]');
        var highlight = root.querySelector('[data-portl-app-insights-highlight]');
        var tabBar = root.querySelector('[data-portl-app-insights-tabs]');
        if (tabs.length === 0) return;

        // Lazy-load helper — works for ALL tab videos now (was previously
        // gated to watch-frame only). The <source> is omitted server-side
        // on every non-default tab, so this is what actually wires up the
        // video for playback when the tab is activated.
        //
        // Why generalize: previously the section pre-warmed every video
        // with .play() on init, which on iOS triggered 5+ parallel MP4
        // downloads on page load — the root cause of the slow loading
        // reported by users on iPhones. Now only the default tab loads
        // on init, every other tab loads on first activation.
        function ensureLazyLoaded(media) {
          if (media.tagName !== 'VIDEO') return;
          if (media.getAttribute('data-lazy-init') === '1') return;
          var src = media.getAttribute('data-src');
          if (!src) return;
          var hasSource = media.querySelector('source');
          if (!hasSource) {
            var source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            media.appendChild(source);
          }
          media.setAttribute('preload', 'auto');
          try { media.load(); } catch (e) {}
          media.setAttribute('data-lazy-init', '1');
        }

        var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
        var sectionVisible = true;
        var currentIdx = 0;

        // No more pre-warm — that was triggering N parallel video downloads
        // on init. The default tab's video has the <source> + autoplay
        // attribute server-side, so the browser handles it natively. Every
        // other video stays inert until its tab is activated.

        // ── playMedia: iOS-safe play() with canplay retry ─────────────
        //
        // The previous implementation called `media.play()` and silently
        // swallowed the rejected promise with `.catch(function () {})`.
        // On iOS, when a video has been lazy-loaded but hasn't reached
        // HAVE_CURRENT_DATA yet (common on cellular within the first
        // ~500ms after load()), play() rejects — and the swallow meant
        // the auto-advance cascade silently died on the first transition.
        //
        // The fix: on rejection, wait for 'canplay' and try ONCE more.
        // That's enough to bridge the gap between load() and the video
        // being playable. If the second attempt also fails, we give up
        // quietly — but the cascade can still recover on the next
        // 'ended' / 'timeupdate' fire.
        //
        // We also defer `currentTime = 0` until readyState >= 1
        // (HAVE_METADATA), since seeking an unloaded video throws on
        // some iOS versions.
        function playMedia(media, opts) {
          if (!media || media.tagName !== 'VIDEO') return;
          opts = opts || {};
          // `resume: true` means "continue from current position" —
          // used by the visibilitychange / pageshow handlers when the
          // user returns from a phone call, notification, app switch,
          // or browser tab change. Default false → reset to 0 (used
          // for tab activations, where we always want to start fresh).
          var resume = opts.resume === true;
          function attempt(retry) {
            if (!resume && media.readyState >= 1 /* HAVE_METADATA */) {
              try { media.currentTime = 0; } catch (e) {}
            }
            try {
              var p = media.play();
              if (p && typeof p.then === 'function') {
                p.catch(function () {
                  if (retry) return; // already retried — give up
                  var onCanplay = function () {
                    media.removeEventListener('canplay', onCanplay);
                    attempt(true);
                  };
                  media.addEventListener('canplay', onCanplay, { once: true });
                });
              }
            } catch (e) {}
          }
          attempt(false);
        }

        // Convenience helper used by visibility / pageshow handlers.
        function getCurrentMedia() {
          for (var i = 0; i < mediaItems.length; i++) {
            if (mediaItems[i].classList.contains('is-active')) return mediaItems[i];
          }
          return null;
        }

        // ── End-of-video detector with iOS 'timeupdate' fallback ──────
        //
        // The 'ended' event SHOULD fire on every non-looped video, but
        // iOS Safari has known cases where it doesn't — particularly on
        // lazy-loaded videos where load() + play() race the metadata.
        //
        // Belt-and-suspenders: listen for 'ended' AND watch 'timeupdate'
        // for currentTime crossing duration-0.15s. The per-video
        // `advanced` flag prevents both firing for the same playback.
        // Reset on 'play' so the next playback can trigger again.
        function attachEndDetector(media) {
          if (media.tagName !== 'VIDEO') return;
          var advanced = false;
          media.addEventListener('play', function () { advanced = false; });
          media.addEventListener('ended', function () {
            if (advanced) return;
            advanced = true;
            handleVideoEnded(media);
          });
          media.addEventListener('timeupdate', function () {
            if (advanced) return;
            if (!media.duration || isNaN(media.duration) || !isFinite(media.duration)) return;
            if (media.currentTime >= media.duration - 0.15) {
              advanced = true;
              handleVideoEnded(media);
            }
          });
        }

        function positionHighlight(idx) {
          if (!highlight) return;
          var tab = tabs[idx];
          if (!tab) return;
          // The highlight is a child of the SCROLLED tabs container.
          // tab.offsetLeft already returns the tab's position relative to
          // the scroll content (not the viewport), so we use it directly.
          // Subtracting scrollLeft was double-correcting and breaking the
          // pill alignment on mobile when tabs overflow horizontally.
          highlight.style.width = tab.offsetWidth + 'px';
          highlight.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
        }

        function scrollTabIntoView(idx) {
          if (!tabBar) return;
          var tab = tabs[idx];
          if (!tab) return;
          // Only act when the tab bar actually overflows (typical on
          // narrow mobile viewports). Smoothly centers the active tab
          // in the visible area so the user can always see what's
          // selected — important when autoplay advances to a tab that
          // was scrolled off-screen.
          if (tabBar.scrollWidth <= tabBar.clientWidth) return;
          var target = tab.offsetLeft + (tab.offsetWidth / 2) - (tabBar.clientWidth / 2);
          var maxScroll = tabBar.scrollWidth - tabBar.clientWidth;
          if (target < 0) target = 0;
          if (target > maxScroll) target = maxScroll;
          if (typeof tabBar.scrollTo === 'function') {
            tabBar.scrollTo({ left: target, behavior: 'smooth' });
          } else {
            tabBar.scrollLeft = target;
          }
        }

        function activate(idx, opts) {
          opts = opts || {};
          if (idx < 0 || idx >= tabs.length) return;
          currentIdx = idx;

          tabs.forEach(function (t, i) {
            var active = (i === idx);
            t.classList.toggle('is-selected', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
            t.setAttribute('tabindex', active ? '0' : '-1');
          });

          var targetId = tabs[idx].getAttribute('data-tab-id');
          var useWatch = false;
          mediaItems.forEach(function (m) {
            var match = m.getAttribute('data-tab-target') === targetId;
            m.classList.toggle('is-active', match);
            m.setAttribute('aria-hidden', match ? 'false' : 'true');
            if (match && m.getAttribute('data-use-watch-frame') === 'true') {
              useWatch = true;
            }
            if (m.tagName === 'VIDEO') {
              if (match && sectionVisible) {
                // Lazy-load on first activation (works for ALL tabs now,
                // not just watch-frame — the default tab is already eager-
                // loaded via its server-rendered <source>).
                ensureLazyLoaded(m);
                // playMedia handles the iOS race where load() hasn't yet
                // produced enough data for play() — it retries on canplay.
                playMedia(m);
              } else {
                try { m.pause(); } catch (e) {}
              }
            }
          });

          // Preload the NEXT tab's video IMMEDIATELY (was delayed 100ms,
          // which on slow iPhone networks meant the next video wasn't
          // ready when the current one ended — causing playMedia's first
          // play() attempt to fail). Starting the download in parallel
          // with the current tab's play() doesn't slow current playback
          // (the active video already has higher priority in the
          // browser's resource scheduler) and dramatically reduces the
          // chance of canplay-retry being needed on tab transition.
          if (autoplayEnabled && mediaItems.length > 1) {
            var nextTabId = tabs[(idx + 1) % tabs.length].getAttribute('data-tab-id');
            mediaItems.forEach(function (m) {
              if (m.getAttribute('data-tab-target') === nextTabId) {
                ensureLazyLoaded(m);
              }
            });
          }

          // Frame swap — applies to wrap (margins) and screen (sizing + img).
          var frame = useWatch ? 'watch' : 'phone';
          if (wrap) wrap.setAttribute('data-frame', frame);
          if (screenEl) screenEl.setAttribute('data-frame', frame);

          positionHighlight(idx);
          scrollTabIntoView(idx);

          if (opts.focus && tabs[idx] && tabs[idx].focus) {
            tabs[idx].focus({ preventScroll: true });
          }
        }

        tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () {
            activate(i, { focus: true });
            restartAutoplay();
          });
          tab.addEventListener('keydown', function (e) {
            var next = -1;
            if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
            else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = tabs.length - 1;
            if (next !== -1) {
              e.preventDefault();
              activate(next, { focus: true });
              restartAutoplay();
            }
          });
        });

        // ── First-gesture fallback: if iOS / Safari blocked autoplay
        // even with muted, retry play() the first time the user touches
        // / clicks / scrolls anywhere on the page.
        function gestureRetry() {
          var currentVid = mediaItems.find ? mediaItems.find(function (m) { return m.classList.contains('is-active'); }) : null;
          if (currentVid) playMedia(currentVid);
          ['touchstart', 'click', 'scroll'].forEach(function (ev) {
            window.removeEventListener(ev, gestureRetry);
          });
        }
        ['touchstart', 'click', 'scroll'].forEach(function (ev) {
          window.addEventListener(ev, gestureRetry, { once: true, passive: true });
        });

        // ── Auto-advance on video END (replaces the old interval timer)
        //
        // Each tab's video has `loop` REMOVED server-side so 'ended' fires
        // naturally. When it fires:
        //   - autoplay ON  → activate next tab (wraps to 0 after last)
        //   - autoplay OFF → manually loop the current video (replay it
        //                    in place since we stripped the loop attr)
        //
        // Hover pauses the cascade — when the user mouses off, the next
        // 'ended' event resumes it. Mobile has no hover so the cascade
        // runs continuously, which matches user expectation.
        function handleVideoEnded(media) {
          // Only react if this is the CURRENT video — a paused or
          // background video's 'ended' is irrelevant.
          var targetId = tabs[currentIdx].getAttribute('data-tab-id');
          if (media.getAttribute('data-tab-target') !== targetId) return;
          // Section scrolled out → skip advance (we'll re-kick from the
          // IntersectionObserver when it scrolls back in).
          if (!sectionVisible) return;
          // NOTE: we intentionally do NOT gate on `hovered` here.
          //
          // The old interval-based cascade paused the TIMER on hover, so
          // skipping a tick was harmless — the timer resumed on
          // mouseleave. With the ended-event cascade there is no timer
          // to skip: if we don't advance when the video ends, the
          // 'ended' event will never fire again on that video, and the
          // cascade is permanently dead until the user manually clicks
          // a tab. Touch devices (iOS / Android) never fire mouseenter
          // so they always advanced — desktop was the only platform
          // affected. Removing the gate restores parity.

          if (autoplayEnabled && tabs.length > 1) {
            var next = (currentIdx + 1) % tabs.length;
            activate(next);
          } else {
            // Manual mode — just replay current via the iOS-safe helper
            playMedia(media);
          }
        }

        // attachEndDetector wires BOTH 'ended' AND a 'timeupdate' fallback
        // for iOS, which sometimes misses 'ended' on lazy-loaded videos.
        // Per-media `advanced` flag prevents the two from double-firing.
        mediaItems.forEach(function (m) {
          attachEndDetector(m);
        });

        // No-op stubs kept so tab click + keyboard handlers don't have
        // to be rewritten — the ended-event cascade replaces both the
        // interval timer AND the explicit restart. Hover handling was
        // also removed: on the old interval cascade, hover paused the
        // timer (resumed on mouseleave); on the ended-event cascade,
        // gating the advance on hover meant the cascade died
        // permanently the moment a desktop user paused over the
        // section — touch devices never fire mouseenter so they were
        // unaffected, which is exactly why iOS worked while desktop
        // broke. Cascade now runs continuously while visible.
        function startAutoplay() {}
        function stopAutoplay() {}
        function restartAutoplay() {}

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              sectionVisible = e.isIntersecting;
              if (sectionVisible) {
                resumeCurrent();
                startAutoplay();
              } else {
                mediaItems.forEach(function (m) {
                  if (m.tagName === 'VIDEO') { try { m.pause(); } catch (err) {} }
                });
                stopAutoplay();
              }
            });
          }, { threshold: 0.15 });
          io.observe(root);
        }

        // ── Resilience to interruption ───────────────────────────────
        //
        // Any of these will pause the current video without firing
        // 'ended', leaving the cascade silently dead:
        //   - User switches to another browser tab (visibilitychange)
        //   - Mobile OS backgrounds the app (visibilitychange on most
        //     platforms; pageshow on iOS coming back from bfcache)
        //   - Incoming phone call interrupts media (iOS pauses all
        //     videos; visibilitychange fires when the app backgrounds)
        //   - Notification panel briefly takes focus (Android — usually
        //     no pause, but defensive)
        //
        // resumeCurrent() decides what to do when the section becomes
        // visible AND the page is foregrounded again:
        //   • If `currentTime` is within 0.5s of `duration`, the user
        //     was offscreen when 'ended' would have fired — advance to
        //     the next tab instead of replaying the last 0.5s.
        //   • Otherwise resume from the position where playback was
        //     interrupted (opts.resume → playMedia skips currentTime=0).
        //
        // We do NOT auto-resume when only the section is offscreen
        // (handled separately by the IntersectionObserver above) or
        // only the document is hidden — both must be true.
        function resumeCurrent() {
          if (!sectionVisible) return;
          if (typeof document !== 'undefined' && document.hidden) return;
          var currentMedia = getCurrentMedia();
          if (!currentMedia || currentMedia.tagName !== 'VIDEO') return;
          var d = currentMedia.duration;
          if (d && !isNaN(d) && isFinite(d) && currentMedia.currentTime >= d - 0.5) {
            // 'ended' was missed while we were backgrounded — advance now
            handleVideoEnded(currentMedia);
          } else {
            playMedia(currentMedia, { resume: true });
          }
        }

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            // Tab/app going to background — most browsers auto-pause
            // muted videos, but be explicit so we don't accidentally
            // burn CPU on background tabs.
            mediaItems.forEach(function (m) {
              if (m.tagName === 'VIDEO') { try { m.pause(); } catch (err) {} }
            });
          } else {
            resumeCurrent();
          }
        });

        // bfcache restore (iOS back/forward nav, mobile Safari resuming
        // from app switcher). visibilitychange may not fire on bfcache
        // restore in all browsers; pageshow with `persisted=true` is the
        // reliable signal.
        window.addEventListener('pageshow', function (evt) {
          if (evt && evt.persisted) resumeCurrent();
        });

        var resizeRaf = null;
        window.addEventListener('resize', function () {
          if (resizeRaf) cancelAnimationFrame(resizeRaf);
          resizeRaf = requestAnimationFrame(function () {
            positionHighlight(currentIdx);
          });
        }, { passive: true });

        // When the user swipes the tab bar horizontally on mobile, the
        // highlight's transform stays correct (it's positioned in scroll
        // content coords) but we re-call positionHighlight on next frame
        // to be safe against sub-pixel browser rounding glitches.
        if (tabBar) {
          var scrollRaf = null;
          tabBar.addEventListener('scroll', function () {
            if (scrollRaf) cancelAnimationFrame(scrollRaf);
            scrollRaf = requestAnimationFrame(function () {
              positionHighlight(currentIdx);
            });
          }, { passive: true });
        }

        requestAnimationFrame(function () {
          activate(0);
          startAutoplay();
        });
      });
    }

    // TBT: below-fold section — defer init() until the first insights
    // instance nears the viewport rather than running its full setup
    // synchronously at DOMContentLoaded. init() is unchanged.
    function whenVisible() {
      var els = document.querySelectorAll('[data-portl-app-insights]');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { init(); return; }
      var io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) { io.disconnect(); init(); break; }
        }
      }, { rootMargin: '400px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenVisible, { once: true });
    } else {
      whenVisible();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-app-showcase"] && !Shopify.designMode) return;
  try {
    
  // iOS-safe autoplay for the in-frame app video.
  //
  // PERFORMANCE: gates initial play() behind IntersectionObserver so iOS
  // doesn't blast bandwidth downloading video data for offscreen sections
  // on page load. The section sits below the fold on most pages, so the
  // old eager play() was a measurable contributor to slow first-paint
  // video readiness on iPhone reported by the team. When scrolled out of
  // view we pause to release decoder/CPU on mobile.
  (function () {
    function init(root) {
      root = root || document;
      var videos = root.querySelectorAll('[data-portl-app-video]');
      if (!videos.length) return;
      videos.forEach(function (v) {
        if (v.dataset.portlAppInit === '1') return;
        v.dataset.portlAppInit = '1';
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        var attempt = function () {
          try {
            var p = v.play();
            if (p && typeof p.then === 'function') p.catch(function () {});
          } catch (e) {}
        };

        if ('IntersectionObserver' in window) {
          var firstHit = false;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                attempt();
                if (!firstHit) {
                  // Wire metadata/canplay retries on first viewport hit
                  // (iOS sometimes refuses the first play even when muted).
                  v.addEventListener('loadedmetadata', attempt, { once: true });
                  v.addEventListener('canplay',        attempt, { once: true });
                  firstHit = true;
                }
              } else {
                try { v.pause(); } catch (e) {}
              }
            });
          }, { threshold: 0.1, rootMargin: '200px 0px' });
          io.observe(v);
        } else {
          // Fallback for ancient browsers without IntersectionObserver
          attempt();
          v.addEventListener('loadedmetadata', attempt, { once: true });
          v.addEventListener('canplay',        attempt, { once: true });
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-b2b-hero"] && !Shopify.designMode) return;
  try {
    
  // iOS-safe autoplay for the hero video.
  (function () {
    function init(root) {
      root = root || document;
      var videos = root.querySelectorAll('[data-portl-b2b-video]');
      if (!videos.length) return;
      videos.forEach(function (v) {
        if (v.dataset.portlB2bInit === '1') return;
        v.dataset.portlB2bInit = '1';
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        var attempt = function () {
          try {
            var p = v.play();
            if (p && typeof p.then === 'function') p.catch(function () {});
          } catch (e) {}
        };
        attempt();
        v.addEventListener('loadedmetadata', attempt, { once: true });
        v.addEventListener('canplay',        attempt, { once: true });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-b2b-market"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root = root || document;
      var sections = root.querySelectorAll('[data-portl-b2b-market]');
      if (!sections.length) return;

      sections.forEach(function (section) {
        if (section.dataset.portlMarketInit === '1') return;
        section.dataset.portlMarketInit = '1';

        var track   = section.querySelector('[data-portl-b2b-market-track]');
        var prevBtn = section.querySelector('[data-portl-b2b-market-prev]');
        var nextBtn = section.querySelector('[data-portl-b2b-market-next]');
        if (!track) return;

        var stepSize = function () {
          var card = track.querySelector('[data-portl-b2b-market-slide]');
          if (!card) return 480;
          var rect = card.getBoundingClientRect();
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          return Math.round(rect.width + gap);
        };

        var updateBtns = function () {
          if (!prevBtn || !nextBtn) return;
          prevBtn.disabled = track.scrollLeft <= 4;
          nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        };

        if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
        if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left:  stepSize(), behavior: 'smooth' }); });

        track.addEventListener('scroll', function () {
          if (track._marketRaf) return;
          track._marketRaf = requestAnimationFrame(function () {
            track._marketRaf = null;
            updateBtns();
          });
        }, { passive: true });

        window.addEventListener('resize', updateBtns, { passive: true });
        updateBtns();

        // "Read more" toggle on each card
        var readMoreBtns = section.querySelectorAll('[data-portl-b2b-market-read-more]');
        readMoreBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var body = btn.parentElement.querySelector('[data-portl-b2b-market-body]');
            if (!body) return;
            var expanded = body.classList.toggle('is-expanded');
            btn.textContent = expanded ? 'Read Less' : 'Read More';
          });
        });
      });
    }

    // TBT: below-fold market section — defer init until it nears the
    // viewport rather than running its setup at DOMContentLoaded. init()
    // is unchanged. Eager fallback if IntersectionObserver is unavailable.
    function whenVisible() {
      var els = document.querySelectorAll('[data-portl-b2b-market]');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { init(document); return; }
      var io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) { io.disconnect(); init(document); break; }
        }
      }, { rootMargin: '400px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenVisible, { once: true });
    } else {
      whenVisible();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-b2b-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      var sections = (scope || document).querySelectorAll('[data-portl-b2b-testimonials]');
      if (!sections || !sections.length) return;

      sections.forEach(function (section) {
        if (section._portlTestimonialsBound) return;
        section._portlTestimonialsBound = true;

        var track   = section.querySelector('[data-portl-testimonials-track]');
        var prevBtn = section.querySelector('[data-portl-testimonials-prev]');
        var nextBtn = section.querySelector('[data-portl-testimonials-next]');
        var dotsBox = section.querySelector('[data-portl-testimonials-dots]');
        if (!track) return;

        var slides = track.querySelectorAll('[data-portl-testimonials-slide]');

        function scrollPaddingLeft() {
          var sp = parseFloat(window.getComputedStyle(track).scrollPaddingLeft);
          return isNaN(sp) ? 0 : sp;
        }

        // Build dot pagination
        if (dotsBox && slides.length) {
          dotsBox.innerHTML = '';
          slides.forEach(function (_, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'portl-b2b-testimonials__dot';
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', function () {
              var target = slides[i];
              if (!target) return;
              // Use offsetLeft relative to track + subtract scroll-padding so card
              // snaps cleanly to the visible edge after the padding.
              var left = target.offsetLeft - track.offsetLeft - scrollPaddingLeft();
              track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
            });
            dotsBox.appendChild(dot);
          });
        }

        function stepSize() {
          var first = slides[0];
          if (!first) return track.clientWidth;
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          return first.getBoundingClientRect().width + gap;
        }

        function updateState() {
          if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
          if (nextBtn) nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

          // Active dot
          if (dotsBox) {
            var dots = dotsBox.querySelectorAll('.portl-b2b-testimonials__dot');
            if (dots.length) {
              var current = Math.round(track.scrollLeft / Math.max(stepSize(), 1));
              if (current < 0) current = 0;
              if (current >= dots.length) current = dots.length - 1;
              dots.forEach(function (d, i) {
                d.classList.toggle('is-active', i === current);
              });
            }
          }
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
        if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left:  stepSize(), behavior: 'smooth' }); });

        track.addEventListener('scroll', function () {
          if (track._tstRaf) return;
          track._tstRaf = requestAnimationFrame(function () {
            track._tstRaf = null;
            updateState();
          });
        }, { passive: true });

        window.addEventListener('resize', updateState, { passive: true });
        updateState();
      });
    }

    // TBT: below-fold testimonials slider — defer init until it nears the
    // viewport instead of wiring dots/arrows/scroll/resize listeners at
    // DOMContentLoaded. init() is unchanged; only its trigger moves off the
    // critical path. Eager fallback if IntersectionObserver is unavailable.
    function whenVisible() {
      var els = document.querySelectorAll('[data-portl-b2b-testimonials]');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { init(document); return; }
      var io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) { io.disconnect(); init(document); break; }
        }
      }, { rootMargin: '400px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenVisible, { once: true });
    } else {
      whenVisible();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Mobile = below the section's 768px breakpoint. Desktop is intentionally
    // left untouched: both arrows always enabled, exactly as today.
    var mqMobile = window.matchMedia('(max-width: 767.98px)');
    var sections = document.querySelectorAll('[data-section-id]');
    sections.forEach(function (root) {
      var track = root.querySelector('[data-portl-blog-track]');
      if (!track) return;
      var prev = root.querySelector('[data-portl-blog-prev]');
      var next = root.querySelector('[data-portl-blog-next]');
      // Snap the arrows to the SAME card boundaries the native swipe uses
      // (scroll-snap-align: start). We scroll to the exact left edge of the
      // next / previous card, measured LIVE from the DOM — never a relative
      // scrollBy of "card width + a hardcoded gap". The old relative approach
      // drifted out of alignment (leaving partial cards) whenever the start
      // position wasn't already card-aligned, and fought scroll-snap-type:
      // mandatory. Absolute scrollTo an exact snap point is deterministic and
      // works across every viewport width (card width + gap are read, not
      // assumed).
      function cardEdges() {
        var cards = track.querySelectorAll('.portl-blog-card');
        var trackLeft = track.getBoundingClientRect().left;
        var base = track.scrollLeft;
        var edges = [];
        for (var i = 0; i < cards.length; i++) {
          // Each card's left edge expressed as the scrollLeft that snaps it to
          // the track's left edge.
          edges.push(Math.round(cards[i].getBoundingClientRect().left - trackLeft + base));
        }
        return edges;
      }
      function goToCard(dir) {
        var edges = cardEdges();
        if (!edges.length) return;
        var cur = track.scrollLeft;
        var TOL = 2; // sub-pixel / iOS momentum tolerance
        var target;
        if (dir > 0) {                                    // next: first edge past current
          target = null;
          for (var i = 0; i < edges.length; i++) {
            if (edges[i] > cur + TOL) { target = edges[i]; break; }
          }
          if (target === null) target = track.scrollWidth; // clamp to the end
        } else {                                          // prev: last edge before current
          target = 0;
          for (var j = edges.length - 1; j >= 0; j--) {
            if (edges[j] < cur - TOL) { target = edges[j]; break; }
          }
        }
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { goToCard(-1); });
      if (next) next.addEventListener('click', function () { goToCard(1); });

      // ── Dynamic arrow state — MOBILE ONLY ──────────────────────────────
      // Standard carousel affordance: disable the prev arrow at the start and
      // the next arrow at the end. The dimmed look + pointer-events:none come
      // from the global `.portl-arrow:disabled` rule; native `disabled` also
      // removes the button from the tab order (a11y). The `aria-disabled`
      // attribute mirrors the state. A no-op guard means the DOM is written
      // ONLY on a real state change (no redundant reflows / flicker), and the
      // scroll handler is rAF-throttled so it never thrashes layout.
      function setDisabled(btn, disabled) {
        if (!btn || btn.disabled === disabled) return;   // no-op guard
        btn.disabled = disabled;
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
      function updateArrows() {
        if (!mqMobile.matches) {                          // Desktop: unchanged
          setDisabled(prev, false);
          setDisabled(next, false);
          return;
        }
        var TOL = 2;                                      // sub-pixel / iOS momentum tolerance
        var max = track.scrollWidth - track.clientWidth;  // max scrollLeft
        if (max <= TOL) {                                 // all cards fit → nothing to scroll
          setDisabled(prev, true);
          setDisabled(next, true);
          return;
        }
        var x = track.scrollLeft;
        setDisabled(prev, x <= TOL);                      // at first card → no left
        setDisabled(next, x >= max - TOL);                // at last card → no right
      }

      var ticking = false;
      function onScroll() {                               // rAF-throttle scroll/resize
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; updateArrows(); });
      }
      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('load', updateArrows);      // re-measure after assets settle
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', updateArrows);
      else if (mqMobile.addListener) mqMobile.addListener(updateArrows); // Safari < 14
      updateArrows();                                     // initial state
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-cards-slider"] && !Shopify.designMode) return;
  try {
    
  // ──────────────────────────────────────────────────────────────
  // Cards slider — uses native scroll-snap on the track. Arrows
  // call scrollBy() with the width of one card. Disabled state
  // tracked via scroll position (start/end detection).
  // ──────────────────────────────────────────────────────────────
  (function () {
    function init(root) {
      root = root || document;
      var sliders = root.querySelectorAll('[data-portl-cards-slider]');
      if (!sliders.length) return;

      sliders.forEach(function (section) {
        if (section.dataset.portlCardsInit === '1') return;
        section.dataset.portlCardsInit = '1';

        var track   = section.querySelector('[data-portl-cards-track]');
        var prevBtn = section.querySelector('[data-portl-cards-prev]');
        var nextBtn = section.querySelector('[data-portl-cards-next]');
        if (!track) return;

        var stepSize = function () {
          var card = track.querySelector('[data-portl-cards-slide]');
          if (!card) return 360;
          var rect = card.getBoundingClientRect();
          // Card width + gap (computed style)
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          return Math.round(rect.width + gap);
        };

        var updateBtns = function () {
          if (!prevBtn || !nextBtn) return;
          var slides = track.querySelectorAll('[data-portl-cards-slide]');
          if (!slides.length) return;
          // Detect the ends by MEASURING card visibility, not scrollLeft-vs-
          // scrollWidth math. scroll-snap (proximity) + the track's right
          // padding can leave the resting scrollLeft several px short of the
          // theoretical max, so the old math never flagged "at end" and the
          // Next arrow stayed active on the last card. Rect-based detection
          // flags an end exactly when the first/last card is fully in view.
          var trackRect = track.getBoundingClientRect();
          var lastRect  = slides[slides.length - 1].getBoundingClientRect();
          var atStart = track.scrollLeft <= 1;                 /* nothing to the left */
          var atEnd   = lastRect.right <= trackRect.right + 1;  /* last card fully visible */
          prevBtn.disabled = atStart;
          nextBtn.disabled = atEnd;
          prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
          nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        };

        if (prevBtn) prevBtn.addEventListener('click', function () {
          if (prevBtn.disabled) return;   /* no navigating before the first card */
          track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
        });
        if (nextBtn) nextBtn.addEventListener('click', function () {
          if (nextBtn.disabled) return;   /* no navigating past the last card */
          track.scrollBy({ left:  stepSize(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', function () {
          // rAF-throttle scroll-driven button updates
          if (track._cardsRaf) return;
          track._cardsRaf = requestAnimationFrame(function () {
            track._cardsRaf = null;
            updateBtns();
          });
        }, { passive: true });

        window.addEventListener('resize', updateBtns, { passive: true });
        // Guarantee the carousel opens on the FIRST card so the initial arrow
        // state is deterministic (Left disabled, Right enabled) even if the
        // browser restored a prior scroll position. scrollLeft is already 0 on
        // a normal load, so this is a no-op then.
        track.scrollLeft = 0;
        updateBtns();
        requestAnimationFrame(updateBtns);   /* re-check once layout has settled */
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-carousel-feature"] && !Shopify.designMode) return;
  try {
    
  /* ──────────────────────────────────────────────────────────────
     Carousel logic — fade between slides, dots + label + arrow
     state, optional autoplay, pause on hover, iOS-safe video
     autoplay.

     Video-handling rules (matches the reference site behaviour):
       • Only the ACTIVE slide's video is played. Inactive slide
         videos are paused so we don't burn CPU/battery or trip
         iOS's "one video at a time" heuristic.
       • When a video slide becomes active, the video is rewound
         to currentTime = 0 so it always plays from the top. The
         CSS poster (image_asset → poster attr in the Liquid)
         covers the brief load delay so the slide never flashes
         empty.
       • All videos are forced muted + playsinline so iOS/Safari
         allows autoplay without a user gesture.
     ────────────────────────────────────────────────────────────── */
  (function () {
    function prepareVideo(v) {
      /* These flags MUST be set in JS too (not just attributes),
         because Safari only honors the JS-side props for the
         "muted at load" autoplay-policy exemption.

         IMPORTANT: do NOT setAttribute('preload', 'auto') here —
         the HTML template sets `preload="none"` so videos don't
         download until the IntersectionObserver fires .play() on
         the active slide. Forcing preload back to 'auto' here
         would defeat the whole optimization and re-download every
         slide's MP4 on init. */
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    }

    function playFromStart(v) {
      try {
        v.currentTime = 0;
      } catch (e) { /* some browsers throw if metadata not loaded yet */ }
      try {
        var p = v.play();
        if (p && typeof p.then === 'function') {
          p.catch(function () {
            /* If autoplay was blocked (e.g. tab in background), retry
               on next 'loadedmetadata' or user interaction. */
            v.addEventListener('loadedmetadata', function once() {
              v.removeEventListener('loadedmetadata', once);
              try { v.play().catch(function () {}); } catch (_) {}
            });
          });
        }
      } catch (e) {}
    }

    function pauseVideo(v) {
      try { v.pause(); } catch (e) {}
    }

    function init(root) {
      root = root || document;
      var carousels = root.querySelectorAll('[data-portl-carousel]');
      if (!carousels.length) return;

      carousels.forEach(function (section) {
        if (section.dataset.portlCarouselInit === '1') return;
        section.dataset.portlCarouselInit = '1';

        var slides   = section.querySelectorAll('[data-portl-carousel-slide]');
        var dots     = section.querySelectorAll('[data-portl-carousel-dot]');
        var prevBtn  = section.querySelector('[data-portl-carousel-prev]');
        var nextBtn  = section.querySelector('[data-portl-carousel-next]');
        var videos   = section.querySelectorAll('[data-portl-carousel-video]');
        var autoplay = parseInt(section.getAttribute('data-autoplay') || '0', 10);

        if (!slides.length) return;

        /* Prep every video for iOS autoplay, but don't start any
           yet — playback is driven by setActive() below. */
        videos.forEach(prepareVideo);

        var current = -1;             /* sentinel so first setActive(0) always runs */
        var count = slides.length;

        var syncVideos = function (activeIdx) {
          /* Pause every video first, then start only the one inside
             the active slide (if any). Iterating per-slide is more
             robust than relying on querySelector inside the slide
             (it correctly handles slides with no video at all). */
          slides.forEach(function (slide, i) {
            var vid = slide.querySelector('[data-portl-carousel-video]');
            if (!vid) return;
            if (i === activeIdx) {
              playFromStart(vid);
            } else {
              pauseVideo(vid);
            }
          });
        };

        var setActive = function (idx) {
          if (idx < 0) idx = 0;
          if (idx >= count) idx = count - 1;
          if (idx === current) return;
          current = idx;

          slides.forEach(function (sl, i) {
            sl.classList.toggle('is-active', i === idx);
            sl.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
          });
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
            dot.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
          if (prevBtn) {
            prevBtn.disabled = idx <= 0;
            prevBtn.classList.toggle('is-active', idx > 0);
          }
          if (nextBtn) {
            nextBtn.disabled = idx >= count - 1;
            nextBtn.classList.toggle('is-active', idx < count - 1);
          }

          syncVideos(idx);
        };

        /* PERFORMANCE: gate the initial setActive(0) (which triggers
           .play() on the first slide's video → metadata fetch + MP4
           download) behind IntersectionObserver. With this gate, the
           ~3MB MP4 of the first active slide doesn't download until
           the carousel is within 200px of the viewport.

           Visual state (dots, slide opacity) is set immediately so
           the carousel appears correct on first paint — only the
           network-heavy .play() is deferred.

           When the carousel scrolls OUT of view, pause all videos
           to save CPU/battery on mobile. */
        var setVisualState = function (idx) {
          slides.forEach(function (sl, i) {
            sl.classList.toggle('is-active', i === idx);
            sl.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
          });
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
            dot.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
          if (prevBtn) {
            prevBtn.disabled = idx <= 0;
            prevBtn.classList.toggle('is-active', idx > 0);
          }
          if (nextBtn) {
            nextBtn.disabled = idx >= count - 1;
            nextBtn.classList.toggle('is-active', idx < count - 1);
          }
        };

        if ('IntersectionObserver' in window) {
          setVisualState(0);   // paint correctly before any scroll
          var carIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                /* setActive will be a no-op for the slide state
                   (current was already 0) but syncVideos still kicks
                   off the .play() for the active slide. */
                if (current === -1) {
                  setActive(0);
                } else {
                  /* Re-entered viewport — resume active slide's video */
                  var slide = slides[current];
                  if (slide) {
                    var vid = slide.querySelector('[data-portl-carousel-video]');
                    if (vid) playFromStart(vid);
                  }
                }
              } else {
                /* Out of viewport — pause every video in this carousel */
                videos.forEach(pauseVideo);
              }
            });
          }, { threshold: 0.15, rootMargin: '200px 0px' });
          carIO.observe(section);
        } else {
          /* No IntersectionObserver — preserve original eager-play
             behavior on ancient browsers. */
          setActive(0);
        }

        /* Manual navigation */
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            stopAutoplay();
            var idx = parseInt(dot.getAttribute('data-portl-carousel-dot') || '0', 10);
            setActive(idx);
          });
        });
        if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); setActive(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); setActive(current + 1); });

        /* Keyboard support (when focus is inside the section) */
        section.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft')  { setActive(current - 1); stopAutoplay(); }
          if (e.key === 'ArrowRight') { setActive(current + 1); stopAutoplay(); }
        });

        /* Touch / swipe support — mobile users navigate by dragging
           left/right across the asset (video/image) area. Arrows are
           hidden on mobile via CSS, so this is the primary nav mode
           there. Bound to .portl-carousel__asset so a swipe inside the
           text panel doesn't accidentally change slides.

           Threshold of 40px chosen to feel responsive but not trigger
           on accidental finger jitter. Vertical-dominant gestures
           (|dy| > |dx|) are ignored so page scrolling still works
           naturally inside the section.

           Listeners are passive — we don't preventDefault — so the
           native scroll stays smooth. */
        var swipeRoot = section.querySelector('.portl-carousel__asset') || section;
        var touchStartX = 0;
        var touchStartY = 0;
        var touchActive = false;
        swipeRoot.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches.length) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchActive = true;
        }, { passive: true });
        swipeRoot.addEventListener('touchend', function (e) {
          if (!touchActive) return;
          touchActive = false;
          var t = (e.changedTouches && e.changedTouches[0]) || null;
          if (!t) return;
          var dx = t.clientX - touchStartX;
          var dy = t.clientY - touchStartY;
          if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
          stopAutoplay();
          if (dx < 0) setActive(current + 1);
          else        setActive(current - 1);
        }, { passive: true });
        swipeRoot.addEventListener('touchcancel', function () {
          touchActive = false;
        }, { passive: true });

        /* Autoplay (optional) — wraps around at the end so the
           rotation never gets stuck on the last slide. */
        var autoplayTimer = null;
        var startAutoplay = function () {
          if (!autoplay || autoplay < 1500) return;
          stopAutoplay();
          autoplayTimer = setInterval(function () {
            var nextIdx = (current + 1) % count;
            setActive(nextIdx);
          }, autoplay);
        };
        var stopAutoplay = function () {
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };
        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('mouseleave', startAutoplay);

        /* Pause autoplay + the active video when the tab is hidden,
           resume on return. Saves CPU and avoids iOS audio quirks. */
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            stopAutoplay();
            slides.forEach(function (slide) {
              var v = slide.querySelector('[data-portl-carousel-video]');
              if (v) pauseVideo(v);
            });
          } else {
            startAutoplay();
            syncVideos(current);
          }
        });

        startAutoplay();
      });
    }

    // TBT: this section is below the fold, so defer init(document) until the
    // first carousel nears the viewport instead of running its full
    // querySelectorAll + per-slide/video setup synchronously at
    // DOMContentLoaded (which fed the compiled_assets/scripts.js long task).
    // init() is unchanged; only its trigger moves off the critical path.
    function whenVisible() {
      var els = document.querySelectorAll('[data-portl-carousel]');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { init(document); return; }
      var io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) { io.disconnect(); init(document); break; }
        }
      }, { rootMargin: '400px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenVisible, { once: true });
    } else {
      whenVisible();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-comparison"] && !Shopify.designMode) return;
  try {
    
  // Click to expand/collapse a feature description
  (function () {
    function init(root) {
      root = root || document;
      var toggles = root.querySelectorAll('[data-portl-comp-toggle]');
      if (!toggles.length) return;

      toggles.forEach(function (btn) {
        if (btn.dataset.portlCompInit === '1') return;
        btn.dataset.portlCompInit = '1';

        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          var targetId = btn.getAttribute('aria-controls');
          var target = targetId ? document.getElementById(targetId) : null;
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (target) {
            if (expanded) target.setAttribute('hidden', '');
            else          target.removeAttribute('hidden');
          }
        });
      });

      // Subtle parallax on the floating bg image (desktop only)
      var bgs = root.querySelectorAll('[data-portl-comparison-bg]');
      if (bgs.length && window.matchMedia('(min-width: 1025px)').matches) {
        var rafId = null;
        var update = function () {
          rafId = null;
          bgs.forEach(function (bg) {
            var sec = bg.closest('.portl-comparison');
            if (!sec) return;
            var rect = sec.getBoundingClientRect();
            var vh = window.innerHeight || document.documentElement.clientHeight;
            // Only animate while the section is on screen
            if (rect.bottom < 0 || rect.top > vh) return;
            // -150px → 0 across the section, like the WP `data-translatey="-150"`
            var progress = 1 - Math.max(0, Math.min(1, (rect.top + rect.height) / (vh + rect.height)));
            var offset = -150 * (1 - progress);
            bg.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
          });
        };
        var onScroll = function () {
          if (rafId == null) rafId = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-experience-center"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.portlXcReady === '1') return;
      if (typeof L === 'undefined') return;     // Leaflet not loaded yet — retry

      var locations;
      try { locations = JSON.parse(root.dataset.locations || '[]'); }
      catch (e) { locations = []; }
      if (!locations.length) return;

      var mapEl = root.querySelector('[data-portl-xc-map]');
      var listEl = root.querySelector('[data-portl-xc-list]');
      var panelEl = root.querySelector('[data-portl-xc-panel]');
      var panelImg = root.querySelector('[data-portl-xc-panel-img]');
      var panelTitle = root.querySelector('[data-portl-xc-panel-title]');
      var panelAddress = root.querySelector('[data-portl-xc-panel-address]');
      var panelLink = root.querySelector('[data-portl-xc-panel-link]');
      var panelCall = root.querySelector('[data-portl-xc-panel-call]');
      var panelCallLabel = root.querySelector('[data-portl-xc-panel-call-label]');
      var panelClose = root.querySelector('[data-portl-xc-panel-close]');

      /* ── Mobile shared-element expand card refs ── */
      var expandEl       = root.querySelector('[data-portl-xc-expand]');
      var expandImg      = root.querySelector('[data-portl-xc-expand-img]');
      var expandTitle    = root.querySelector('[data-portl-xc-expand-title]');
      var expandAddress  = root.querySelector('[data-portl-xc-expand-address]');
      var expandMaps     = root.querySelector('[data-portl-xc-expand-maps]');
      var expandCall     = root.querySelector('[data-portl-xc-expand-call]');
      var expandClose    = root.querySelector('[data-portl-xc-expand-close]');
      var expandSourceCard = null;   /* card we morphed from — used for shrink */
      var expandSourceLoc  = null;
      if (!mapEl || !listEl) return;

      var map = L.map(mapEl, {
        scrollWheelZoom: false,
        zoomControl: false,
        worldCopyJump: false,
        minZoom: 4,
        maxZoom: 16,
        /* Disables the entire attribution control widget so the
           "Leaflet | © OSM © CARTO" chip never renders. NOTE:
           OSM/CARTO licenses technically require this attribution
           — keep this disabled at the merchant's own risk. */
        attributionControl: false,
      });

      L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
        maxZoom: 19,
        subdomains: 'abcd',
        /* Attribution string deliberately omitted (attributionControl
           is disabled above). If you need to re-enable it later for
           license compliance, restore both options together. */
      }).addTo(map);

      var bounds = L.latLngBounds(locations.map(function (l) { return [l.lat, l.lon]; }));
      map.fitBounds(bounds, { padding: [60, 60] });

      function makeIcon(active) {
        return L.divIcon({
          className: 'portl-xc-marker-icon',
          html:
            '<div class="portl-xc-marker' + (active ? ' is-active' : '') + '">' +
            '<span class="portl-xc-marker__halo"></span>' +
            '<span class="portl-xc-marker__ring"></span>' +
            '<span class="portl-xc-marker__core"></span>' +
            '</div>',
          iconSize: [22, 22],
          iconAnchor: [11, 11],
        });
      }

      var markers = {};
      var cards = {};
      var activeId = null;

      function openPanel(loc) {
        /* Mobile uses the FAQ-style inline accordion built into each
           card; the side panel is `display: none` there. Skip the
           panel DOM work entirely on mobile to keep the interaction
           snappy and avoid muting an invisible element. */
        if (window.matchMedia('(max-width: 899px)').matches) return;
        if (panelImg) {
          panelImg.src = loc.image || '';
          panelImg.alt = loc.title || '';
          panelImg.style.display = loc.image ? '' : 'none';
        }
        if (panelTitle) panelTitle.textContent = loc.title || '';
        if (panelAddress) panelAddress.innerHTML = (loc.address || []).join('<br>');
        if (panelLink) panelLink.href = loc.mapUrl || '#';

        /* Call button — show only when this location has a phone number
           AND the per-location toggle is on. Build tel: link by stripping
           spaces, dashes, parens (keep leading +). */
        if (panelCall) {
          var phone = (loc.phone || '').trim();
          var showCall = loc.showCall !== false && phone.length > 0;
          if (showCall) {
            var telClean = phone.replace(/[^\d+]/g, '');
            panelCall.href = 'tel:' + telClean;
            panelCall.setAttribute('aria-label', 'Call ' + (loc.title || '') + ' on ' + phone);
            panelCall.removeAttribute('hidden');
          } else {
            panelCall.setAttribute('hidden', '');
            panelCall.removeAttribute('href');
          }
        }

        if (panelEl) {
          panelEl.classList.add('is-open');
          panelEl.setAttribute('aria-hidden', 'false');
        }
        /* Mobile bottom-sheet — add section class so CSS fades out
           the list + map and shows the scrim. Also lock body scroll
           so the page underneath can't scroll behind the open sheet.
           Both no-ops on desktop because the related CSS is wrapped
           in @media (max-width: 899px). */
        if (root) root.classList.add('portl-xc--panel-open');
        lockBodyScroll(true);
      }

      function closePanel() {
        if (panelEl) {
          panelEl.classList.remove('is-open');
          panelEl.setAttribute('aria-hidden', 'true');
        }
        if (activeId && markers[activeId]) {
          markers[activeId].setIcon(makeIcon(false));
          if (cards[activeId]) {
            cards[activeId].classList.remove('is-active');
            var hdr = cards[activeId].querySelector('.portl-xc__card-header');
            if (hdr) hdr.setAttribute('aria-expanded', 'false');
          }
        }
        activeId = null;
        /* Reverse mobile state — section class drops. Body scroll
           unlock only matters if we actually locked it (mobile only). */
        if (root) root.classList.remove('portl-xc--panel-open');
        lockBodyScroll(false);
      }

      /* Body scroll lock — used while the mobile bottom-sheet is open.
         Stores scroll Y on lock and restores it on unlock so the user
         doesn't jump to the top when the sheet closes. Only active on
         mobile viewports (≤899px) — desktop scroll is never locked
         since the panel is in-flow there. */
      var savedScrollY = 0;
      function lockBodyScroll(lock) {
        var mobile = window.matchMedia('(max-width: 899px)').matches;
        if (!mobile) return;
        var body = document.body;
        if (lock) {
          savedScrollY = window.scrollY || window.pageYOffset || 0;
          body.style.position = 'fixed';
          body.style.top = '-' + savedScrollY + 'px';
          body.style.left = '0';
          body.style.right = '0';
          body.style.width = '100%';
          body.classList.add('portl-xc-panel-lock');
        } else {
          body.classList.remove('portl-xc-panel-lock');
          body.style.position = '';
          body.style.top = '';
          body.style.left = '';
          body.style.right = '';
          body.style.width = '';
          window.scrollTo(0, savedScrollY);
        }
      }

      function focusLocation(id) {
        var loc = locations.find(function (l) { return l.id === id; });
        if (!loc) return;
        if (activeId && markers[activeId]) {
          markers[activeId].setIcon(makeIcon(false));
          if (cards[activeId]) cards[activeId].classList.remove('is-active');
        }
        activeId = id;
        if (markers[id]) markers[id].setIcon(makeIcon(true));
        if (cards[id]) {
          cards[id].classList.add('is-active');
          var hdr = cards[id].querySelector('.portl-xc__card-header');
          if (hdr) hdr.setAttribute('aria-expanded', 'true');
        }
        /* On mobile we don't auto-pan the map (it's hidden behind the
           accordion anyway, and panning behind a hidden element wastes
           CPU). Desktop still flies to the location. */
        if (!window.matchMedia('(max-width: 899px)').matches) {
          map.flyTo([loc.lat, loc.lon], 14, { duration: 0.6 });
        }
        // Apply this location's per-block panel + button overrides BEFORE
        // openPanel(), so the panel paints with the right colors on its
        // first frame (avoids a flash of section-default colors).
        applyPanelOverrides(loc);
        openPanel(loc);
      }

      if (panelClose) panelClose.addEventListener('click', closePanel);

      /* Tap the scrim (the dimmed area behind the sheet) to dismiss
         on mobile — standard bottom-sheet UX. The scrim is the
         section's `::before` pseudo, so we attach the listener to
         the section root and gate on (1) mobile viewport AND
         (2) the section is in `portl-xc--panel-open` state AND
         (3) the click landed on the section root itself, NOT a
         descendant (panel, list, map). */
      if (root) {
        root.addEventListener('click', function (e) {
          if (e.target !== root) return;
          if (!root.classList.contains('portl-xc--panel-open')) return;
          if (!window.matchMedia('(max-width: 899px)').matches) return;
          closePanel();
        });
      }

      /* ESC key closes the sheet — keyboard / a11y nicety, also useful
         when testing on desktop emulators */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!root || !root.classList.contains('portl-xc--panel-open')) return;
        closePanel();
      });

      /* Per-location override system.
         Cards and the slide-in panel both consume CSS vars defined at the
         section root (--xc-card-* / --xc-panel-* / --xc-btn-*). Setting the
         same vars on a child element shadows the section value for that
         element's subtree. Per-location overrides work by writing those
         vars to the card element (always-on per card) or the panel element
         (re-written on each focusLocation, so the panel reflects whichever
         location is currently selected).

         Sentinels for "no override / inherit section default":
           • Colors → '' (empty) OR any transparent representation
           • Sizes  → 0 (sliders use min:0 = inherit; non-zero = override)
           • Weights → '' (select "Inherit" option emits empty string)
         Padding/radius always emit (defaults match design baseline). */
      var TRANSPARENT = ['', '#00000000', 'rgba(0,0,0,0)', 'rgba(0, 0, 0, 0)'];
      function isOverridableColor(v) {
        return v && TRANSPARENT.indexOf(v) === -1;
      }
      function setColorVar(el, prop, value) {
        if (isOverridableColor(value)) el.style.setProperty(prop, value);
        else el.style.removeProperty(prop);
      }
      function setPxVar(el, prop, value) {
        // 0 means "inherit" for sizes; for padding/radius pass 0 explicitly
        // via setPxVarAlways instead.
        if (value && Number(value) > 0) el.style.setProperty(prop, value + 'px');
        else el.style.removeProperty(prop);
      }
      function setPxVarAlways(el, prop, value) {
        // Always emit — used for card padding/radius where 0 is legitimate.
        el.style.setProperty(prop, (value || 0) + 'px');
      }
      function setWeightVar(el, prop, value) {
        if (value) el.style.setProperty(prop, value);
        else el.style.removeProperty(prop);
      }

      /* ── Mobile shared-element morph ──────────────────────────
         Pattern based on the user's reference sample (App Store
         style card expansion):
           1. Read source card's bounding rect via getBoundingClientRect
           2. Populate expand element with source data (image, text, links)
           3. Set CSS vars so the expand element starts AT the card's
              position+size (via CSS transforms)
           4. On next paint tick, switch data-state to "expanded" — CSS
              transitions the transforms/clip-path to fullscreen
           5. Close: switch to "shrink" — transforms reverse back to
              the source card's position, then "hidden" hides it.
         All math is in CSS (uses var() arithmetic); JS just feeds
         the numbers.
      ──────────────────────────────────────────────────────────── */
      function updateExpandRect(card) {
        if (!expandEl || !card) return;
        var rect = card.getBoundingClientRect();
        expandEl.style.setProperty('--xc-ex-top',    rect.top    + 'px');
        expandEl.style.setProperty('--xc-ex-left',   rect.left   + 'px');
        expandEl.style.setProperty('--xc-ex-width',  rect.width);
        expandEl.style.setProperty('--xc-ex-height', rect.height);
        expandEl.style.setProperty('--xc-ex-sw', window.innerWidth);
        expandEl.style.setProperty('--xc-ex-sh', window.innerHeight);
      }

      function openExpand(sourceCard, loc) {
        if (!expandEl) return;
        expandSourceCard = sourceCard;
        expandSourceLoc  = loc;

        /* Populate content */
        if (expandImg) {
          expandImg.src = loc.image || '';
          expandImg.alt = loc.title || '';
          expandImg.style.display = loc.image ? '' : 'none';
        }
        if (expandTitle)   expandTitle.textContent = loc.title || '';
        if (expandAddress) expandAddress.innerHTML = (loc.address || []).join('<br>');
        if (expandMaps)    expandMaps.href = loc.mapUrl || '#';

        if (expandCall) {
          var phone = (loc.phone || '').trim();
          var showCall = loc.showCall !== false && phone.length > 0;
          if (showCall) {
            var telClean = phone.replace(/[^\d+]/g, '');
            expandCall.href = 'tel:' + telClean;
            expandCall.setAttribute('aria-label', 'Call ' + (loc.title || '') + ' on ' + phone);
            expandCall.removeAttribute('hidden');
          } else {
            expandCall.setAttribute('hidden', '');
            expandCall.removeAttribute('href');
          }
        }

        /* Apply per-location overrides (button colors etc.) so the
           expand panel matches the brand colors set for this city. */
        if (typeof applyExpandOverrides === 'function') {
          applyExpandOverrides(loc);
        }

        /* Capture starting rect + screen size for the CSS morph */
        updateExpandRect(sourceCard);
        expandEl.setAttribute('aria-hidden', 'false');

        /* Need a paint tick between setting initial vars and switching
           state, so CSS sees the "hidden" state with the vars applied
           BEFORE transitioning to "expanded". */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            expandEl.dataset.state = 'expanded';
          });
        });

        /* Lock body scroll while overlay is open */
        document.body.classList.add('portl-xc-expand-lock');
      }

      function closeExpand() {
        if (!expandEl || expandEl.dataset.state === 'hidden') return;
        if (expandSourceCard) updateExpandRect(expandSourceCard);
        expandEl.dataset.state = 'shrink';
        setTimeout(function () {
          expandEl.dataset.state = 'hidden';
          expandEl.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('portl-xc-expand-lock');
          expandSourceCard = null;
          expandSourceLoc  = null;
        }, 320);  /* matches the CSS transition duration */
      }

      /* Per-location overrides for the expand overlay buttons —
         mirrors applyPanelOverrides but targets the mobile expand
         element so each city's Maps/Call colors carry over. */
      function applyExpandOverrides(loc) {
        if (!expandEl) return;
        setColorVar(expandEl, '--xc-btn-bg',         loc.buttonBg);
        setColorVar(expandEl, '--xc-btn-text',       loc.buttonText);
        setColorVar(expandEl, '--xc-btn-hover-bg',   loc.buttonHoverBg);
        setColorVar(expandEl, '--xc-call-bg',        loc.callBg);
        setColorVar(expandEl, '--xc-call-text',      loc.callText);
        setColorVar(expandEl, '--xc-call-border',    loc.callBorder);
        setColorVar(expandEl, '--xc-call-hover-bg',  loc.callHoverBg);
        setColorVar(expandEl, '--xc-call-hover-text',loc.callHoverText);
        setColorVar(expandEl, '--xc-call-icon-color',loc.callIcon);
      }

      if (expandClose) expandClose.addEventListener('click', closeExpand);

      /* ESC closes the expand overlay */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (expandEl && expandEl.dataset.state !== 'hidden') closeExpand();
      });

      /* Re-measure on resize/orientation — if user rotates phone
         while the expand is in the shrink state, we want the math
         to use the new card rect. */
      window.addEventListener('resize', function () {
        if (expandEl && expandEl.dataset.state !== 'hidden' && expandSourceCard) {
          updateExpandRect(expandSourceCard);
        }
      });

      function applyCardOverrides(card, loc) {
        // Colors
        setColorVar(card, '--xc-card-bg',          loc.cardBg);
        setColorVar(card, '--xc-card-border',      loc.cardBorder);
        setColorVar(card, '--xc-card-title-color', loc.cardTitle);
        setColorVar(card, '--xc-card-text-color',  loc.cardText);
        // Typography (size sliders — 0 = inherit; weights — empty = inherit)
        setPxVar(card,     '--xc-card-title-d',      loc.cardTitleSizeD);
        setPxVar(card,     '--xc-card-title-m',      loc.cardTitleSizeM);
        setWeightVar(card, '--xc-card-title-weight', loc.cardTitleWeight);
        setPxVar(card,     '--xc-card-text-d',       loc.cardTextSizeD);
        setPxVar(card,     '--xc-card-text-m',       loc.cardTextSizeM);
        setWeightVar(card, '--xc-card-text-weight',  loc.cardTextWeight);
        // Spacing & shape — emitted as CSS VARIABLES so the desktop
        // rule consumes them and the mobile accordion rule can ignore
        // them. (Previously these were inline `padding: …px` which
        // beat the mobile flat-card CSS via inline-style specificity
        // and boxed the image/buttons inward.)
        setPxVarAlways(card, '--xc-card-radius', loc.cardRadius);
        card.style.setProperty('--xc-card-pad-t', (loc.cardPadT || 0) + 'px');
        card.style.setProperty('--xc-card-pad-r', (loc.cardPadR || 0) + 'px');
        card.style.setProperty('--xc-card-pad-b', (loc.cardPadB || 0) + 'px');
        card.style.setProperty('--xc-card-pad-l', (loc.cardPadL || 0) + 'px');
        card.style.setProperty('border-radius', (loc.cardRadius || 0) + 'px');
      }

      function applyPanelOverrides(loc) {
        if (!panelEl) return;
        // Panel colors + typography
        setColorVar(panelEl, '--xc-panel-bg',          loc.panelBg);
        setColorVar(panelEl, '--xc-panel-overlay',     loc.panelOverlay);
        setColorVar(panelEl, '--xc-panel-title-color', loc.panelTitle);
        setColorVar(panelEl, '--xc-panel-text-color',  loc.panelText);
        setPxVar(panelEl,     '--xc-panel-title-d',      loc.panelTitleSizeD);
        setPxVar(panelEl,     '--xc-panel-title-m',      loc.panelTitleSizeM);
        setPxVar(panelEl,     '--xc-panel-text-d',       loc.panelTextSizeD);
        setPxVar(panelEl,     '--xc-panel-text-m',       loc.panelTextSizeM);
        setWeightVar(panelEl, '--xc-panel-title-weight', loc.panelTitleWeight);
        setWeightVar(panelEl, '--xc-panel-text-weight',  loc.panelTextWeight);
        // Button colors — Maps
        setColorVar(panelEl, '--xc-btn-bg',       loc.buttonBg);
        setColorVar(panelEl, '--xc-btn-text',     loc.buttonText);
        setColorVar(panelEl, '--xc-btn-hover-bg', loc.buttonHoverBg);
        // Button colors — Call (per-location overrides win over section defaults)
        setColorVar(panelEl, '--xc-call-bg',         loc.callBg);
        setColorVar(panelEl, '--xc-call-text',       loc.callText);
        setColorVar(panelEl, '--xc-call-border',     loc.callBorder);
        setColorVar(panelEl, '--xc-call-hover-bg',   loc.callHoverBg);
        setColorVar(panelEl, '--xc-call-hover-text', loc.callHoverText);
        setColorVar(panelEl, '--xc-call-icon-color', loc.callIcon);
      }

      locations.forEach(function (loc) {
        var marker = L.marker([loc.lat, loc.lon], { icon: makeIcon(false) }).addTo(map);
        marker.on('click', function () { focusLocation(loc.id); });
        markers[loc.id] = marker;

        /* Card structure (now an FAQ-style accordion on mobile, click-
           trigger on desktop):
             <article.portl-xc__card>
               <button.portl-xc__card-header>  ← always-visible row
                 <pin>H</pin>
                 <h3>Hyderabad</h3>
                 <p>address...</p>
                 <chevron svg/>
               </button>
               <div.portl-xc__card-details>    ← mobile-only accordion
                 <img loading="lazy" decoding="async"/>
                 <a Maps/>
                 <a Call/>
                 <button close/>
               </div>
             </article>
           Card root is a <article> (not <button>) so the nested action
           buttons inside details don't violate HTML "no interactive
           inside button" rule. */
        var card = document.createElement('article');
        card.className = 'portl-xc__card';
        card.setAttribute('role', 'listitem');
        var firstChar = (loc.title || '?').charAt(0).toUpperCase();
        var addressHtml = (loc.address || []).join('<br>');

        /* Header — the always-visible toggle row */
        var header = document.createElement('button');
        header.type = 'button';
        header.className = 'portl-xc__card-header';
        header.setAttribute('aria-expanded', 'false');
        header.setAttribute('aria-label', loc.title + ', ' + (loc.address || []).join(', '));
        header.innerHTML =
          '<span class="portl-xc__pin" aria-hidden="true"></span>' +
          '<span class="portl-xc__card-text"><h3></h3><p></p></span>' +
          '<span class="portl-xc__card-chevron" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<polyline points="6 9 12 15 18 9"/>' +
            '</svg>' +
          '</span>';
        header.querySelector('.portl-xc__pin').textContent = firstChar;
        header.querySelector('h3').textContent = loc.title || '';
        header.querySelector('p').innerHTML = addressHtml;

        /* Details — collapsed by default on mobile, hidden entirely on
           desktop (CSS). Contains: image, Maps button, Call button
           (if phone provided), and a close X (mobile only). */
        var details = document.createElement('div');
        details.className = 'portl-xc__card-details';

        /* FAQ-answer body — ONLY image + buttons.
           Title + address live in the always-visible header above,
           so we don't duplicate them here. Wrapped in
           `.portl-xc__card-details-inner` (single grid child) so the
           `grid-template-rows: 0fr → 1fr` accordion animation works.
           Close X sits OUTSIDE this wrapper (positioned absolutely on
           the card root) so it stays visible during the height animation. */
        var titleSafe   = (loc.title || '').replace(/"/g, '&quot;');
        var detailsHtml = '<div class="portl-xc__card-details-inner">';
        if (loc.image) {
          detailsHtml +=
            '<div class="portl-xc__card-image">' +
              '<img src="' + loc.image.replace(/"/g, '&quot;') + '" alt="' +
              titleSafe + '" loading="lazy"/>' +
            '</div>';
        }
        detailsHtml += '<div class="portl-xc__card-actions">';
        detailsHtml +=
          '<a class="portl-xc__panel-link" href="' +
          (loc.mapUrl || '#').replace(/"/g, '&quot;') +
          '" target="_blank" rel="noopener">View on Google Maps &rarr;</a>';
        /* Call link only if phone present */
        var phone = (loc.phone || '').trim();
        var showCall = loc.showCall !== false && phone.length > 0;
        if (showCall) {
          var telClean = phone.replace(/[^\d+]/g, '');
          detailsHtml +=
            '<a class="portl-xc__panel-call" href="tel:' + telClean +
            '" aria-label="Call ' + titleSafe +
            '"><span class="portl-xc__panel-call-icon" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>' +
              '</svg></span>' +
              '<span class="portl-xc__panel-call-label">Call</span></a>';
        }
        detailsHtml += '</div>';
        detailsHtml += '</div>'; /* close .portl-xc__card-details-inner */

        /* Close X — sits at top-right of the card (positioned absolutely
           against `.portl-xc__card`, NOT inside the accordion inner wrap),
           so it stays clickable + correctly placed during the open animation.
           Mobile-only — hidden on desktop via CSS. */
        details.innerHTML = detailsHtml;
        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'portl-xc__card-close';
        closeBtn.setAttribute('aria-label', 'Collapse details');
        closeBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<line x1="6" y1="6" x2="18" y2="18"/>' +
            '<line x1="6" y1="18" x2="18" y2="6"/>' +
          '</svg>';

        card.appendChild(header);
        card.appendChild(details);
        card.appendChild(closeBtn);

        /* Click handler — viewport-aware:
             • Mobile (≤899px): simple FAQ accordion. Toggle .is-active
               on this card; close any sibling that's already open
               (single-open accordion). Pattern matches the user's
               sample (class toggle → CSS animates the height).
             • Desktop: existing behavior — focus marker + open the
               side panel on the map. */
        function handleCardClick() {
          var isMobile = window.matchMedia('(max-width: 899px)').matches;
          if (isMobile) {
            var wasOpen = card.classList.contains('is-active');
            /* Close every other card first (single-open accordion) */
            if (listEl) {
              listEl.querySelectorAll('.portl-xc__card.is-active').forEach(function (c) {
                c.classList.remove('is-active');
                var h = c.querySelector('.portl-xc__card-header');
                if (h) h.setAttribute('aria-expanded', 'false');
              });
            }
            /* If this card wasn't open before, open it now. Else stays closed. */
            if (!wasOpen) {
              card.classList.add('is-active');
              header.setAttribute('aria-expanded', 'true');
            } else {
              header.setAttribute('aria-expanded', 'false');
            }
          } else {
            focusLocation(loc.id);
          }
        }
        header.addEventListener('click', handleCardClick);
        /* Card-internal close X — closes this card's accordion on mobile,
           or the desktop side panel via closePanel(). */
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var isMobile = window.matchMedia('(max-width: 899px)').matches;
          if (isMobile) {
            card.classList.remove('is-active');
            header.setAttribute('aria-expanded', 'false');
          } else {
            closePanel();
          }
        });

        applyCardOverrides(card, loc);

        listEl.appendChild(card);
        cards[loc.id] = card;
      });

      root.dataset.portlXcReady = '1';

      // Some browsers compute the map container size before layout settles
      // (especially inside grids/flex). Force a recalc once visible.
      setTimeout(function () { map.invalidateSize(); }, 200);
    }

    function initAll() {
      document.querySelectorAll('[data-portl-xc]').forEach(init);
    }

    function whenLeafletReady(cb) {
      if (typeof L !== 'undefined') { cb(); return; }
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (typeof L !== 'undefined') { clearInterval(iv); cb(); }
        else if (tries > 80) clearInterval(iv);   // ~16s ceiling
      }, 200);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        whenLeafletReady(initAll);
      }, { once: true });
    } else {
      whenLeafletReady(initAll);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-portl-xc]')) {
        whenLeafletReady(function () {
          e.target.querySelectorAll('[data-portl-xc]').forEach(function (root) {
            root.dataset.portlXcReady = '';
            init(root);
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-explore-hero"] && !Shopify.designMode) return;
  try {
    
  // Fallback: retry .play() on first user gesture if Mobile Safari blocks autoplay
  (function () {
    var videos = document.querySelectorAll('[data-portl-eh-video]');
    if (!videos.length) return;
    videos.forEach(function (v) {
      v.muted = true;
      var attempt = v.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          var retry = function () {
            videos.forEach(function (vv) { vv.play().catch(function () {}); });
            ['touchstart', 'click', 'scroll'].forEach(function (ev) {
              window.removeEventListener(ev, retry);
            });
          };
          ['touchstart', 'click', 'scroll'].forEach(function (ev) {
            window.addEventListener(ev, retry, { once: true, passive: true });
          });
        });
      }
    });
  })();

  // ─── End-of-video Buy Now card ─────────────────────────────────
  // Shows a black overlay card with "Buy Now" CTA the moment the hero
  // video ends. Per section — supports multiple explore-hero instances
  // on the same page (one for mobile video, one for desktop video; only
  // the visible one ends due to display:none on the other).
  (function () {
    document.querySelectorAll('[data-section-id]').forEach(function (section) {
      var endcard = section.querySelector('[data-portl-eh-endcard]');
      if (!endcard) return;

      var videos = section.querySelectorAll('[data-portl-eh-video]');
      if (!videos.length) return;

      var replay = section.querySelector('[data-portl-eh-endcard-replay]');

      function showCard() {
        endcard.classList.add('is-visible');
        endcard.setAttribute('aria-hidden', 'false');
      }
      function hideCard() {
        endcard.classList.remove('is-visible');
        endcard.setAttribute('aria-hidden', 'true');
      }

      videos.forEach(function (v) {
        v.addEventListener('ended', showCard);
      });

      if (replay) {
        replay.addEventListener('click', function () {
          hideCard();
          videos.forEach(function (v) {
            // Only restart the video the breakpoint actually shows
            if (v.offsetParent !== null) {
              try { v.currentTime = 0; } catch (e) {}
              v.play().catch(function () {});
            }
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  // ──────────────────────────────────────────────────────────────
  // FAQ tabs + nested accordion
  //   • Click tab → swap visible panel
  //   • Click question title → toggle answer
  //   • Multiple answers can be open within a tab
  // ──────────────────────────────────────────────────────────────
  (function () {
    function init(root) {
      root = root || document;
      var sections = root.querySelectorAll('[data-portl-faq-tabs]');
      if (!sections.length) return;

      sections.forEach(function (section) {
        if (section.dataset.portlFaqInit === '1') return;
        section.dataset.portlFaqInit = '1';

        var tabs   = section.querySelectorAll('[data-portl-faq-tab]');
        var panels = section.querySelectorAll('[data-portl-faq-panel]');

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var idx = parseInt(tab.getAttribute('data-portl-faq-tab') || '0', 10);
            tabs.forEach(function (t, i) {
              t.classList.toggle('is-current', i === idx);
              t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
            });
            panels.forEach(function (p, i) {
              p.classList.toggle('is-active', i === idx);
              p.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
            });
          });
        });

        var toggles = section.querySelectorAll('[data-portl-faq-toggle]');
        toggles.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var expanded = btn.getAttribute('aria-expanded') === 'true';
            var targetId = btn.getAttribute('aria-controls');
            var target = targetId ? document.getElementById(targetId) : null;
            btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            if (target) {
              if (expanded) target.setAttribute('hidden', '');
              else          target.removeAttribute('hidden');
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-featured-media"] && !Shopify.designMode) return;
  try {
    
  /* Auto-scroll marquee — duplicate the press-quote cards once so the
     CSS animation loops seamlessly. Clones are aria-hidden + removed
     from the tab order so assistive tech / keyboard users only see the
     originals. Only runs when the admin enabled auto-scroll. */
  (function () {
    function setup(pq) {
      if (!pq || pq.dataset.pfmPqReady === '1') return;
      var track = pq.querySelector('.portl-featured-media__pq-track');
      if (!track) return;
      var children = Array.prototype.slice.call(track.children);
      if (children.length === 0) return;
      children.forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        track.appendChild(clone);
      });
      pq.dataset.pfmPqReady = '1';
    }
    function bootAll() {
      document.querySelectorAll('.portl-featured-media__pq--autoscroll').forEach(setup);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll, { once: true });
    } else {
      bootAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target && e.target.querySelector ? e.target.querySelector('.portl-featured-media__pq--autoscroll') : null;
      if (s) setup(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-footer"] && !Shopify.designMode) return;
  try {
    
  /* ── Footer newsletter — scroll restoration after submit ─────────────
     The newsletter is the standard Shopify {% form 'customer' %} and submits
     NATIVELY (full-page POST) — required because the store's hCaptcha bot
     protection needs the native form flow to stay invisible. (AJAX-submitting
     omits the captcha token, so Shopify serves the /challenge page with a stray
     "Submit" button.) After the post, Shopify reloads and server-renders the
     result message in the footer; the browser lands at the top, so we bring that
     message into view INSTANTLY (no animated jump) and focus it. No-op on a
     normal page load — the message only exists right after a submit. */
  (function () {
    var posted = document.querySelector('.portl-footer__newsletter-form [data-portl-form-posted]');
    if (!posted) return;
    requestAnimationFrame(function () {
      try { posted.scrollIntoView({ behavior: 'auto', block: 'center' }); }
      catch (e) { try { posted.scrollIntoView(); } catch (e2) {} }
      try { posted.focus({ preventScroll: true }); } catch (e) {}
    });
  })();

  /* ── Double-submit guard ─────────────────────────────────────────────
     QA clicking Subscribe rapidly fires one native POST per click. The
     burst trips Shopify's bot protection → the hCaptcha /challenge page.
     On the FIRST valid submit we lock the form: a synchronous flag blocks
     every re-entrant submit event immediately, and the button is disabled
     + shown busy. Disabling is DEFERRED to a 0ms timeout so it happens
     AFTER this submission starts — disabling synchronously can cancel the
     in-flight native POST in some browsers. The submit event only fires
     once native validation (required + type="email") passes, so a valid
     email is guaranteed here. Safety net re-enables after 8s if navigation
     never happens (stalled network), so the user is never stuck. */
  (function () {
    var form = document.querySelector('.portl-footer__newsletter-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (form.__portlNlSubmitting) { e.preventDefault(); return; }   // ignore extra clicks
      form.__portlNlSubmitting = true;
      var btn = form.querySelector('[type="submit"]');
      setTimeout(function () {
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        form.classList.add('is-submitting');
      }, 0);
      setTimeout(function () {
        form.__portlNlSubmitting = false;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        form.classList.remove('is-submitting');
      }, 8000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-gallery-swiper"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-id]').forEach(function (root) {
      var track = root.querySelector('[data-portl-gs-track]');
      if (!track) return;
      var prev = root.querySelector('[data-portl-gs-prev]');
      var next = root.querySelector('[data-portl-gs-next]');
      var step = function () {
        var slide = track.querySelector('.portl-gs-slide');
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return slide ? slide.getBoundingClientRect().width + gap : 600;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SHOP_OPEN_ATTR = 'data-shop-open';
    // Open is instant on hover (no delay). Close has a small grace
    // window so quick re-entries (crossing the hover-bridge into the
    // panel) don't cause flicker.
    var HOVER_CLOSE_DELAY = 200;

    function initShop(nav) {
      if (!nav || nav.dataset.portlShopInit === '1') return;
      var trigger  = nav.querySelector('[data-portl-shop-toggle]');
      var panel    = nav.querySelector('[data-portl-shop-panel]');
      var backdrop = nav.querySelector('[data-portl-shop-backdrop]');
      if (!trigger || !panel) return;
      nav.dataset.portlShopInit = '1';

      var isTouchOnly = window.matchMedia('(hover: none)').matches;
      var closeTimer = null;
      var triggerLi = trigger.closest('.portl-nav__shop-li') || trigger;

      function open() {
        clearTimeout(closeTimer);
        closeTimer = null;
        if (nav.getAttribute(SHOP_OPEN_ATTR) === 'true') return;
        nav.setAttribute(SHOP_OPEN_ATTR, 'true');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }
      function close() {
        clearTimeout(closeTimer);
        closeTimer = null;
        if (nav.getAttribute(SHOP_OPEN_ATTR) !== 'true') return;
        nav.removeAttribute(SHOP_OPEN_ATTR);
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      }
      function toggle() {
        if (nav.getAttribute(SHOP_OPEN_ATTR) === 'true') close();
        else open();
      }

      // ── Click / tap on trigger ─────────────────────────────
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        toggle();
      });

      // ── Hover via bubbling mouseover/mouseout ──────────────
      // Two zones, intentionally different:
      //
      //   OPEN zone   = ONLY the actual trigger button (`trigger`).
      //                 Used by mouseover to decide whether to open.
      //                 Excludes the stretched-to-nav-height <li>
      //                 padding and the 60px ::after hover-bridge so
      //                 the menu can't pop open from idle cursor
      //                 hovering BELOW the button (which was firing
      //                 during scroll past the Shop column).
      //
      //   KEEP-OPEN zone = trigger + <li> bridge + panel. Used by
      //                    mouseout to decide whether to close. The
      //                    bridge is included here so the cursor
      //                    can travel from the button down through
      //                    the gap into the panel without the menu
      //                    closing mid-traverse.
      //
      // Asymmetric zones = strict open trigger + generous keep-open
      // bridge → no accidental opens, no flicker on intentional use.
      if (!isTouchOnly) {
        // Helper — checks whether an element is anywhere inside our
        // "keep open" surface (trigger LI including bridge OR panel).
        var inKeepOpenZone = function (el) {
          if (!el) return false;
          return triggerLi.contains(el) || panel.contains(el);
        };
        var isOpen = function () {
          return nav.getAttribute(SHOP_OPEN_ATTR) === 'true';
        };
        // Helper — start the close countdown unless cursor is going
        // somewhere that should keep the menu open.
        var scheduleCloseIfLeaving = function (relatedTarget) {
          if (inKeepOpenZone(relatedTarget)) return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(close, HOVER_CLOSE_DELAY);
        };

        // ─── OPEN — mouseenter on trigger button only ─────────────
        // mouseenter fires once when the cursor enters the trigger
        // (does NOT bubble like mouseover). Open only from the actual
        // Shop button — not from the stretched LI or bridge area, so
        // idle hovers below the button (during page scroll) can't
        // accidentally open the menu.
        trigger.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          closeTimer = null;
          open();
        });

        // ─── KEEP OPEN — panel mouseenter cancels any pending close.
        // CRITICAL for the trigger → panel traversal: if the cursor
        // moves fast and the mouseleave-from-trigger relatedTarget
        // briefly resolves to <body> or nav (between bridge and
        // panel edge), a close timer might get scheduled. This
        // listener cancels that timer the moment the cursor lands on
        // the panel — so the menu STAYS open while the user picks an
        // item, even if the in-between bridge missed the cursor.
        panel.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          closeTimer = null;
        });

        // ─── KEEP OPEN — re-entering the trigger LI (button or bridge)
        // also cancels any pending close.
        triggerLi.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          closeTimer = null;
        });

        // ─── CLOSE — mouseleave fires once when cursor truly leaves
        // each element. relatedTarget = where cursor is going. We
        // schedule the close timer only when relatedTarget is OUTSIDE
        // both the trigger LI (bridge included) AND the panel.
        triggerLi.addEventListener('mouseleave', function (e) {
          if (!isOpen()) return;
          scheduleCloseIfLeaving(e.relatedTarget);
        });
        panel.addEventListener('mouseleave', function (e) {
          if (!isOpen()) return;
          scheduleCloseIfLeaving(e.relatedTarget);
        });

        // ─── CLOSE — cursor leaves the whole document.
        // relatedTarget is null when the cursor leaves the window.
        document.addEventListener('mouseleave', function () {
          if (!isOpen()) return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(close, HOVER_CLOSE_DELAY);
        });
      }

      // ── Click outside → close ──────────────────────────────
      document.addEventListener('click', function (e) {
        if (nav.getAttribute(SHOP_OPEN_ATTR) !== 'true') return;
        if (panel.contains(e.target)) return;
        if (trigger.contains(e.target)) return;
        close();
      });

      // ── Click on backdrop → close ──────────────────────────
      if (backdrop) {
        backdrop.addEventListener('click', close);
      }

      // ── ESC closes + restores focus to trigger ─────────────
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (nav.getAttribute(SHOP_OPEN_ATTR) !== 'true') return;
        close();
        trigger.focus();
      });

      // ── Resize: close if crossing the mobile breakpoint ────
      // Avoids stuck-open state when user rotates / resizes from
      // desktop into mobile drawer territory.
      var mq = window.matchMedia('(max-width: 767.98px)');
      var onChange = function () { if (mq.matches) close(); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);

      // ── Close when a card link is clicked (so panel doesn't
      //    linger over the destination page during nav) ──────
      panel.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { close(); });
      });
    }

    function initAll() {
      document.querySelectorAll('.portl-nav').forEach(initShop);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
    // Theme editor: re-init when the header section reloads
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.portl-nav')) {
        initAll();
      }
    });
  })();

  /* ─── Transparent header over hero ─────────────────────────────
     Pages with a [data-hero-transparent-trigger] hero (home, Ultra Gym
     Explore, Studio Explore) get a transparent header while that hero
     is in viewport. Once scrolled past, body attribute drops → CSS
     rule reverts the nav background to solid #0A0A0A.
     The CSS in portl-theme.css handles the actual color swap with a
     smooth 0.3s transition. */
  (function () {
    function init() {
      var triggers = document.querySelectorAll('[data-hero-transparent-trigger]');
      // No trigger on this page → ensure body attribute is OFF and bail
      if (!triggers.length) {
        document.body.removeAttribute('data-hero-transparent');
        return;
      }

      var visible = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            visible.add(e.target);
          } else {
            visible.delete(e.target);
          }
        });
        // While a hero video modal has the body locked (position:fixed),
        // the layout shift would falsely report the hero as off-screen and
        // flip the header to its solid (white) state — a white flash behind
        // the modal overlay. Keep the current state until the modal closes.
        if (document.body.classList.contains('portl-hero-modal-lock')) return;
        if (visible.size > 0) {
          document.body.setAttribute('data-hero-transparent', 'true');
        } else {
          document.body.removeAttribute('data-hero-transparent');
        }
      }, {
        // Any tiny intersection counts as "in view" so the header stays
        // transparent until the hero is completely scrolled off.
        threshold: 0
      });

      triggers.forEach(function (t) { io.observe(t); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  /* ── Cart count badge ──────────────────────────────────────
     Liquid renders the correct count on full page navigation. This
     keeps the badge accurate for the two cases Liquid can't cover:
       1. bfcache / back-forward restore (stale cached markup), and
       2. AJAX add-to-cart from apps (GoKwik / Snapmint) that mutate
          the cart without a full reload.
     Exposes window.portlRefreshCartCount() so any add-to-cart flow
     can force a sync. */
  (function () {
    function setCount(n) {
      var badges = document.querySelectorAll('[data-cart-count]');
      Array.prototype.forEach.call(badges, function (b) {
        b.textContent = n > 99 ? '99+' : String(n);
        if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
        var btn = b.closest ? b.closest('.portl-nav__cart-btn') : null;
        if (btn) {
          btn.setAttribute('aria-label', n > 0 ? ('Cart, ' + n + ' ' + (n === 1 ? 'item' : 'items')) : 'Cart');
        }
      });
    }

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') { setCount(c.item_count); } })
        .catch(function () { /* offline / blocked — keep Liquid-rendered count */ });
    }

    window.portlRefreshCartCount = refresh;

    // bfcache restore — the cached DOM may show a stale count.
    window.addEventListener('pageshow', function (e) { if (e.persisted) { refresh(); } });

    // One sync on load, in case items were added via AJAX on a prior page
    // this session (Liquid count is correct on hard nav, but harmless to confirm).
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh, { once: true });
    } else {
      refresh();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-home-hero"] && !Shopify.designMode) return;
  try {
    
  // Bulletproof hero-video autoplay — matches Studio Explore behavior.
  //   • Sets muted + defaultMuted in JS (some browsers ignore the attr)
  //   • Eager play() on init
  //   • Retries on loadedmetadata + canplay (iOS often refuses play()
  //     before readyState is high enough)
  //   • Periodic timer nudges at 1s and 3s for slow-network mobile
  //   • Persistent unlock on any user interaction (covers iOS Low Power)
  //   • Re-binds on shopify:section:load for theme editor reorders
  (function () {
    function attempt(v) {
      try {
        v.muted = true;
        v.defaultMuted = true;
        var p = v.play();
        if (p && typeof p.then === 'function') p.catch(function () {});
      } catch (e) {}
    }

    // LCP guard: the hero <source>s ship with NO `src` (held in data-src) so
    // nothing — not even the shared autoplay rescuer in portl-theme.js, which
    // eager-play()s [data-portl-hero-video] at DOMContentLoaded — can fetch the
    // 2.4 MB video before first paint and steal bandwidth from the LCP poster.
    // We promote data-src → src only once we actually want playback (window
    // 'load' / first user interaction), then load() + play().
    function restoreSources(root) {
      (root || document).querySelectorAll('[data-portl-hero-video]').forEach(function (v) {
        if (v.dataset.portlSrcRestored === '1') return;
        var srcs = v.querySelectorAll('source[data-src]');
        if (!srcs.length) return;
        srcs.forEach(function (s) { s.setAttribute('src', s.getAttribute('data-src')); });
        v.dataset.portlSrcRestored = '1';
        try { v.load(); } catch (e) {}
      });
    }

    function ensurePlaying(root) {
      restoreSources(root);
      (root || document).querySelectorAll('[data-portl-hero-video]').forEach(function (v) {
        if (v.paused || v.readyState < 2) attempt(v);
      });
    }

    function init(root) {
      root = root || document;
      var videos = root.querySelectorAll('[data-portl-hero-video]');
      if (!videos.length) return;

      videos.forEach(function (v) {
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');

        // Fade the video in only once it's actually playing, so the eager
        // poster <img> (the LCP) stays painted until then — no black frame.
        v.addEventListener('playing', function () { v.classList.add('is-playing'); });

        // NOTE: no eager attempt() and no `autoplay` here. The <source>s carry
        // no `src` (data-src only) + preload="none", so the video loads NOTHING
        // until restoreSources() promotes data-src → src — which we defer to
        // window 'load' (below) so it never competes with the LCP poster for
        // bandwidth before first paint.
        v.addEventListener('loadedmetadata', function () { attempt(v); });
        v.addEventListener('canplay',        function () { attempt(v); });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    // Deferred start: kick the hero video AFTER first paint (window load),
    // then nudge a couple of times for slow-network / iOS throttling. This is
    // the primary play trigger now that autoplay + eager play() are removed.
    window.addEventListener('load', function () {
      ensurePlaying(document);
      setTimeout(function () { ensurePlaying(document); }, 800);
      setTimeout(function () { ensurePlaying(document); }, 2500);
    });

    // Persistent unlock — first user interaction kicks any still-paused video
    if (!window._portlHomeHeroUnlocked) {
      ['touchstart', 'pointerdown', 'click', 'scroll'].forEach(function (evt) {
        window.addEventListener(evt, function () { ensurePlaying(document); },
          { passive: true, capture: true });
      });
      window._portlHomeHeroUnlocked = true;
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-portl-hero-video]')) {
        init(e.target);
        // In the theme editor window 'load' has already fired, so start the
        // video immediately (restoreSources + play) after a section reorder.
        ensurePlaying(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-info-accordion"] && !Shopify.designMode) return;
  try {
    
  // Click title to toggle accordion item. Multiple can be open at once.
  (function () {
    function init(root) {
      root = root || document;
      var toggles = root.querySelectorAll('[data-portl-info-toggle]');
      if (!toggles.length) return;

      toggles.forEach(function (btn) {
        if (btn.dataset.portlInfoInit === '1') return;
        btn.dataset.portlInfoInit = '1';

        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          var targetId = btn.getAttribute('aria-controls');
          var target = targetId ? document.getElementById(targetId) : null;
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (target) {
            if (expanded) target.setAttribute('hidden', '');
            else          target.removeAttribute('hidden');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-latest-news"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var track = section.querySelector('[data-pln-track]');
      if (!track) return;
      var prev = section.querySelector('[data-pln-prev]');
      var next = section.querySelector('[data-pln-next]');

      /* Marquee mode — clone the cards once so the CSS keyframe
         animation (translateX 0 → -50%) loops seamlessly. Only
         runs when section root has data-pln-marquee="true" and we
         haven't already cloned (idempotent). Manual prev/next
         arrows are hidden by CSS when marquee is active, so the
         scrollByCard handlers below are inert in that mode. */
      if (section.getAttribute('data-pln-marquee') === 'true' && !track.__plnCloned) {
        track.__plnCloned = true;
        var cards = track.querySelectorAll('.portl-news-card');
        if (cards.length) {
          var frag = document.createDocumentFragment();
          cards.forEach(function (c) {
            var clone = c.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-pln-clone', '1');
            /* Strip focusability from cloned links so keyboard tab
               order doesn't double up over duplicated content. */
            clone.querySelectorAll('a, button').forEach(function (el) {
              el.setAttribute('tabindex', '-1');
            });
            frag.appendChild(clone);
          });
          track.appendChild(frag);
        }
      }

      function scrollByCard(dir) {
        var card = track.querySelector('.portl-news-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
        var step = (card.offsetWidth + gap) * (dir === 'next' ? 1 : -1);
        track.scrollBy({ left: step, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByCard('prev'); });
      if (next) next.addEventListener('click', function () { scrollByCard('next'); });
    }

    function boot() {
      document.querySelectorAll('.portl-latest-news').forEach(init);
    }

    if (document.readyState !== 'loading') {
      boot();
    } else {
      document.addEventListener('DOMContentLoaded', boot);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('.portl-latest-news');
      if (sec) init(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-loox-wrapper"] && !Shopify.designMode) return;
  try {
    
  /* ═══ Loox wrapper — shadow-DOM hide shim ═════════════════════════
     Arrow color is handled entirely by the inherited `color` cascade
     defined in the stylesheet above (Loox's <svg fill="currentColor">
     picks it up through the shadow boundary). No painting needed.

     This script only runs when the merchant has flipped on "Hide
     arrow buttons entirely". Light-DOM CSS at [data-hide-nav="1"]
     handles light-DOM Loox builds; this shim injects a matching
     `display:none` rule INTO the shadow root for shadow-DOM Loox
     builds, where theme CSS cannot reach. */
  (function () {
    var INJECT_FLAG = '__portlLooxHideStyled';

    // ═══ Lazy-mount Loox widget on scroll into viewport ═══════════
    //
    // Server-side we render the app block inside a <template>, which
    // keeps its custom elements DISCONNECTED — Loox's expensive init
    // work (review fetch, image hydration, swipe wiring) doesn't run
    // on page load. On first viewport intersection we clone the
    // template content into the empty mount div, which connects the
    // custom element → its connectedCallback fires → normal init.
    //
    // rootMargin: 200px so we start ~one viewport before the user
    // actually reaches the section, giving Loox a head start.
    // After the first intersect we disconnect the observer.
    //
    // Browsers without IntersectionObserver (very old) fall through
    // to the immediate-mount path — same end result, just no defer.
    function mountLoox(wrap) {
      if (wrap.__portlLooxMounted) return;
      wrap.__portlLooxMounted = true;
      var tmpl = wrap.querySelector('[data-portl-loox-template]');
      var mount = wrap.querySelector('[data-portl-loox-mount]');
      if (!tmpl || !mount) return;
      try {
        mount.appendChild(tmpl.content.cloneNode(true));
      } catch (e) {
        // Silent fail — extremely unlikely in any modern browser
        // (template + cloneNode are universally supported). If it
        // ever happens, the section will be empty rather than broken;
        // the merchant can see the issue in DevTools.
      }
    }

    function setupLazyMount(wrap) {
      if (wrap.__portlLooxLazyBound) return;
      wrap.__portlLooxLazyBound = true;
      if ('IntersectionObserver' in window) {
        /* Mobile gets a larger rootMargin so slower 3G/4G connections
           have more time to fetch the Loox script + initial review
           images BEFORE the section actually scrolls into view.
           Desktop keeps a tighter 200px since broadband can fetch in
           the time it takes the user to scroll one viewport. */
        var rm = (window.innerWidth || 1024) < 768 ? '400px 0px' : '200px 0px';
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              /* Schedule the clone in the next animation frame so we
                 don't compete with any scroll-driven paint work that's
                 already in flight. The clone itself is fast, but the
                 Loox connectedCallback that runs after can do real
                 work — keeping it off the critical scroll path avoids
                 a one-frame jank. */
              if (window.requestAnimationFrame) {
                requestAnimationFrame(function () { mountLoox(wrap); });
              } else {
                mountLoox(wrap);
              }
              io.disconnect();
            }
          });
        }, { rootMargin: rm, threshold: 0 });
        io.observe(wrap);
      } else {
        // No IO support — mount immediately so old browsers still see
        // the widget. Loses the defer benefit but preserves UX.
        mountLoox(wrap);
      }
    }

    function buildHideStyleEl() {
      var s = document.createElement('style');
      s.textContent = [
        '.swiper-button-prev,',
        '.swiper-button-next,',
        '[class*="prev"],',
        '[class*="next"] {',
        '  display: none !important;',
        '  visibility: hidden !important;',
        '  pointer-events: none !important;',
        '}'
      ].join('\n');
      return s;
    }

    function injectHideInto(host) {
      if (!host || !host.shadowRoot || host[INJECT_FLAG]) return;
      host[INJECT_FLAG] = true;
      host.shadowRoot.appendChild(buildHideStyleEl());
    }

    function bootForWrap(wrap) {
      if (wrap.__portlLooxBooted) return;
      wrap.__portlLooxBooted = true;

      // Lazy-mount the widget (gated on IO intersection). Runs even
      // when arrows aren't being hidden — independent feature.
      setupLazyMount(wrap);

      /* Only do anything for the arrow-hide shim when the merchant
         explicitly hides arrows. Otherwise the wrapper does nothing
         and Loox renders normally with our inherited color cascade. */
      if (wrap.getAttribute('data-hide-nav') !== '1') return;

      function scan() {
        wrap.querySelectorAll('loox-dynamic-carousel-widget, loox-widget, [class*="loox-widget"]').forEach(injectHideInto);
      }
      scan();
      /* Poll briefly for late-mounted Loox shadow hosts. After 5s
         the widget will have mounted, so we stop. */
      var checks = 0;
      var t = setInterval(function () {
        scan();
        if (++checks >= 10) clearInterval(t);
      }, 500);
    }

    function boot() {
      document.querySelectorAll('.portl-loox-wrap').forEach(bootForWrap);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var t = e.target;
      if (!t || !t.querySelectorAll) return;
      t.querySelectorAll('.portl-loox-wrap').forEach(function (w) {
        // Reset all flags so the section re-mounts cleanly when an
        // admin edits in the theme editor.
        w.__portlLooxBooted = false;
        w.__portlLooxLazyBound = false;
        w.__portlLooxMounted = false;
        bootForWrap(w);
      });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-modes-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-id]').forEach(function (root) {
      var track = root.querySelector('[data-portl-mc-track]');
      if (!track) return;
      var prev = root.querySelector('[data-portl-mc-prev]');
      var next = root.querySelector('[data-portl-mc-next]');
      var step = function () {
        var card = track.querySelector('.portl-mc-card');
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card ? card.getBoundingClientRect().width + gap : 320;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-modes-tabs"] && !Shopify.designMode) return;
  try {
    
  // ──────────────────────────────────────────────────────────────
  // Tabbed mode swap — clicking a tab pill OR an arrow swaps the
  // active video + content panel. iOS-safe video autoplay; videos
  // pause when not active to save CPU/battery.
  // ──────────────────────────────────────────────────────────────
  (function () {
    function init(root) {
      root = root || document;
      var sections = root.querySelectorAll('[data-portl-modes-tabs]');
      if (!sections.length) return;

      sections.forEach(function (section) {
        if (section.dataset.portlModesInit === '1') return;
        section.dataset.portlModesInit = '1';

        var tabs    = section.querySelectorAll('[data-portl-modes-tab]');
        var slides  = section.querySelectorAll('[data-portl-modes-slide]');
        var panels  = section.querySelectorAll('[data-portl-modes-panel]');
        var prevBtn = section.querySelector('[data-portl-modes-prev]');
        var nextBtn = section.querySelector('[data-portl-modes-next]');
        var videos  = section.querySelectorAll('[data-portl-modes-video]');
        var count   = tabs.length;
        if (count <= 0) return;

        // iOS-safe video setup — only the active one plays
        videos.forEach(function (v) {
          v.muted = true;
          v.defaultMuted = true;
          v.setAttribute('muted', '');
          v.setAttribute('playsinline', '');
          v.setAttribute('webkit-playsinline', '');
        });

        var current = 0;
        var setActive = function (idx) {
          if (idx < 0) idx = 0;
          if (idx >= count) idx = count - 1;
          if (idx === current && section.dataset.portlModesReady === '1') return;
          section.dataset.portlModesReady = '1';
          current = idx;

          tabs.forEach(function (el, i) {
            el.classList.toggle('is-current', i === idx);
            el.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
          slides.forEach(function (el, i) {
            el.classList.toggle('is-active', i === idx);
            el.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
          });
          panels.forEach(function (el, i) {
            el.classList.toggle('is-active', i === idx);
            el.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
          });

          // Pause non-active videos, attempt-play active video.
          // PERF: upgrade preload from 'none' to 'metadata' on the
          // active video BEFORE play() — so the browser starts
          // fetching the moov atom while we wait for the decode.
          // Without this, the first play() on a `preload="none"`
          // video has a 200-500ms stall on mid-tier mobile.
          videos.forEach(function (v, i) {
            if (i === idx) {
              if (v.getAttribute('preload') === 'none') {
                v.setAttribute('preload', 'metadata');
              }
              try {
                var p = v.play();
                if (p && typeof p.then === 'function') p.catch(function () {});
              } catch (e) {}
            } else {
              try { v.pause(); } catch (e) {}
            }
          });

          if (prevBtn) prevBtn.disabled = idx <= 0;
          if (nextBtn) nextBtn.disabled = idx >= count - 1;
        };

        // PERFORMANCE: gate the initial setActive(0) behind
        // IntersectionObserver. With `preload="none"` on the videos +
        // no `autoplay` attribute, MP4 data isn't fetched until JS
        // calls .play(). Wrapping the first play in IO means the
        // ~6MB MP4 for the active mode (and ~24MB across all 4 modes
        // if user tabs through) doesn't download until the user
        // scrolls within 200px of the section.
        //
        // The IO also pauses the video when scrolled out — saves
        // CPU/battery on mobile, mirrors the proven pattern from
        // portl-video-feature.liquid:596-639.
        if ('IntersectionObserver' in window) {
          var modesPlayed = false;
          var modesIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (!modesPlayed) {
                  setActive(0);  // first activation triggers .play() + metadata fetch
                  modesPlayed = true;
                } else {
                  // Re-entered viewport — resume the active video
                  var v = videos[current];
                  if (v) {
                    try {
                      var p = v.play();
                      if (p && typeof p.then === 'function') p.catch(function () {});
                    } catch (e) {}
                  }
                }
              } else {
                // Pause when scrolled out
                videos.forEach(function (v) { try { v.pause(); } catch (e) {} });
              }
            });
          }, { threshold: 0.15, rootMargin: '200px 0px' });
          modesIO.observe(section);
          // Still apply tab/UI state for tab 0 immediately (no .play(),
          // so no MP4 fetch) so the active tab pill + slide appearance
          // is correct on first paint before the user scrolls.
          tabs.forEach(function (el, i) {
            el.classList.toggle('is-current', i === 0);
            el.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          });
          slides.forEach(function (el, i) {
            el.classList.toggle('is-active', i === 0);
            el.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
          });
          panels.forEach(function (el, i) {
            el.classList.toggle('is-active', i === 0);
            el.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
          });
        } else {
          // No IntersectionObserver support — fall back to eager play
          // (preserves original behavior on ancient browsers).
          setActive(0);
        }

        // Tab click
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var idx = parseInt(tab.getAttribute('data-portl-modes-tab') || '0', 10);
            setActive(idx);
          });
        });

        // Arrow nav (clamped — last next disables)
        if (prevBtn) prevBtn.addEventListener('click', function () { setActive(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { setActive(current + 1); });

        // Keyboard
        section.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft')  setActive(current - 1);
          if (e.key === 'ArrowRight') setActive(current + 1);
        });
      });
    }

    // TBT: below-fold section — defer init(document) until the first tabs
    // instance nears the viewport rather than running its full setup
    // synchronously at DOMContentLoaded. init() is unchanged.
    function whenVisible() {
      var els = document.querySelectorAll('[data-portl-modes-tabs]');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { init(document); return; }
      var io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) { io.disconnect(); init(document); break; }
        }
      }, { rootMargin: '400px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenVisible, { once: true });
    } else {
      whenVisible();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-page-hero"] && !Shopify.designMode) return;
  try {
    
  // ──────────────────────────────────────────────────────────────
  // Hero video — aggressive autoplay pipeline that survives cold-cache
  // start on iOS Safari + Android Chrome.
  //
  // Root cause this fixes: with preload="metadata" + autoplay, browsers
  // load only the moov atom and STOP fetching until play() is called.
  // If the first play() call rejects (because readyState < HAVE_FUTURE_DATA),
  // Safari can leave the video element paused permanently — no further
  // bytes fetched, canplay never fires. This pipeline:
  //   • Calls v.load() to force the network state to NETWORK_LOADING.
  //   • Listens on every state-progress event (no { once: true }) so
  //     we retry on EVERY readyState change, not just the first.
  //   • Schedules play() retries at exponential intervals (100ms → 8s).
  //   • Uses IntersectionObserver as a final safety net when the
  //     video element enters the viewport.
  //   • Persistent unlock on user interaction for iOS Low Power Mode.
  // ──────────────────────────────────────────────────────────────
  (function () {
    var STATE_EVENTS = [
      'loadstart', 'loadedmetadata', 'loadeddata', 'canplay',
      'canplaythrough', 'progress', 'suspend', 'stalled', 'waiting',
      'pause'
    ];
    var RETRY_DELAYS_MS = [100, 250, 500, 1000, 2000, 4000, 8000];

    function tryPlay(v) {
      if (!v) return;
      /* CRITICAL: when the modal is open we intentionally pause the
         background video. The `pause` event below fires `tryPlay`,
         which would re-play it immediately. The modal sets
         `data-portl-paused-by-modal="1"` on the element before
         pausing; bail here so the video stays paused until the
         modal clears the flag in resumeBackgroundVideo(). */
      if (v.dataset.portlPausedByModal === '1') return;
      if (!v.paused && !v.ended) return;
      try {
        v.muted = true;
        v.defaultMuted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function init(root) {
      root = root || document;
      var videos = root.querySelectorAll('.portl-page-hero [data-portl-hero-video]');
      if (!videos.length) return;

      videos.forEach(function (v) {
        if (v.dataset.portlHeroBound === '1') return;
        v.dataset.portlHeroBound = '1';

        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('autoplay', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.setAttribute('disablepictureinpicture', '');

        // Force the browser to start fetching now. Without this,
        // preload="metadata" keeps the network idle after the moov atom
        // loads, leaving Safari's first play() rejecting forever.
        try { v.load(); } catch (e) {}

        // Retry on EVERY readiness/progress event — no `once`.
        STATE_EVENTS.forEach(function (ev) {
          v.addEventListener(ev, function () { tryPlay(v); });
        });
        v.addEventListener('error', function () {
          if (window.console) console.warn('[portl-page-hero] video failed:', v.currentSrc || v.src);
        });

        tryPlay(v);

        // IntersectionObserver — when the hero enters the viewport,
        // retry play() with a fresh autoplay-policy budget.
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) tryPlay(v);
            });
          });
          io.observe(v);
        }
      });

      // Exponential retry ladder — covers the case where every event-
      // based attempt rejects but a later one (with more buffer) succeeds.
      RETRY_DELAYS_MS.forEach(function (ms) {
        setTimeout(function () {
          root.querySelectorAll('.portl-page-hero [data-portl-hero-video]').forEach(tryPlay);
        }, ms);
      });

      // window.load — final nudge after all resources finish.
      window.addEventListener('load', function () {
        root.querySelectorAll('.portl-page-hero [data-portl-hero-video]').forEach(tryPlay);
      });

      // pageshow — fires when returning via bfcache (back/forward nav).
      // Without this, Safari pauses the video on bfcache restore.
      window.addEventListener('pageshow', function () {
        root.querySelectorAll('.portl-page-hero [data-portl-hero-video]').forEach(tryPlay);
      });

      // Persistent user-interaction unlock — covers iOS Low Power Mode.
      if (!window._portlPageHeroUnlocked) {
        var retry = function () {
          document.querySelectorAll('.portl-page-hero [data-portl-hero-video]').forEach(tryPlay);
        };
        ['touchstart', 'pointerdown', 'click', 'scroll'].forEach(function (evt) {
          window.addEventListener(evt, retry, { passive: true, capture: true });
        });
        window._portlPageHeroUnlocked = true;
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.portl-page-hero')) {
        // Reset the bind flag for re-rendered elements so the new
        // copies get the full pipeline attached.
        e.target.querySelectorAll('[data-portl-hero-video]').forEach(function (v) {
          v.dataset.portlHeroBound = '';
        });
        init(e.target);
      }
    });
  })();

  /* ─── Hero variant picker ──────────────────────────────────────
     Click a chip → update the Buy Now CTA href + visible price.
     The href becomes /products/<handle>?variant=<id> so the PDP
     pre-selects the chosen variant on arrival. */
  (function () {
    function bind(root) {
      root.querySelectorAll('[data-portl-hero-variants]').forEach(function (group) {
        var chips = group.querySelectorAll('.portl-page-hero__chip');
        // Scope to the SAME .portl-page-hero so multiple hero sections
        // on one page don't bleed into each other.
        var hero = group.closest('.portl-page-hero');
        if (!hero) return;
        var cta = hero.querySelector('[data-portl-hero-buy]');
        var priceEl = hero.querySelector('[data-portl-hero-buy-price]');

        chips.forEach(function (chip) {
          if (chip.disabled) return;
          chip.addEventListener('click', function (e) {
            e.preventDefault();
            var url = chip.getAttribute('data-variant-url');
            var price = chip.getAttribute('data-variant-price');

            chips.forEach(function (c) {
              c.classList.remove('is-selected');
              c.setAttribute('aria-pressed', 'false');
            });
            chip.classList.add('is-selected');
            chip.setAttribute('aria-pressed', 'true');

            if (cta && url) cta.setAttribute('href', url);
            if (priceEl && price) priceEl.textContent = price;
          });
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bind(document); }, { once: true });
    } else {
      bind(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-portl-hero-variants]')) {
        bind(e.target);
      }
    });
  })();

  /* ─── Hero video lightbox modal ──────────────────────────────────
     Click anywhere on the hero (outside interactive elements) →
     opens a centered modal that autoplays the same video.

     Lazy-init: the modal video has `preload="none"` and the actual
     `src` attribute is moved off the source tags to `data-src`. We
     promote `data-src` → `src` + call `.load()` on first open ONLY.
     Zero impact on page load.

     Body scroll lock: position-fixed-with-restore pattern survives
     iOS Safari rubber-band. Original scrollY is stamped on the body
     and restored on close.

     Focus trap: simple two-anchor trap — Tab from last focusable
     wraps to first, Shift+Tab from first wraps to last. Sufficient
     for a modal with only two focusable elements (close + video).
  */
  (function () {
    var SKIP_SELECTORS = 'a, button, input, select, textarea, label, [role="button"], [data-portl-hero-modal-skip]';
    var didLoadSources = false;

    function activateSources(video) {
      if (didLoadSources || !video) return;
      /* Sources are set eagerly in the Liquid markup now (was a
         data-src lazy-load pattern that broke on iOS). If any
         legacy data-src attributes are still present they get
         promoted to src here so we don't regress older templates. */
      Array.prototype.forEach.call(video.querySelectorAll('source'), function (src) {
        var url = src.getAttribute('data-src');
        if (url && !src.getAttribute('src')) src.setAttribute('src', url);
      });
      didLoadSources = true;
    }

    function lockBody() {
      if (document.body.dataset.portlModalLocked === '1') return;
      var scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.portlModalLocked = '1';
      document.body.dataset.portlModalScrollY = String(scrollY);
      document.body.classList.add('portl-hero-modal-lock');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockBody() {
      if (document.body.dataset.portlModalLocked !== '1') return;
      var scrollY = parseInt(document.body.dataset.portlModalScrollY || '0', 10);
      document.body.classList.remove('portl-hero-modal-lock');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.portlModalLocked;
      delete document.body.dataset.portlModalScrollY;
      // Restore scroll without smooth-scroll firing an extra animation.
      window.scrollTo(0, scrollY);
    }

    function bindModal(hero) {
      if (!hero || hero.dataset.portlHeroModalBound === '1') return;
      // The modal now lives OUTSIDE the hero <section> (a sibling inside the
      // #shopify-section wrapper) so its backdrop-filter isn't trapped by the
      // section's isolation:isolate. Search the wrapper, not just the hero.
      var modal = (hero.parentNode || document).querySelector('[data-portl-hero-modal]');
      if (!modal) return;
      hero.dataset.portlHeroModalBound = '1';
      hero.setAttribute('data-portl-hero-modal-trigger', '');

      var overlay = modal.querySelector('[data-portl-hero-modal-overlay]');
      var dialog = modal.querySelector('.portl-hero-modal__dialog');
      var closeBtn = modal.querySelector('[data-portl-hero-modal-close]');
      /* Modal can contain TWO <video> elements:
           data-modal-video-kind="hero"  → played by hero-area click
           data-modal-video-kind="demo"  → played by Live Demo CTA
         Either or both may be present depending on admin config.
         `resolveVideo(kind)` picks the matching element, with a
         fallback chain (kind → opposite kind → first available)
         so unconfigured kinds gracefully reuse the other video. */
      var modalVideos = Array.prototype.slice.call(
        modal.querySelectorAll('[data-portl-hero-modal-video]')
      );
      if (!dialog || !closeBtn || modalVideos.length === 0) return;

      /* ── HLS primary + MP4 fallback (popup video strategy) ──────
         Each kind ('hero' / 'demo') may carry data-hls-src. Per-
         video isolated Hls instances, keyed by data-video-id.
         Fatal failure → teardown + video.load() → in-markup MP4
         <source> tags take over. Close → destroy all instances to
         free decoder/buffer memory. hls.js loads from CDN on FIRST
         popup open only — zero page-load cost. */
      var hlsInstances = {};
      var modalLoader = modal.querySelector('[data-portl-hero-modal-loader]');

      function showLoader() { if (modalLoader) modalLoader.classList.add('is-visible'); }
      function hideLoader() { if (modalLoader) modalLoader.classList.remove('is-visible'); }

      function loadHlsScript(onload, onerror) {
        if (window.Hls) { onload(); return; }
        var sc = document.createElement('script');
        sc.src = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js';
        sc.async = true;
        sc.onload = onload;
        sc.onerror = onerror;
        document.head.appendChild(sc);
      }

      function fallbackToMp4(v) {
        var id = v.getAttribute('data-video-id') || '';
        if (hlsInstances[id]) { try { hlsInstances[id].destroy(); } catch (e) {} delete hlsInstances[id]; }
        v.removeAttribute('src');
        v.dataset.hlsReady = '';
        v.dataset.hlsFailed = '1';
        try { v.load(); } catch (e) {}          /* <source> MP4s take over */
        try {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } catch (e) {}
      }

      function ensureSource(v, done) {
        var src = v.getAttribute('data-hls-src');
        if (!src || v.dataset.hlsFailed === '1' || v.dataset.hlsReady === '1') { done(); return; }
        if (v.canPlayType('application/vnd.apple.mpegurl')) {
          v.src = src;
          v.dataset.hlsReady = '1';
          done(); return;
        }
        loadHlsScript(function () {
          if (window.Hls && window.Hls.isSupported()) {
            var id = v.getAttribute('data-video-id') || String(Math.floor(performance.now()));
            var h = new window.Hls();
            hlsInstances[id] = h;
            h.loadSource(src);
            h.attachMedia(v);
            v.dataset.hlsReady = '1';
            h.on(window.Hls.Events.MANIFEST_PARSED, done);
            h.on(window.Hls.Events.ERROR, function (evt, data) {
              if (data && data.fatal) {
                if (window.console) console.warn('[portl-hero-modal] HLS fatal — MP4 fallback:', data.type, data.details);
                fallbackToMp4(v);
              }
            });
          } else {
            fallbackToMp4(v); done();
          }
        }, function () { fallbackToMp4(v); done(); });
      }

      function teardownStreams() {
        modalVideos.forEach(function (v) {
          var id = v.getAttribute('data-video-id') || '';
          if (hlsInstances[id]) { try { hlsInstances[id].destroy(); } catch (e) {} delete hlsInstances[id]; }
          if (v.getAttribute('data-hls-src') && v.dataset.hlsReady === '1') {
            v.removeAttribute('src');
            v.dataset.hlsReady = '';
            try { v.load(); } catch (e) {}
          }
        });
      }

      /* Loader lifecycle — any video reaching first frame hides it. */
      modalVideos.forEach(function (v) {
        v.addEventListener('playing', hideLoader);
        v.addEventListener('loadeddata', hideLoader);
        v.addEventListener('error', hideLoader);
      });

      function resolveVideo(kind) {
        var match = null;
        for (var i = 0; i < modalVideos.length; i++) {
          if (modalVideos[i].dataset.modalVideoKind === kind) {
            match = modalVideos[i];
            break;
          }
        }
        return match || modalVideos[0];
      }

      /* Force iOS to fetch metadata for BOTH videos immediately,
         before any click. Even with the hidden modifier the modal is
         in the render tree (display:flex), but iOS sometimes still
         skips preload until it sees a load(). Calling load() here
         triggers the fetch for free during idle time, so when the
         user clicks ANY trigger the play() call has data to render. */
      modalVideos.forEach(function (v) {
        /* HLS videos skip the warmup — their source attaches on
           first open; warming the fallback MP4 would waste bytes. */
        if (v.getAttribute('data-hls-src')) return;
        try { v.load(); } catch (e) {}
      });

      /* All background hero videos (desktop + mobile sources may both
         be present in the DOM, with CSS display:none on the non-active
         variant). We pause ALL of them on modal open and resume ALL
         on modal close — the inactive one is no-op anyway. */
      var bgVideos = hero.querySelectorAll('.portl-page-hero__bg-video');

      var lastFocused = null;
      /* Track which bg videos were actively playing at open time so we
         only resume those (we don't auto-start ones the user had paused
         manually). */
      var pausedBgVideos = [];

      function pauseBackgroundVideo() {
        pausedBgVideos = [];
        Array.prototype.forEach.call(bgVideos, function (v) {
          /* Mark with the intent flag BEFORE pausing — otherwise the
             autoplay-retry pipeline (which listens for the `pause`
             event) instantly re-plays the video, racing with our
             pause call and leaving the video running behind the
             modal. tryPlay checks for this flag and bails. */
          v.dataset.portlPausedByModal = '1';
          /* video.paused is true if it's not currently playing for any
             reason (ended, never started, etc). We only restart videos
             that were actively playing. */
          if (!v.paused && !v.ended) {
            pausedBgVideos.push(v);
          }
          try { v.pause(); } catch (e) {}
        });
      }

      function resumeBackgroundVideo() {
        /* Clear the intent flag FIRST so the play() call (and any
           subsequent autoplay-retry events) succeed. */
        Array.prototype.forEach.call(bgVideos, function (v) {
          delete v.dataset.portlPausedByModal;
          v.removeAttribute('data-portl-paused-by-modal');
        });
        pausedBgVideos.forEach(function (v) {
          try {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } catch (e) {}
        });
        pausedBgVideos = [];
      }

      /* Track which video element is currently shown in the modal
         (set by openModal). closeModal + focus-trap reference this
         dynamically instead of capturing one element at bind time. */
      var activeModalVideo = null;

      /* Custom Mute/Unmute toggle (native controls are hidden). The button
         mirrors the ACTIVE video's live muted state via `volumechange`, so it
         stays correct when the open sequence auto-unmutes on `playing` and
         when the user taps it. Functionality unchanged — audio only. */
      var soundBtn = modal.querySelector('[data-portl-hero-modal-sound]');
      function syncSoundBtn() {
        if (!soundBtn) return;
        var v = activeModalVideo || modalVideos[0];
        var muted = !v || v.muted;
        soundBtn.setAttribute('data-muted', muted ? 'true' : 'false');
        soundBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
        soundBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }
      if (soundBtn) {
        soundBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var v = activeModalVideo || modalVideos[0];
          if (v) v.muted = !v.muted;   /* the volumechange listener repaints the icon */
        });
        modalVideos.forEach(function (v) {
          v.addEventListener('volumechange', syncSoundBtn);
        });
      }

      function showOnlyKind(kind) {
        var target = resolveVideo(kind);
        modalVideos.forEach(function (v) {
          if (v === target) {
            v.classList.remove('portl-hero-modal__video--hidden');
          } else {
            v.classList.add('portl-hero-modal__video--hidden');
            /* Pause the OTHER video so a quick close-then-reopen of
               the alternate kind doesn't leave a stale half-played
               clip in the background. */
            try { v.pause(); } catch (e) {}
            try { v.currentTime = 0; } catch (e) {}
            v.muted = true;
          }
        });
        return target;
      }

      function openModal(kind) {
        if (modal.classList.contains('is-open')) return;
        kind = kind || 'hero';
        lastFocused = document.activeElement;

        /* Pick the matching video, hide siblings. */
        var modalVideo = showOnlyKind(kind);
        activeModalVideo = modalVideo;
        if (!modalVideo) return;

        activateSources(modalVideo);

        /* Pause the background hero video before the modal video
           starts — avoids two audio tracks playing at once and
           reduces decoder pressure on mobile. */
        pauseBackgroundVideo();

        lockBody();
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');

        // Defer focus so the transition starts cleanly.
        setTimeout(function () { closeBtn.focus(); }, 60);

        /* iOS-safe play sequence:
             1. Start MUTED — iOS guarantees muted play() succeeds
                inside a user gesture.
             2. If the video already has metadata, play() right now.
                If it doesn't, call load() then wait for the FIRST
                `canplay` event before calling play() — iOS rejects
                play() on a fully-empty video element (readyState=0)
                even inside a click handler.
             3. Once `playing` fires (decoding has started), unmute
                and let the user control audio via native controls.
        */
        modalVideo.muted = true;
        modalVideo.volume = 1;
        syncSoundBtn();   /* show the muted icon immediately on open */

        function attemptPlay() {
          try { modalVideo.currentTime = 0; } catch (e) {}
          var p = modalVideo.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function (err) {
              try { console.warn('[portl-hero-modal] play failed:', err); } catch (e) {}
            });
          }
        }

        /* Show the loader until the first frame renders. */
        showLoader();

        /* Resolve the source first — no-op for MP4; attaches HLS
           (native or hls.js) on first open. Then run the iOS-safe
           readyState-gated play sequence. */
        ensureSource(modalVideo, function () {
          /* readyState: 0 = HAVE_NOTHING, 1 = HAVE_METADATA,
             2 = HAVE_CURRENT_DATA, 3 = HAVE_FUTURE_DATA, 4 = HAVE_ENOUGH_DATA.
             We need >= 2 (have current frame) for iOS play() to succeed. */
          if (modalVideo.readyState >= 2) {
            attemptPlay();
            return;
          }
          /* MP4 only: kick the network fetch. HLS manages its own
             loading via the attached MediaSource. */
          if (!modalVideo.getAttribute('data-hls-src')) {
            try { modalVideo.load(); } catch (e) {}
          }
          var onReady = function () {
            modalVideo.removeEventListener('canplay', onReady);
            modalVideo.removeEventListener('loadeddata', onReady);
            attemptPlay();
          };
          modalVideo.addEventListener('canplay', onReady);
          modalVideo.addEventListener('loadeddata', onReady);
          /* Also attempt right away — on browsers where play() is
             tolerant of unbuffered state, this starts decoding the
             moment bytes arrive without needing the canplay handoff. */
          attemptPlay();
        });

        /* Unmute once playback actually starts. Listen for `playing`
           (NOT `play`, which fires before bytes flow). */
        var onPlaying = function () {
          modalVideo.muted = false;
          modalVideo.removeEventListener('playing', onPlaying);
        };
        modalVideo.addEventListener('playing', onPlaying);
      }

      function closeModal() {
        if (!modal.classList.contains('is-open')) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');

        /* Pause + reset ALL modal videos (not just the active one) so
           a stale playback from a previous open doesn't leak into the
           next open of a different kind. */
        modalVideos.forEach(function (v) {
          try { v.pause(); } catch (e) {}
          if (!v.getAttribute('data-hls-src')) {
            try { v.currentTime = 0; } catch (e) {}
          }
          v.muted = true;
        });
        /* Strategy-mandated teardown: destroy HLS instances, drop
           sources, video.load() → decoder + buffer memory freed.
           Reopen re-attaches cheaply (hls.js script stays cached). */
        teardownStreams();
        hideLoader();
        activeModalVideo = null;

        unlockBody();

        /* Resume the background hero video that was paused on open. */
        resumeBackgroundVideo();

        if (lastFocused && typeof lastFocused.focus === 'function') {
          try { lastFocused.focus(); } catch (e) {}
        }
      }

      /* ─── Single consolidated click dispatcher ──────────────────
         Previously we had TWO listeners: one on each Live Demo CTA
         (for explicit demo trigger) and one on the hero root (for
         click-anywhere-to-open-hero-popup). On some mobile browsers
         the bubble order between them was racey — the hero handler
         would sometimes fire FIRST and open the hero popup before
         the demo handler's `stopPropagation` could kick in.

         Fix: ONE handler on the hero root, in the CAPTURE phase
         (third arg `true`), with an explicit demo-trigger lookup
         BEFORE the hero-fallback path. Capture phase fires
         top-down so we beat any descendant listener; the
         demo-trigger check then routes to openModal('demo') when
         the click landed on (or inside) the Live Demo button.
         Demo always wins when its trigger is in the path. */
      hero.addEventListener('click', function (e) {
        if (modal.classList.contains('is-open')) return;

        // Don't intercept clicks inside the modal itself (it's a
        // fixed-position descendant of the hero — close button etc).
        if (modal.contains(e.target)) return;

        // Don't open if user is mid text-selection.
        var sel = window.getSelection && window.getSelection();
        if (sel && sel.toString().length > 0) return;

        // ── Priority 1: did the click land on a Live Demo trigger?
        // Use `closest` so a tap on the SVG icon or the inner
        // <span> still resolves to the parent <a>.
        var demoEl = e.target.closest('[data-portl-hero-demo-trigger]');
        if (demoEl && hero.contains(demoEl)) {
          e.preventDefault();
          e.stopPropagation();
          openModal('demo');
          return;
        }

        // ── Priority 2: any other interactive element → ignore
        // (let normal nav happen — Buy Now, variant chips, etc).
        if (e.target.closest(SKIP_SELECTORS)) return;

        // ── Priority 3: click landed on the hero background →
        // open the hero-click popup.
        e.preventDefault();
        openModal('hero');
      }, true); /* ← capture phase: fires before any bubble-phase listener */

      // ─── Close paths ─────────────────────────────────────────────
      closeBtn.addEventListener('click', closeModal);
      if (overlay) overlay.addEventListener('click', closeModal);

      // ESC key.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          e.preventDefault();
          closeModal();
        }
      });

      // ─── Simple focus trap inside the modal ─────────────────────
      // Uses `activeModalVideo` (set on open) so the trap follows
      // whichever video kind is currently visible.
      modal.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !modal.classList.contains('is-open')) return;
        var focusables = [closeBtn, activeModalVideo].filter(Boolean);
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    function initAll(root) {
      root = root || document;
      var heroes = root.querySelectorAll('.portl-page-hero[data-section-id]');
      heroes.forEach(function (hero) {
        // Only bind heroes that actually have a modal (video configured +
        // admin toggle on). The modal is a sibling in the #shopify-section
        // wrapper now, so look there rather than inside the hero.
        if ((hero.parentNode || document).querySelector('[data-portl-hero-modal]')) bindModal(hero);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.portl-page-hero')) {
        // Reset the bind flag for any newly-rendered hero.
        e.target.querySelectorAll('.portl-page-hero[data-section-id]').forEach(function (h) {
          h.dataset.portlHeroModalBound = '';
        });
        didLoadSources = false; // re-allow lazy load after editor reload
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-press-quotes"] && !Shopify.designMode) return;
  try {
    
  /* Autoscroll marquee setup — duplicate the cards once so the CSS
     animation loop wraps invisibly. When the animation translates
     -50% (the duplicate's offset), the duplicate sits exactly where
     the original started → user sees continuous infinite scroll. */
  (function () {
    function setup(section) {
      if (section.dataset.portlPqReady === '1') return;
      if (section.dataset.autoscroll !== '1') return;
      var track = section.querySelector('.portl-pq__track');
      if (!track) return;
      var children = Array.prototype.slice.call(track.children);
      if (children.length === 0) return;
      /* Clone each card and append. Use cloneNode(true) for deep clone.
         aria-hidden the clones so screen readers don't read duplicates. */
      children.forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        /* Remove tabindex on cloned anchors so keyboard users don't
           tab through duplicate links */
        clone.setAttribute('tabindex', '-1');
        track.appendChild(clone);
      });
      section.dataset.portlPqReady = '1';
    }
    function bootAll() {
      document.querySelectorAll('.portl-pq--autoscroll').forEach(setup);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll, { once: true });
    } else {
      bootAll();
    }
    /* Re-init when a section reloads in the theme editor */
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.portl-pq--autoscroll');
      if (s) setup(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-id]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-portl-rev-slide]');
      if (!slides.length) return;
      var dots = root.querySelectorAll('[data-portl-rev-dot]');
      var prev = root.querySelector('[data-portl-rev-prev]');
      var next = root.querySelector('[data-portl-rev-next]');
      var idx = 0;
      function go(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      }
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-reviews-edt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOne(section) {
      if (!section || section.dataset.portlEdtInit === '1') return;
      section.dataset.portlEdtInit = '1';

      var track = section.querySelector('[data-portl-edt-track]');
      var prev  = section.querySelector('[data-portl-edt-prev]');
      var next  = section.querySelector('[data-portl-edt-next]');
      var dotsContainer = section.querySelector('[data-portl-edt-dots]');
      // Static text panel — populated from whichever card is active.
      var panel        = section.querySelector('[data-portl-edt-panel]');
      var panelStars   = section.querySelector('[data-portl-edt-panel-stars]');
      var panelText    = section.querySelector('[data-portl-edt-panel-text]');
      var panelName    = section.querySelector('[data-portl-edt-panel-name]');
      var panelVerified= section.querySelector('[data-portl-edt-panel-verified]');
      if (!track) return;

      function getCards() {
        return Array.prototype.slice.call(track.querySelectorAll('.portl-edt-card'));
      }

      // ── Active card → panel sync ─────────────────────────────
      // Find the card that is currently the leftmost visible one
      // in the carousel. That card's data populates the static
      // text panel on the left. Panel content cross-fades on change.
      var activeIndex = -1;
      function findActiveCardIndex() {
        var cards = getCards();
        if (!cards.length) return 0;
        var trackRect = track.getBoundingClientRect();
        // Leftmost card whose right edge is past the track's left edge.
        for (var i = 0; i < cards.length; i++) {
          var r = cards[i].getBoundingClientRect();
          if (r.right - trackRect.left > 24) return i;
        }
        return cards.length - 1;
      }

      function starsHtml(n) {
        var s = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"/></svg>';
        var out = '';
        for (var i = 0; i < n; i++) out += s;
        return out;
      }

      function applyPanelData(card) {
        if (!card || !panel) return;
        var d = card.dataset;
        var rating = parseInt(d.reviewRating || '5', 10);
        if (isNaN(rating)) rating = 0;

        if (panelStars) {
          panelStars.innerHTML = starsHtml(rating);
          panelStars.style.display = rating > 0 ? '' : 'none';
        }
        if (panelText) {
          panelText.textContent = d.reviewText || '';
          panelText.style.display = d.reviewText ? '' : 'none';
        }
        if (panelName) {
          panelName.textContent = d.reviewName || '';
        }
        if (panelVerified) {
          if (d.reviewVerified === '1' && d.reviewName) {
            panelVerified.classList.add('is-visible');
          } else {
            panelVerified.classList.remove('is-visible');
          }
        }
      }

      function syncPanel() {
        var idx = findActiveCardIndex();
        if (idx === activeIndex) return;
        activeIndex = idx;
        var cards = getCards();
        var card = cards[idx];
        if (!card) return;

        // Update focal-card classes (used for the desktop staircase
        // sizing + mobile center-card scale).
        updateFocalClasses(idx);

        if (!panel) {
          applyPanelData(card);
          return;
        }

        // Cross-fade: hide → swap → reveal
        panel.classList.add('is-fading');
        setTimeout(function () {
          applyPanelData(card);
          // Force reflow so transition triggers cleanly
          void panel.offsetWidth;
          panel.classList.remove('is-fading');
        }, 200);
      }

      // Detect mobile breakpoint (matches CSS @media max-width: 767.98px)
      function isMobile() {
        return window.matchMedia('(max-width: 767.98px)').matches;
      }

      // Apply size classes based on each card's position relative to the
      // currently-active (focal) card.
      //
      // Mobile  — WRAPS previous/secondary indices so 3 cards are ALWAYS
      //           visible (left small + center BIG + right small), even
      //           when the active card is the first or last in the list.
      //           Uses: is-previous, is-focal, is-secondary
      // Desktop — NO wrap. 5 cards forward from focal:
      //             is-focal (1st) + is-secondary (2nd) + is-tertiary (3rd)
      //             + is-fourth (4th) + is-fifth (5th, slightly smaller)
      //           setCenter() clamps activeIdx to cards.length - 5 so
      //           there's never a frame with fewer than 5 visible (unless
      //           the section truly has < 5 reviews).
      function updateFocalClasses(activeIdx) {
        var cards = getCards();
        if (!cards.length) return;
        if (typeof activeIdx !== 'number') activeIdx = findActiveCardIndex();
        var n = cards.length;
        var mobile = isMobile();

        var prevIdx, nextIdx, thirdIdx, fourthIdx, fifthIdx;
        if (mobile) {
          // Wrap so always 3 visible (left + center + right)
          prevIdx  = (activeIdx - 1 + n) % n;
          nextIdx  = (activeIdx + 1) % n;
          thirdIdx  = -1;                      // not used on mobile
          fourthIdx = -1;
          fifthIdx  = -1;
        } else {
          // Desktop 5-up — no wrap. is-previous is kept assigned but
          // CSS hides it (legacy compatibility for any code that
          // reads .is-previous on desktop).
          prevIdx   = activeIdx - 1;
          nextIdx   = activeIdx + 1;
          thirdIdx  = activeIdx + 2;
          fourthIdx = activeIdx + 3;
          fifthIdx  = activeIdx + 4;
        }

        cards.forEach(function (c, i) {
          c.classList.toggle('is-focal',     i === activeIdx);
          c.classList.toggle('is-secondary', i === nextIdx);
          c.classList.toggle('is-tertiary',  i === thirdIdx);
          c.classList.toggle('is-fourth',    i === fourthIdx);
          c.classList.toggle('is-fifth',     i === fifthIdx);
          c.classList.toggle('is-previous',  i === prevIdx);
        });
      }

      // ── State-based navigation (no scrolling) ───────────────
      // Only 3 cards are visible at any time (CSS hides the rest).
      // setCenter() updates the focal index, shuffles the classes,
      // CSS handles smooth size transitions.
      //
      // `allowWrap` controls boundary behaviour:
      //   true  → autoplay can wrap from last → first
      //   false → arrow clicks STOP at boundaries (no wrap)
      function setCenter(idx, allowWrap) {
        var cards = getCards();
        if (!cards.length) return;
        // Mobile: any card can be focal (wraps via previous/secondary).
        // Desktop: cap focal at cards.length - 5 so the 5-card row is
        // always fully populated. Autoplay's allowWrap=true then
        // cycles cleanly from "last 5-up position" back to 0 without
        // an awkward frame showing fewer than 5 cards.
        var max = isMobile() ? cards.length - 1 : Math.max(0, cards.length - 5);
        if (idx < 0) idx = allowWrap ? max : 0;
        if (idx > max) idx = allowWrap ? 0 : max;

        activeIndex = idx;
        updateFocalClasses(idx);
        updateArrowVisibility();
        if (typeof updateDots === 'function') updateDots();

        // Sync panel content with cross-fade
        var card = cards[idx];
        if (card) {
          if (panel) {
            panel.classList.add('is-fading');
            setTimeout(function () {
              applyPanelData(card);
              void panel.offsetWidth;
              panel.classList.remove('is-fading');
            }, 180);
          } else {
            applyPanelData(card);
          }
        }
      }

      // Show/hide arrows at start + end boundaries.
      // Mobile  — always visible (the slider wraps continuously).
      // Desktop — hidden at first/last review respectively.
      function updateArrowVisibility() {
        var cards = getCards();
        if (!cards.length) return;
        if (isMobile()) {
          if (prev) prev.style.visibility = 'visible';
          if (next) next.style.visibility = 'visible';
        } else {
          // Desktop 5-up: right arrow hides only when the last 5
          // cards are already on screen (cards.length - 5 is the
          // last meaningful focal index).
          var atStart = activeIndex <= 0;
          var atEnd   = activeIndex >= Math.max(0, cards.length - 5);
          if (prev) prev.style.visibility = atStart ? 'hidden' : 'visible';
          if (next) next.style.visibility = atEnd   ? 'hidden' : 'visible';
        }
      }

      // Legacy aliases (kept so existing keyboard / swipe code paths work)
      function scrollByOneCard(dir) { setCenter(activeIndex + dir, isMobile()); }
      function scrollToCard(idx)    { setCenter(idx, isMobile()); }

      // Arrow clicks: wrap on MOBILE (continuous), stop at boundaries on
      // DESKTOP (where arrows visually hide at first/last).
      if (prev) prev.addEventListener('click', function () { setCenter(activeIndex - 1, isMobile()); });
      if (next) next.addEventListener('click', function () { setCenter(activeIndex + 1, isMobile()); });

      // ── Pagination dots — one dot per card ─────────────────
      // The active dot reflects whichever card is closest to the
      // left edge of the visible viewport. Clicking a dot scrolls
      // that card into view.
      var dotEls = [];
      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        var cards = getCards();
        dotEls = cards.map(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'portl-edt-reviews__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          b.addEventListener('click', function () { setCenter(i); });
          dotsContainer.appendChild(b);
          return b;
        });
        updateDots();
      }
      function updateDots() {
        if (!dotEls.length) return;
        // Active dot reflects the current focal index — no scroll math.
        var idx = activeIndex;
        if (idx < 0) idx = 0;
        if (idx >= dotEls.length) idx = dotEls.length - 1;
        dotEls.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
      }
      buildDots();

      // With state-based nav, arrows are always enabled (they wrap).
      // Kept as no-op so other call sites don't break.
      function updateNavState() {
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
        updateDots();
      }
      // Initial populate of the panel + focal classes + arrow state
      // with the first card's data (runs once on init).
      (function () {
        var cards = getCards();
        if (cards[0]) {
          applyPanelData(cards[0]);
          activeIndex = 0;
          updateFocalClasses(0);
          updateDots();
          updateArrowVisibility();
        }
      })();
      window.addEventListener('resize', function () {
        // Re-evaluate breakpoint-dependent state: focal class wrap,
        // arrow visibility, and rebuild dots for the new size.
        buildDots();
        updateFocalClasses(activeIndex);
        updateArrowVisibility();
        updateNavState();
      });

      // Keyboard arrow keys when the track has focus
      track.setAttribute('tabindex', '0');
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); scrollByOneCard(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); scrollByOneCard(1); }
      });

      // ── Autoplay (matches EDTworld Loox autoplay-delay='5') ──
      // Auto-advance every 5s indefinitely. Does NOT pause on hover
      // (Loox's default behavior — users hovering to read reviews
      // shouldn't freeze the carousel). Only pauses on:
      //   • Active touch (mobile interaction)
      //   • Modal open
      //   • Tab hidden (battery friendly)
      //   • prefers-reduced-motion
      var AUTOPLAY_DELAY = parseInt(section.dataset.portlEdtAutoplay || '5000', 10);
      var autoplayTimer = null;
      var paused = false;

      function advanceAutoplay() {
        if (paused) return;
        if (document.hidden) return;
        // Autoplay wraps last → first for continuous loop.
        setCenter(activeIndex + 1, true);
      }
      function startAutoplay() {
        stopAutoplay();
        if (AUTOPLAY_DELAY <= 0) return;
        autoplayTimer = setInterval(advanceAutoplay, AUTOPLAY_DELAY);
      }
      function stopAutoplay() {
        if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
      }
      function pause()  { paused = true;  stopAutoplay(); }
      function resume() { paused = false; startAutoplay(); }

      // Pause briefly on touch (mobile swipe interaction)
      section.addEventListener('touchstart', function () {
        pause();
      }, { passive: true });
      section.addEventListener('touchend', function () {
        // Resume 1.5s after touchend so user can finish their swipe
        setTimeout(resume, 1500);
      }, { passive: true });

      // Pause briefly when user clicks an arrow / dot — resume after 4s
      if (prev) prev.addEventListener('click', function () { pause(); setTimeout(resume, 4000); });
      if (next) next.addEventListener('click', function () { pause(); setTimeout(resume, 4000); });

      // Stop the interval when tab is hidden, restart when visible
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay();
        else if (!paused) startAutoplay();
      });

      // Respect reduced-motion
      var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (rm.matches) {
        AUTOPLAY_DELAY = 0;
      } else {
        // Kick off autoplay. Use a tiny initial delay so the page is
        // fully laid out before the first advance fires.
        setTimeout(startAutoplay, 250);
      }

      // ── Lightbox modal — open on card click ────────────────
      initModal(section, track, pause, resume);

      // ── Text panel: clicking the cyan review box opens the
      //    SAME modal as clicking the focal image card.
      //    We delegate by programmatically clicking the focal card,
      //    which routes through the existing section-level click
      //    listener inside initModal() and opens the popup at the
      //    correct review index (= activeIndex).
      if (panel) {
        panel.setAttribute('role', 'button');
        panel.setAttribute('tabindex', '0');
        panel.setAttribute('aria-label', 'Open full review');

        function openFocalFromPanel() {
          var cards = getCards();
          var focal = cards[activeIndex];
          if (focal && typeof focal.click === 'function') {
            focal.click();
          }
        }

        panel.addEventListener('click', function (e) {
          // Don't double-fire if a card inside the panel was clicked
          // (none exist today, but be defensive).
          if (e.target.closest('[data-portl-edt-card]')) return;
          openFocalFromPanel();
        });

        panel.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openFocalFromPanel();
          }
        });
      }
    }

    // ──────────────────────────────────────────────────────────
    // Modal lightbox
    //   • Reads review data from clicked card's data-* attributes
    //   • Supports prev/next nav, ESC, click-outside, mobile swipe
    //   • Pauses carousel autoplay while open; resumes on close
    //   • Returns focus to the originating card on close (a11y)
    // ──────────────────────────────────────────────────────────
    function initModal(section, track, pauseAutoplay, resumeAutoplay) {
      var modal = section.querySelector('[data-portl-edt-modal]');
      if (!modal) return;

      var imgEl     = modal.querySelector('[data-portl-edt-modal-img]');
      var mediaEl   = modal.querySelector('.portl-edt-modal__media');
      var panelEl   = modal.querySelector('.portl-edt-modal__panel');
      var textEl    = modal.querySelector('[data-portl-edt-modal-text]');
      var nameEl    = modal.querySelector('[data-portl-edt-modal-name]');
      var verifiedEl= modal.querySelector('[data-portl-edt-modal-verified]');
      var starsEl   = modal.querySelector('[data-portl-edt-modal-stars]');
      var productEl = modal.querySelector('[data-portl-edt-modal-product]');
      var productLb = modal.querySelector('[data-portl-edt-modal-product-label]');
      var productRow= modal.querySelector('[data-portl-edt-modal-product-row]');
      var productThumb = modal.querySelector('[data-portl-edt-modal-product-thumb]');
      var productNameEl = modal.querySelector('[data-portl-edt-modal-product-name]');
      var imgPrev   = modal.querySelector('[data-portl-edt-img-prev]');
      var imgNext   = modal.querySelector('[data-portl-edt-img-next]');
      var thumbsEl  = modal.querySelector('[data-portl-edt-modal-thumbs]');
      var infoBtn   = modal.querySelector('[data-portl-edt-info]');
      var infoTip   = modal.querySelector('[data-portl-edt-info-tooltip]');
      var prevBtn   = modal.querySelector('[data-portl-edt-modal-prev]');
      var nextBtn   = modal.querySelector('[data-portl-edt-modal-next]');
      var closers   = modal.querySelectorAll('[data-portl-edt-close]');

      var cards = [];
      var currentIndex = 0;
      var lastFocused = null;
      // Per-review image gallery state
      var currentImages = [];
      var currentImgIdx = 0;

      function refreshCards() {
        cards = Array.prototype.slice.call(
          section.querySelectorAll('[data-portl-edt-card]')
        );
      }

      function starSvg() {
        return '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
          '<polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"/></svg>';
      }

      function showImage(idx) {
        if (!currentImages.length) return;
        if (idx < 0) idx = 0;
        if (idx >= currentImages.length) idx = currentImages.length - 1;
        currentImgIdx = idx;

        if (imgEl) {
          imgEl.classList.add('is-loading');
          imgEl.src = currentImages[idx];
          // Cross-fade in once loaded
          imgEl.onload = function () { imgEl.classList.remove('is-loading'); };
        }

        // Update thumb active state
        if (thumbsEl) {
          Array.prototype.forEach.call(
            thumbsEl.querySelectorAll('.portl-edt-modal__thumb'),
            function (t, i) {
              t.classList.toggle('is-active', i === idx);
              t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
            }
          );
        }

        // Image-nav visibility rules (matches reference popup behavior):
        //   • 1 image total      → hide BOTH arrows
        //   • on first image     → hide LEFT (prev) arrow
        //   • on last image      → hide RIGHT (next) arrow
        //   • middle of >1 list  → show both
        var hasMultiple = currentImages.length > 1;
        if (imgPrev) {
          imgPrev.hidden   = !hasMultiple || idx <= 0;
          imgPrev.disabled = imgPrev.hidden;
        }
        if (imgNext) {
          imgNext.hidden   = !hasMultiple || idx >= currentImages.length - 1;
          imgNext.disabled = imgNext.hidden;
        }
      }

      function buildThumbs() {
        if (!thumbsEl) return;
        thumbsEl.innerHTML = '';
        if (!currentImages.length) return;       // no images at all → nothing to show
        // Always render the strip (even for a single image) to match
        // the EDT World reference popup behavior.
        currentImages.forEach(function (src, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'portl-edt-modal__thumb' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', 'View image ' + (i + 1));
          btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          btn.dataset.thumbIdx = String(i);

          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          btn.appendChild(img);

          btn.addEventListener('click', function () { showImage(i); });
          thumbsEl.appendChild(btn);
        });
      }

      function populate(card) {
        if (!card) return;
        // Always dismiss any open verified tooltip when switching reviews
        if (infoTip && !infoTip.hidden && infoBtn) {
          infoTip.hidden = true;
          infoBtn.setAttribute('aria-expanded', 'false');
        }
        var data = card.dataset;
        var rating = parseInt(data.reviewRating || '5', 10);
        if (isNaN(rating) || rating < 0) rating = 0;

        // Collect up to 3 images for THIS review
        currentImages = [
          data.reviewImage,
          data.reviewImage2,
          data.reviewImage3
        ].filter(function (s) { return s && s.length > 0; });

        if (currentImages.length) {
          panelEl.classList.remove('no-image');
          mediaEl.style.display = '';
          buildThumbs();
          showImage(0);
        } else {
          imgEl.removeAttribute('src');
          imgEl.alt = '';
          panelEl.classList.add('no-image');
          if (thumbsEl) thumbsEl.innerHTML = '';
          if (imgPrev) { imgPrev.hidden = true; imgPrev.disabled = true; }
          if (imgNext) { imgNext.hidden = true; imgNext.disabled = true; }
        }
        if (imgEl) imgEl.alt = data.reviewName || 'Customer review';

        // Stars
        if (starsEl) {
          var html = '';
          for (var i = 0; i < rating; i++) html += starSvg();
          starsEl.innerHTML = html;
          starsEl.setAttribute('aria-label', rating + ' out of 5 stars');
          starsEl.style.display = rating > 0 ? '' : 'none';
        }

        // Text + name
        if (textEl) textEl.textContent = data.reviewText || '';
        if (textEl) textEl.style.display = data.reviewText ? '' : 'none';
        if (nameEl) nameEl.textContent = data.reviewName || '';

        // Verified badge (with "i" icon)
        if (verifiedEl) {
          if (data.reviewVerified === '1' && data.reviewName) {
            verifiedEl.hidden = false;
          } else {
            verifiedEl.hidden = true;
          }
        }

        // Product info row (thumb + name + CTA button)
        if (productRow) {
          var hasProductLink = !!data.reviewProductUrl;
          var hasProductName = !!data.reviewProductName;
          var hasProductThumb = !!data.reviewProductImage;
          var showRow = hasProductLink || hasProductName || hasProductThumb;
          productRow.hidden = !showRow;

          if (showRow) {
            if (productThumb) {
              if (hasProductThumb) {
                productThumb.src = data.reviewProductImage;
                productThumb.alt = data.reviewProductName || 'Product';
                productThumb.style.display = '';
              } else {
                productThumb.removeAttribute('src');
                productThumb.style.display = 'none';
              }
            }
            if (productNameEl) productNameEl.textContent = data.reviewProductName || '';
            if (productEl) {
              if (hasProductLink) {
                productEl.href = data.reviewProductUrl;
                productEl.style.display = '';
                if (productLb) productLb.textContent = data.reviewProductLabel || 'View product';
              } else {
                productEl.removeAttribute('href');
                productEl.style.display = 'none';
              }
            }
          }
        }

        // Outer prev/next disabled states (review-level — hidden by default)
        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= cards.length - 1;
      }

      function openAt(index) {
        refreshCards();
        if (index < 0) index = 0;
        if (index >= cards.length) index = cards.length - 1;
        currentIndex = index;
        lastFocused = document.activeElement;
        populate(cards[currentIndex]);

        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('portl-edt-modal-open');
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
        pauseAutoplay();

        // Focus the close button for keyboard users
        setTimeout(function () {
          var closeBtn = modal.querySelector('.portl-edt-modal__close');
          if (closeBtn) closeBtn.focus();
        }, 60);
      }

      function close() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        setTimeout(function () {
          modal.hidden = true;
          document.body.classList.remove('portl-edt-modal-open');
          if (lastFocused && lastFocused.focus) lastFocused.focus();
        }, 280);
        // Resume autoplay a beat after close so it doesn't jump immediately
        setTimeout(resumeAutoplay, 800);
      }

      function next() {
        if (currentIndex < cards.length - 1) {
          currentIndex++;
          populate(cards[currentIndex]);
        }
      }
      function prev() {
        if (currentIndex > 0) {
          currentIndex--;
          populate(cards[currentIndex]);
        }
      }

      // ── Card → open modal ──
      section.addEventListener('click', function (e) {
        var card = e.target.closest('[data-portl-edt-card]');
        if (!card || !section.contains(card)) return;
        e.preventDefault();
        refreshCards();
        var idx = cards.indexOf(card);
        if (idx === -1) idx = 0;
        openAt(idx);
      });

      // ── Close + outer (review-level) prev/next ──
      closers.forEach(function (btn) { btn.addEventListener('click', close); });
      if (prevBtn) prevBtn.addEventListener('click', function (e) {
        if (prevBtn.disabled) { e.preventDefault(); return; }
        prev();
      });
      if (nextBtn) nextBtn.addEventListener('click', function (e) {
        if (nextBtn.disabled) { e.preventDefault(); return; }
        next();
      });

      // ── Image-level prev/next (within current review's images) ──
      if (imgPrev) imgPrev.addEventListener('click', function () {
        if (imgPrev.disabled) return;
        showImage(currentImgIdx - 1);
      });
      if (imgNext) imgNext.addEventListener('click', function () {
        if (imgNext.disabled) return;
        showImage(currentImgIdx + 1);
      });

      // ── Verified info tooltip — toggle on (i) click ──
      function openInfo() {
        if (!infoTip || !infoBtn) return;
        infoTip.hidden = false;
        infoBtn.setAttribute('aria-expanded', 'true');
      }
      function closeInfo() {
        if (!infoTip || !infoBtn) return;
        infoTip.hidden = true;
        infoBtn.setAttribute('aria-expanded', 'false');
      }
      if (infoBtn) {
        infoBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (infoTip && infoTip.hidden) openInfo(); else closeInfo();
        });
      }
      // Click anywhere outside the tooltip / button closes it
      modal.addEventListener('click', function (e) {
        if (!infoTip || infoTip.hidden) return;
        if (infoTip.contains(e.target) || (infoBtn && infoBtn.contains(e.target))) return;
        closeInfo();
      });
      // Reset tooltip when modal closes (close listener defined further down).
      // We tack it onto every closer button so it always clears.
      Array.prototype.forEach.call(closers, function (b) {
        b.addEventListener('click', closeInfo);
      });

      // ── Keyboard ──
      // ESC closes. Arrow keys navigate IMAGES inside the current review
      // when the review has multiple images; otherwise nav to next/prev review.
      document.addEventListener('keydown', function (e) {
        if (modal.hidden) return;
        if (e.key === 'Escape') {
          // ESC closes the tooltip first if open, then the modal
          if (infoTip && !infoTip.hidden) { closeInfo(); return; }
          close();
          return;
        }
        if (e.key === 'ArrowRight') {
          if (currentImages.length > 1 && currentImgIdx < currentImages.length - 1) showImage(currentImgIdx + 1);
          else next();
        } else if (e.key === 'ArrowLeft') {
          if (currentImages.length > 1 && currentImgIdx > 0) showImage(currentImgIdx - 1);
          else prev();
        }
      });

      // ── Touch swipe on the image area (mobile) ──
      // Multi-image reviews: swipe nav images within the review.
      // Single-image reviews: swipe nav between reviews.
      var sx = 0, sy = 0, dragging = false;
      if (mediaEl) {
        mediaEl.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches[0]) return;
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          dragging = true;
        }, { passive: true });
        mediaEl.addEventListener('touchend', function (e) {
          if (!dragging) return;
          dragging = false;
          var t = e.changedTouches && e.changedTouches[0];
          if (!t) return;
          var dx = t.clientX - sx;
          var dy = t.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            if (currentImages.length > 1) {
              if (dx < 0) showImage(currentImgIdx + 1);
              else        showImage(currentImgIdx - 1);
            } else {
              if (dx < 0) next(); else prev();
            }
          }
        }, { passive: true });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-portl-edt-reviews]').forEach(initOne);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-portl-edt-reviews]')) {
        initAll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-reviews-grid"] && !Shopify.designMode) return;
  try {
    
  // ──────────────────────────────────────────────────────────────
  // Submit Review modal
  //   • Open: click [data-portl-review-open]
  //   • Close: click [data-portl-review-close], ESC, or backdrop
  //   • Star rating: click stars 1..5; updates hidden input
  //   • File: when chosen, show filename below the upload box
  //   • Auto-open after a successful submission to show the success state
  // ──────────────────────────────────────────────────────────────
  (function () {
    function init(root) {
      root = root || document;
      var sections = root.querySelectorAll('.portl-reviews-grid');
      if (!sections.length) return;

      sections.forEach(function (section) {
        if (section.dataset.portlReviewInit === '1') return;
        section.dataset.portlReviewInit = '1';

        var modal     = section.querySelector('[data-portl-review-modal]');
        var openBtn   = section.querySelector('[data-portl-review-open]');
        var closers   = section.querySelectorAll('[data-portl-review-close]');
        var stars     = section.querySelectorAll('[data-portl-review-star]');
        var ratingIn  = section.querySelector('[data-portl-review-rating-value]');
        var fileIn    = section.querySelector('[data-portl-review-file]');
        var fileName  = section.querySelector('[data-portl-review-file-name]');

        if (!modal) return;

        var openModal = function () {
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('portl-review-modal-open');
          requestAnimationFrame(function () { modal.classList.add('is-open'); });
        };
        var closeModal = function () {
          modal.classList.remove('is-open');
          setTimeout(function () {
            modal.hidden = true;
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('portl-review-modal-open');
          }, 250);
        };

        if (openBtn) openBtn.addEventListener('click', openModal);
        closers.forEach(function (c) { c.addEventListener('click', closeModal); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) closeModal();
        });

        // Star rating selector
        stars.forEach(function (star) {
          star.addEventListener('click', function () {
            var val = parseInt(star.getAttribute('data-portl-review-star') || '0', 10);
            stars.forEach(function (s, i) {
              s.classList.toggle('is-filled', (i + 1) <= val);
            });
            if (ratingIn) ratingIn.value = String(val);
          });
        });

        // File-name display
        if (fileIn && fileName) {
          fileIn.addEventListener('change', function () {
            if (fileIn.files && fileIn.files.length > 0) {
              fileName.textContent = fileIn.files[0].name;
            } else {
              fileName.textContent = '';
            }
          });
        }

        // ── Double-submit guard ──────────────────────────────────────────
        // This review form does a native full-page POST to /contact. Rapidly
        // clicking Submit fires multiple POSTs before the page navigates,
        // which trips Shopify's abuse protection and redirects to /challenge.
        // Block re-entrant submits and disable the button after the first one.
        var reviewForm = modal.querySelector('form');
        if (reviewForm) {
          reviewForm.addEventListener('submit', function (e) {
            if (reviewForm.__portlSubmitting) { e.preventDefault(); return; }
            reviewForm.__portlSubmitting = true;
            var btns = reviewForm.querySelectorAll('[type="submit"]');
            // Defer disabling so the in-flight POST isn't cancelled.
            setTimeout(function () {
              btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
            }, 0);
            // Safety re-enable if navigation stalls.
            setTimeout(function () {
              reviewForm.__portlSubmitting = false;
              btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
            }, 8000);
          });
        }

        // Auto-open after Shopify form post (so user sees the success state)
        var url = window.location.href;
        if (url.indexOf('contact_posted=true') !== -1 || url.indexOf('#contact_form-success') !== -1) {
          setTimeout(openModal, 250);
        }
        // Or open if the form rendered with post-success state
        var postedSuccess = section.querySelector('.portl-review-modal__success');
        if (postedSuccess) openModal();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-reviews-pdp"] && !Shopify.designMode) return;
  try {
    
  // IntersectionObserver-driven reveal for review cards.
  // Cards animate in once when the section first enters the viewport.
  // Falls back to instantly-visible on browsers without IO (very old).
  (function () {
    function initOne(section) {
      if (!section || section.dataset.portlReviewsInit === '1') return;
      section.dataset.portlReviewsInit = '1';

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-revealed');
        return;
      }

      // Section-level observer: when ANY part of the grid enters the
      // viewport, flip the section class — every card animates with
      // its own staggered delay via --reveal-delay.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      io.observe(section);
    }

    function initAll() {
      document.querySelectorAll('[data-portl-reviews]').forEach(initOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-portl-reviews]')) {
        initAll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-social-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOnce(root) {
      if (root.dataset.portlReelsInit === '1') return;
      root.dataset.portlReelsInit = '1';
      initReels(root);
    }
    // TBT optimization: Reels sit below the fold, so defer each section's
    // (querySelectorAll + listener + observer) setup until it nears the
    // viewport instead of running it all synchronously at DOMContentLoaded
    // (which lumped into the compiled_assets/scripts.js long task). An
    // above-the-fold section fires the observer immediately, so behavior
    // is unchanged — only the timing of below-fold init moves off the
    // critical path. Falls back to eager init if IO is unsupported.
    function initAll() {
      var roots = document.querySelectorAll('.portl-social-reels');
      if (!('IntersectionObserver' in window)) {
        roots.forEach(initOnce);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { io.unobserve(en.target); initOnce(en.target); }
        });
      }, { rootMargin: '400px 0px' });
      roots.forEach(function (root) {
        if (root.dataset.portlReelsInit === '1') return;
        io.observe(root);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
    // Theme editor: re-init when sections reload
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.portl-social-reels')) {
        initAll();
      }
    });

    function initReels(root) {
      var track = root.querySelector('[data-portl-reels-track]');
      if (!track) return;

      // ── 1. Carousel controls ──────────────────────────────────
      var prev = root.querySelector('[data-portl-reels-prev]');
      var next = root.querySelector('[data-portl-reels-next]');
      var step = function () {
        var first = track.querySelector('.portl-reel-card');
        return first ? first.getBoundingClientRect().width + 12 : 320;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });

      // ── 1b. Lightbox modal (used only for cards without video) ─
      initModal(root);

      // ── 1c. Smart inline video autoplay (IntersectionObserver) ─
      initInlineVideo(root);

      // ── 1d. Dynamic Instagram view counts (optional, additive) ─
      // Refreshes ONLY the views text on each card; does not touch
      // videos, thumbnails, captions, handles, popup, or layout.
      updateViewCounts(root);

      // ── 2. Live API mode (optional) ──────────────────────────
      var endpoint = root.getAttribute('data-portl-reels-api');
      if (!endpoint) return; // No API → keep server-rendered fallback as-is

      var cacheMinutes = parseInt(root.getAttribute('data-portl-reels-cache') || '60', 10);
      var maxReels     = parseInt(root.getAttribute('data-portl-reels-max')   || '16', 10);
      var cacheKey     = 'portl-reels::' + endpoint;
      var cacheTTL     = Math.max(1, cacheMinutes) * 60 * 1000;

      // 2a. Try cache first (instant render — no network wait)
      try {
        var raw = window.localStorage && localStorage.getItem(cacheKey);
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && parsed.t && (Date.now() - parsed.t) < cacheTTL && Array.isArray(parsed.d)) {
            renderReels(track, parsed.d.slice(0, maxReels));
            // Refresh in background if cache is older than half its TTL
            if ((Date.now() - parsed.t) > cacheTTL / 2) fetchAndStore();
            return;
          }
        }
      } catch (e) { /* ignore — quota / privacy mode */ }

      // 2b. No usable cache → fetch live
      fetchAndStore();

      function fetchAndStore() {
        fetch(endpoint, { credentials: 'omit' })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (data) {
            var reels = Array.isArray(data) ? data : (data && Array.isArray(data.reels) ? data.reels : null);
            if (!reels || !reels.length) return;
            try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: reels })); } catch (e) {}
            renderReels(track, reels.slice(0, maxReels));
          })
          .catch(function () { /* network/CORS error — fallback already rendered */ });
      }
    }

    function renderReels(track, reels) {
      /* Honor the admin-configured preload strategy. Read once from
         the section root data attribute — set by Liquid based on the
         3-tier cascade (per-section > theme > default). Falls back
         to "none" if missing for any reason. */
      var sectionRoot = track.closest('.portl-social-reels');
      var preloadVal = (sectionRoot && sectionRoot.getAttribute('data-portl-reels-preload')) || 'none';
      /* Sanitize against unexpected values — only the three valid
         preload values are allowed to reach the markup. */
      if (preloadVal !== 'metadata' && preloadVal !== 'auto') preloadVal = 'none';

      var html = reels.map(function (r) {
        var permalink = sanitizeUrl(r.permalink);
        var thumb     = sanitizeUrl(r.thumbnail || r.thumb);
        var video     = sanitizeUrl(r.video_url || r.media_url || '');
        var caption   = escapeHtml(r.caption || '');
        var username  = escapeHtml(r.username || '');
        var views     = escapeHtml(r.views || '');
        var hasVideo  = !!video;
        var embedUrl  = deriveEmbedUrl(permalink);
        var embedAttr = (!hasVideo && embedUrl) ? ' data-portl-reel-embed="' + escapeHtml(embedUrl) + '"' : '';
        // PERFORMANCE: preload value honors admin choice (default "none").
        // Across ~16 dynamically-injected reels this saves ~10MB of
        // eager metadata fetch on page load when admin keeps default.
        // The IntersectionObserver at line 1020 fires .play() when each
        // reel enters the viewport regardless of preload setting.
        // Matches the SSR template above — NO autoplay attribute
        // (browsers download bytes eagerly when it's set). IO
        // observer in initInlineVideo handles play() on visibility.
        var media = hasVideo
          ? '<video class="portl-reel-card__video" data-portl-reel-video muted loop playsinline webkit-playsinline disablepictureinpicture preload="' + preloadVal + '" poster="' + (thumb || '') + '" aria-label="' + (caption || 'Instagram reel') + '">' +
              '<source src="' + video + '" type="video/mp4">' +
            '</video>'
          : (thumb ? '<img class="portl-reel-card__img" src="' + thumb + '" alt="' + (caption || 'Reel') + '" loading="lazy" decoding="async">' : '');

        return (
          '<a class="portl-reel-card' + (hasVideo ? ' portl-reel-card--has-video' : '') + '" href="' + permalink + '" target="_blank" rel="noopener noreferrer"' +
            embedAttr + ' data-portl-reel-caption="' + caption + '" data-portl-reel-handle="' + username + '">' +
            '<div class="portl-reel-card__media">' +
              media +
              '<span class="portl-reel-card__shade" aria-hidden="true"></span>' +
              '<span class="portl-reel-card__play" aria-hidden="true">' +
                '<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>' +
              '</span>' +
              (username ? '<span class="portl-reel-card__handle">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                  '<rect x="2" y="2" width="20" height="20" rx="5"/>' +
                  '<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>' +
                  '<line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>' +
                '</svg>' + username + '</span>' : '') +
              (views    ? '<span class="portl-reel-card__views">' + views + ' views</span>' : '') +
              (caption  ? '<p class="portl-reel-card__caption">' + caption + '</p>' : '') +
            '</div>' +
          '</a>'
        );
      }).join('');
      // Replace static fallback with live data
      track.innerHTML = html;

      // Re-bind smart autoplay to the freshly inserted videos
      var section = track.closest('.portl-social-reels');
      if (section) initInlineVideo(section);
    }

    // ──────────────────────────────────────────────────────────────
    // Dynamic Instagram view counts — additive overlay.
    //
    //   • Reads each card's data-portl-reel-shortcode and href.
    //   • Calls the configured backend endpoint (Shopify App Proxy or
    //     external server). Direct browser → Instagram Graph API calls
    //     are NOT possible (CORS + access tokens), so a backend proxy
    //     is required.
    //   • Updates ONLY the .portl-reel-card__views text content.
    //     Videos, thumbnails, captions, handles, animations, popup,
    //     scrolling — all untouched.
    //   • Cache-first render (localStorage, configurable TTL) so the
    //     section never waits on the network on warm visits.
    //   • Silent failure: on any error the static views (set in the
    //     theme editor) remain visible.
    //
    // Backend contract (the endpoint you wire up to Graph API):
    //   GET  {endpoint}?ids=<shortcode1>,<shortcode2>,...
    //   Auth/secrets handled server-side. CORS must allow the
    //   storefront origin (Shopify App Proxy handles this automatically).
    //   Response — any ONE of these JSON shapes is accepted:
    //     {
    //       "CxYz123": "1.2M",
    //       "AbCdEfG": { "views": "890K", "views_count": 890123 }
    //     }
    //     [ { "shortcode": "CxYz123", "views": "1.2M" }, ... ]
    //     { "reels": [ { "shortcode": "CxYz123", "views_count": 1234567 } ] }
    //   If "views" is a string, used as-is. If "views_count" is a
    //   number, it's formatted as 1.2M / 890K / 123.
    // ──────────────────────────────────────────────────────────────
    function updateViewCounts(root) {
      var endpoint = root.getAttribute('data-portl-reels-views-api');
      if (!endpoint) return;                       // No endpoint → static views remain

      var cacheMinutes = parseInt(root.getAttribute('data-portl-reels-cache') || '60', 10);
      var cacheKey = 'portl-reels-views::' + endpoint;
      var cacheTTL = Math.max(1, cacheMinutes) * 60 * 1000;

      // Collect identifiers from the DOM (shortcode preferred, full URL fallback)
      var cards = root.querySelectorAll('.portl-reel-card');
      var entries = [];
      cards.forEach(function (card) {
        var sc  = card.getAttribute('data-portl-reel-shortcode') || '';
        var url = card.getAttribute('href') || '';
        if (sc || (url && url !== '#')) {
          entries.push({ shortcode: sc, url: url, card: card });
        }
      });
      if (!entries.length) return;

      // Cache-first render (instant — no network wait)
      try {
        var raw = window.localStorage && localStorage.getItem(cacheKey);
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && parsed.t && (Date.now() - parsed.t) < cacheTTL && parsed.d) {
            applyViews(parsed.d, entries);
            // Stale-while-revalidate — refresh in background past half TTL
            if ((Date.now() - parsed.t) > cacheTTL / 2) fetchAndApply();
            return;
          }
        }
      } catch (e) { /* quota / privacy mode — ignore */ }

      fetchAndApply();

      function fetchAndApply() {
        var ids = entries.map(function (e) { return e.shortcode || e.url; }).filter(Boolean);
        var sep = endpoint.indexOf('?') >= 0 ? '&' : '?';
        var url = endpoint + sep + 'ids=' + encodeURIComponent(ids.join(','));

        fetch(url, { credentials: 'omit' })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (data) {
            var map = normalizeViewsResponse(data);
            if (!map || !Object.keys(map).length) return;
            try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: map })); } catch (e) {}
            applyViews(map, entries);
          })
          .catch(function () { /* network/CORS/server error — keep static numbers */ });
      }

      function normalizeViewsResponse(data) {
        // Accept four response shapes — see backend contract comment above.
        var map = {};
        if (!data) return map;

        if (Array.isArray(data)) {
          data.forEach(function (item) {
            if (!item) return;
            var key = item.shortcode || item.id;
            if (!key) return;
            map[key] = item.views || formatViews(item.views_count || item.play_count);
          });
          return map;
        }
        if (Array.isArray(data.reels)) {
          data.reels.forEach(function (item) {
            if (!item) return;
            var key = item.shortcode || item.id;
            if (!key) return;
            map[key] = item.views || formatViews(item.views_count || item.play_count);
          });
          return map;
        }
        if (typeof data === 'object') {
          Object.keys(data).forEach(function (key) {
            var val = data[key];
            if (val == null) return;
            if (typeof val === 'string') {
              map[key] = val;
            } else if (typeof val === 'number') {
              map[key] = formatViews(val);
            } else if (typeof val === 'object') {
              map[key] = val.views || formatViews(val.views_count || val.play_count);
            }
          });
          return map;
        }
        return map;
      }

      function applyViews(map, entries) {
        entries.forEach(function (e) {
          var value = map[e.shortcode] || map[e.url];
          if (!value) return;                      // Unknown card — leave static value
          var el = e.card.querySelector('[data-portl-reel-views-el]');
          if (!el) return;
          // Preserve a graceful UX — only update if we have a usable value
          var clean = String(value).trim();
          if (!clean) return;
          // Match existing copy format: "<n> views"
          el.textContent = clean + ' views';
        });
      }

      function formatViews(num) {
        if (typeof num !== 'number' || isNaN(num)) return '';
        if (num >= 1e9) return (num / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
        if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
        if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
        return String(num);
      }
    }

    // Convert any reel/post URL to its /embed/ form
    function deriveEmbedUrl(url) {
      if (!url || url === '#') return '';
      var m = url.match(/\/(reel|p|tv)\/([A-Za-z0-9_-]+)/);
      if (!m) return '';
      return 'https://www.instagram.com/' + m[1] + '/' + m[2] + '/embed/';
    }

    // ──────────────────────────────────────────────────────────────
    // Smart inline video — Intersection Observer–driven autoplay
    //   • Plays muted + looping when card is in viewport (≥25%)
    //   • Pauses when out of view (saves CPU/battery)
    //   • Caps simultaneous playback to 2 (prevents lag with 16 cards)
    //   • Mobile Safari fallback: retries on first user interaction
    // ──────────────────────────────────────────────────────────────
    var MAX_CONCURRENT = 2;
    var playing = new Set();
    var pendingPlay = new Set(); // videos that wanted to play but were blocked
    var unlockBound = false;

    function initInlineVideo(root) {
      if (!('IntersectionObserver' in window)) return;

      var videos = root.querySelectorAll('[data-portl-reel-video]');
      if (!videos.length) return;

      var track = root.querySelector('[data-portl-reels-track]');

      /* ─── Active-only autoplay (Option 2) ──────────────────────────
         Of all the reels currently visible in the carousel, we play
         only ONE — the one whose horizontal center is closest to the
         track's horizontal center. Every other visible reel is loaded
         (its byte fetch starts when it enters viewport via play())
         but immediately paused.

         Trade-offs vs Option 1 (play-all-visible):
           • ~80% lower mobile CPU (1 decoder instead of 5)
           • Sidesteps iOS hardware-decoder slot limit (typically 4)
           • Saves ~60% bandwidth for users who don't watch each reel
           • Cleaner audio path — only one video producing decoded
             frames, even though they're all muted

         How active is resolved:
           • IO callback updates the visibleVideos Set
           • updateActive() picks the visible reel closest to the
             track center
           • Plays the new active, pauses the previous active
           • Re-runs on:
              - IO visibility change (scroll vertical / first paint)
              - track horizontal scroll (swipe / nav button)
              - window resize (viewport changes mid-session)
        ───────────────────────────────────────────────────────────── */
      var visibleVideos = new Set();
      var currentActive = null;

      function pickActive() {
        if (!visibleVideos.size) return null;
        /* Reference center: the track's bounding box, not the
           viewport. Track may not span the full window (max-width
           + padding) so its center is the real visual midpoint of
           the carousel. */
        var ref = (track || root).getBoundingClientRect();
        var refCenter = ref.left + ref.width / 2;
        var bestV = null;
        var bestDist = Infinity;
        visibleVideos.forEach(function (v) {
          var rect = v.getBoundingClientRect();
          var c = rect.left + rect.width / 2;
          var d = Math.abs(c - refCenter);
          if (d < bestDist) { bestDist = d; bestV = v; }
        });
        return bestV;
      }

      function updateActive() {
        var newActive = pickActive();
        if (newActive === currentActive) return;
        /* Pause previous active before starting new — avoids a
           moment where two decoders are running simultaneously. */
        if (currentActive) {
          tryPause(currentActive, currentActive.closest('.portl-reel-card'));
        }
        currentActive = newActive;
        if (newActive) {
          tryPlay(newActive, newActive.closest('.portl-reel-card'));
        }
      }

      /* Throttle scroll-driven updateActive to once per animation
         frame. Carousel-edge swipes can fire 100+ scroll events in
         a second; running pickActive() on each would burn CPU for
         no visible benefit. */
      var rafPending = false;
      function scheduleUpdate() {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () {
          rafPending = false;
          updateActive();
        });
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          var card = v.closest('.portl-reel-card');
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            visibleVideos.add(v);
          } else {
            visibleVideos.delete(v);
            /* Pause anything that just left the visible set. The
               currentActive bookkeeping happens in updateActive. */
            tryPause(v, card);
          }
        });
        /* Schedule an updateActive after this batch of entries
           has been processed — the visible set has just changed,
           so the center-most reel may have changed too. */
        scheduleUpdate();
      }, {
        threshold: [0, 0.25, 0.5, 0.75],
        rootMargin: '0px'
      });

      /* Horizontal scroll inside the carousel track moves cards
         under the viewport center without changing IO state, so we
         also listen for scroll on the track itself. Passive listener
         — never blocks the scroll. */
      if (track) {
        track.addEventListener('scroll', scheduleUpdate, { passive: true });
      }
      /* Window resize can change track center → active may change. */
      window.addEventListener('resize', scheduleUpdate, { passive: true });

      /* Modal lifecycle integration — when the lightbox opens, pause
         the inline currentActive so two videos aren't decoding at
         once (the modal one and the same reel in the carousel
         underneath the backdrop). When the modal closes, re-pick
         the active inline reel and resume it. Uses custom events so
         the modal init code stays decoupled from the inline init. */
      root.addEventListener('portl-reels:modal-open', function () {
        if (currentActive) {
          tryPause(currentActive, currentActive.closest('.portl-reel-card'));
        }
      });
      root.addEventListener('portl-reels:modal-close', function () {
        /* Clear currentActive so updateActive() treats this as a
           transition and re-fires play() on whatever's center now. */
        currentActive = null;
        scheduleUpdate();
      });

      videos.forEach(function (v) {
        // Mobile autoplay requirements (Chrome Android + iOS Safari):
        //   muted + playsinline + autoplay must ALL be present as DOM
        //   attributes (not just JS properties) for the browser to permit
        //   autoplay without a user gesture. Some browsers also need
        //   `defaultMuted = true` set BEFORE the first play attempt.
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        // autoplay attribute REMOVED: with it set, browsers eagerly
        // download bytes on first paint for ALL videos regardless of
        // preload="none". The IO observer below calls .play()
        // programmatically when each reel becomes visible — modern
        // browsers permit play() on muted videos without a gesture
        // or the autoplay attribute.
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        // Avoid PiP / fullscreen prompts on iOS
        v.setAttribute('disablepictureinpicture', '');
        v.setAttribute('disableremoteplayback', '');

        /* IMPORTANT: do NOT bump preload to "metadata" here, and do
           NOT call play() eagerly. Doing either downloads all 16
           reel videos on page load (~30MB on Home — confirmed via
           GTmetrix report). The IO observer below calls .play() the
           moment a reel crosses 25% intersection — at that point
           the browser fetches bytes, decodes, and starts playing.

           The autoplay attribute is ALSO removed from the HTML
           templates so the browser doesn't auto-download bytes on
           its own before IO fires. Play happens via JS .play() on
           muted videos, which all modern browsers permit without a
           gesture. */

        // Retry play at buffer milestones — iOS Safari sometimes
        // rejects the first play() call before HAVE_ENOUGH_DATA;
        // these handlers re-attempt once data is ready.
        var retryPlay = function () {
          // Only (re)play the CHOSEN active reel. Previously this replayed ANY
          // in-viewport reel on every canplay/loadeddata, which fought the
          // single-active model + the MAX_CONCURRENT eviction — reels paused and
          // replayed each other in a churn, flickering the play-icon overlay.
          // The active reel's own load events still fire this, so iOS keeps its
          // retry; background reels no longer get force-played.
          if (v === currentActive) tryPlay(v, v.closest('.portl-reel-card'));
        };
        v.addEventListener('loadedmetadata', retryPlay);
        v.addEventListener('loadeddata',     retryPlay);   // iOS-friendly
        v.addEventListener('canplay',        retryPlay);   // safe fallback
        // If decoding fails (404, codec, etc.), surface for diagnostics
        v.addEventListener('error', function () {
          // eslint-disable-next-line no-console
          if (window.console) console.warn('[portl-reels] video failed to load:', v.currentSrc || v.src);
        });

        // Drive the play-icon overlay from the video's ACTUAL playback state
        // rather than from the imperative tryPlay/tryPause calls. The overlay
        // (`.portl-reel-card__play` — shown when paused, hidden when playing)
        // now always matches reality and only toggles on a genuine play↔pause
        // transition, so it can't desync or flicker if some other code path
        // plays/pauses the video. `loop` videos don't fire pause on restart,
        // and `waiting`/buffering doesn't fire pause, so neither flashes the
        // icon. The existing 0.3s opacity transition smooths each change.
        var pcard = v.closest('.portl-reel-card');
        v.addEventListener('playing', function () {
          if (pcard) pcard.classList.add('portl-reel-card--is-playing');
        });
        v.addEventListener('pause', function () {
          if (pcard) pcard.classList.remove('portl-reel-card--is-playing');
        });

        io.observe(v);
      });

      // Pause everything when tab is hidden — saves battery
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          videos.forEach(function (v) { tryPause(v, v.closest('.portl-reel-card')); });
        }
      });

      bindUnlock(root);
    }

    function isInViewport(el) {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
    }

    // Mobile fallback: iOS Safari (esp. Low-Power Mode) and strict autoplay
    // policies reject .play() until any user gesture occurs. We listen on
    // EVERY interaction (not just the first) and re-attempt every viewport
    // video — both the ones that previously failed AND any new ones the IO
    // hasn't intersected yet.
    function bindUnlock(root) {
      if (unlockBound) return;
      unlockBound = true;
      var retry = function () {
        // Retry previously-blocked videos
        pendingPlay.forEach(function (v) {
          tryPlay(v, v.closest('.portl-reel-card'));
        });
        pendingPlay.clear();
        // Plus any video currently in viewport (covers IO not yet fired)
        document.querySelectorAll('.portl-social-reels [data-portl-reel-video]').forEach(function (v) {
          if (isInViewport(v)) tryPlay(v, v.closest('.portl-reel-card'));
        });
      };
      // Note: NOT { once: true } — keep listening for repeated retries.
      // `passive: true` keeps scroll smooth; `capture: true` ensures we run
      // before consumers preventDefault.
      ['touchstart', 'touchend', 'pointerdown', 'click', 'scroll'].forEach(function (evt) {
        window.addEventListener(evt, retry, { passive: true, capture: true });
      });
    }

    function tryPlay(video, card) {
      if (playing.has(video)) return;
      // Cap simultaneous playback
      if (playing.size >= MAX_CONCURRENT) {
        var first = playing.values().next().value;
        if (first) tryPause(first, first.closest('.portl-reel-card'));
      }
      // Belt-and-suspenders muting (browsers may flip it on rebind)
      video.muted = true;
      var attempt;
      try {
        attempt = video.play();
      } catch (err) {
        attempt = null;
      }
      if (attempt && typeof attempt.then === 'function') {
        attempt.then(function () {
          playing.add(video);
          pendingPlay.delete(video);
          // NOTE: `--is-playing` is intentionally NOT toggled here. The icon is
          // driven solely by the video's own `playing`/`pause` events (single
          // source of truth) so it only changes on a genuine play↔pause
          // transition. Toggling it here too double-fired and flickered it.
        }).catch(function () {
          // Autoplay blocked — queue for retry on first user interaction
          pendingPlay.add(video);
        });
      } else {
        playing.add(video);
      }
    }
    function tryPause(video, card) {
      pendingPlay.delete(video);
      if (!playing.has(video) && video.paused) return;
      video.pause();   // fires 'pause' → its listener removes `--is-playing`
      playing.delete(video);
    }

    // ──────────────────────────────────────────────────────────────
    // Lightbox modal — click thumbnail → larger video viewer with
    //   prev/next navigation. Plays the same local mp4 the thumbnail
    //   uses. First/last clamps via native button.disabled. Supports
    //   ESC, ←/→ keys, and touch-swipe.
    // ──────────────────────────────────────────────────────────────
    function initModal(root) {
      var modal     = root.querySelector('[data-portl-reel-modal]');
      if (!modal) return;
      var video     = modal.querySelector('[data-portl-reel-modal-video]');
      var permaLink = modal.querySelector('[data-portl-reel-permalink]');
      var handleEl  = modal.querySelector('[data-portl-reel-modal-handle]');
      var captionEl = modal.querySelector('[data-portl-reel-modal-caption]');
      var prevBtn   = modal.querySelector('[data-portl-reel-prev]');
      var nextBtn   = modal.querySelector('[data-portl-reel-next]');
      var stage     = modal.querySelector('[data-portl-reel-stage]');
      var closers   = modal.querySelectorAll('[data-portl-reel-close]');
      var muteBtn   = modal.querySelector('[data-portl-reel-mute]');
      var spinner   = modal.querySelector('[data-portl-reel-modal-spinner]');
      var track     = root.querySelector('[data-portl-reels-track]');

      /* ─── Loading spinner wiring ──────────────────────────────────
         Shows the spinner whenever the video is buffering (waiting
         event) or in a not-yet-playable state. Hides on canplay /
         playing (bytes ready / decoding started). This covers:
           • Initial cold load on slow networks
           • Mid-playback rebuffering when the connection drops
           • iOS first-frame decode delay
         No-op if the spinner element is missing (defensive). */
      function showSpinner() {
        if (spinner) spinner.classList.add('is-visible');
      }
      function hideSpinner() {
        if (spinner) spinner.classList.remove('is-visible');
      }
      if (video && spinner) {
        /* `waiting` fires when the browser needs more data to
           continue playing. `stalled` fires when bytes arrive
           too slowly. Both → show spinner. */
        video.addEventListener('waiting', showSpinner);
        video.addEventListener('stalled', showSpinner);
        /* `canplay` fires when enough data is buffered to start
           playing without buffering. `playing` fires when actual
           decoding/rendering begins. Both → hide spinner. */
        video.addEventListener('canplay', hideSpinner);
        video.addEventListener('playing', hideSpinner);
        /* Errors should also hide the spinner so the user isn't
           left staring at a spinner that will never resolve. */
        video.addEventListener('error', hideSpinner);
      }

      var current = 0;
      var cards = [];

      function refreshCards() {
        cards = Array.prototype.slice.call(track.querySelectorAll('.portl-reel-card'));
      }

      // Pull video src + meta off a card. Uses the same local mp4 as the
      // thumbnail when present (data-portl-reel-video <source>), otherwise
      // falls back to the IG embed iframe in a new tab on close.
      function getCardData(card) {
        // Reel (autoplay) src — same local mp4 the thumbnail uses.
        var v = card.querySelector('[data-portl-reel-video]');
        var reelSrc = '';
        if (v) {
          var s = v.querySelector('source');
          if (s && s.getAttribute('src')) reelSrc = s.getAttribute('src');
          else if (v.getAttribute('src')) reelSrc = v.getAttribute('src');
        }
        // Optional separate popup video (admin-uploaded, never preloaded).
        // When present it's used in the popup INSTEAD of the reel video;
        // when absent we fall back to the reel src — preserving current
        // behavior, including for API-driven cards that have no popup attr.
        var popupSrc = card.getAttribute('data-portl-reel-popup-video') || '';
        return {
          src:      popupSrc || reelSrc,
          caption:  card.getAttribute('data-portl-reel-caption') || '',
          handle:   card.getAttribute('data-portl-reel-handle')  || '',
          permalink: card.getAttribute('href') || '#'
        };
      }

      function loadIndex(idx) {
        if (idx < 0 || idx >= cards.length) return;
        current = idx;
        var data = getCardData(cards[idx]);

        // Update video src + reset playback position.
        // CRITICAL: iOS Safari requires .load() after src change. Without
        // it, the video silently keeps the previous source's state and
        // .play() either does nothing or shows the "unsupported media"
        // strikethrough icon. Using a <source> child + load() is the most
        // reliable cross-browser pattern.
        if (data.src) {
          // New slide → fresh start; clear any prior user-pause intent so the
          // next reel autoplays on open / prev-next navigation.
          modal._userPaused = false;
          /* Show the spinner the moment we start loading a new src.
             It'll auto-hide when canplay/playing fires (in the
             listeners set up at the top of initModal). This covers
             the gap BEFORE the first `waiting` event fires — that
             event only emits if the video runs out of buffered data
             during playback, but the initial cold load can take
             time too. */
          showSpinner();
          // Clear and rebuild — guarantees iOS picks up the new resource
          while (video.firstChild) video.removeChild(video.firstChild);
          video.removeAttribute('src');
          var src = document.createElement('source');
          src.setAttribute('src', data.src);
          src.setAttribute('type', 'video/mp4');
          video.appendChild(src);
          // Honor the user's last mute choice across slide changes.
          // - First open: starts UNMUTED (sound on) since the click is a valid
          //   user gesture for autoplay-with-sound.
          // - User taps mute → preferMuted = true → next slide stays muted.
          // - User taps unmute → preferMuted = false → next slide plays with sound.
          // Apply user's mute preference (false = sound on by default)
          var startMuted = !!modal._preferMuted;
          if (startMuted) {
            video.muted = true;
            video.defaultMuted = true;
            video.setAttribute('muted', '');
          } else {
            video.removeAttribute('muted');
            video.muted = false;
            video.defaultMuted = false;
            video.volume = 1;
          }
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          try { video.load(); } catch (e) {}

          // CRITICAL: Call play() SYNCHRONOUSLY here, in the same call stack
          // as the user's click. Browsers (especially Chrome) only honor
          // unmuted autoplay if play() runs INSIDE the gesture's task.
          // Waiting for async events (canplay/loadedmetadata) loses gesture
          // context and forces a mute fallback. The browser queues this play
          // request and starts playback once data is buffered — with sound.
          var playWithFallback = function () {
            try {
              var p = video.play();
              if (p && typeof p.then === 'function') {
                p.catch(function () {
                  // Browser explicitly rejected unmuted play — only NOW mute.
                  // (NotAllowedError is the autoplay-policy rejection.)
                  if (!video.muted) {
                    video.muted = true;
                    video.defaultMuted = true;
                    video.setAttribute('muted', '');
                    try { video.play().catch(function () {}); } catch (err) {}
                  }
                });
              }
            } catch (e) {
              if (!video.muted) {
                video.muted = true;
                video.defaultMuted = true;
                video.setAttribute('muted', '');
                try { video.play().catch(function () {}); } catch (err) {}
              }
            }
          };
          // First play() call — synchronous, in user-gesture context.
          playWithFallback();
          // iOS sometimes needs a re-attempt after metadata is parsed.
          // Only retry if the video is still paused (first attempt didn't take).
          var retryOnce = function () {
            video.removeEventListener('loadedmetadata', retryOnce);
            video.removeEventListener('canplay',        retryOnce);
            // Re-attempt ONLY if still paused, and do NOT mute on failure.
            // The original code called playWithFallback() here, which mutes
            // on rejection — but this retry runs AFTER the click gesture has
            // ended, so an unmuted play() is rejected by autoplay policy and
            // the video gets silently muted. That is exactly what silenced
            // freshly-loaded (cold) popup videos: their in-gesture play() is
            // still buffering when canplay fires, so this retry ran and muted
            // them. Preserve the user's unmuted intent from the open gesture;
            // the queued gesture-play resolves with sound once buffered. If a
            // strict browser still blocks it, the video stays paused and the
            // next tap (play / unmute) starts it with sound.
            if (video.paused && !modal._userPaused) {
              try {
                var rp = video.play();
                if (rp && typeof rp.then === 'function') rp.catch(function () {});
              } catch (e) {}
            }
          };
          video.addEventListener('loadedmetadata', retryOnce, { once: true });
          video.addEventListener('canplay',        retryOnce, { once: true });
        } else {
          while (video.firstChild) video.removeChild(video.firstChild);
          video.removeAttribute('src');
          try { video.load(); } catch (e) {}
        }

        // Meta
        if (handleEl)  handleEl.textContent  = data.handle;
        if (captionEl) captionEl.textContent = data.caption;
        if (permaLink) permaLink.setAttribute('href', data.permalink);

        updateNavState();
      }

      function updateNavState() {
        var atStart = current <= 0;
        var atEnd   = current >= cards.length - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }

      function next() { if (current < cards.length - 1) loadIndex(current + 1); }
      function prev() { if (current > 0)               loadIndex(current - 1); }

      // ── Tap / click delegation ─────────────────────────────────
      // iOS Safari often suppresses synthetic 'click' after a touch that
      // moved (even slightly) during horizontal scroll. We detect a tap
      // (no significant movement) on touchend and fire openModal directly,
      // and still keep a click listener as the primary path for desktop +
      // Android. A short guard window prevents double-firing.
      var lastOpenTs = 0;
      var openFromCard = function (card) {
        if (!card) return;
        if (Date.now() - lastOpenTs < 400) return;  // dedupe touchend + click
        lastOpenTs = Date.now();
        refreshCards();
        var idx = cards.indexOf(card);
        if (idx === -1) idx = 0;
        openModal(idx);
      };

      track.addEventListener('click', function (e) {
        var card = e.target.closest('.portl-reel-card');
        if (!card) return;
        e.preventDefault();
        openFromCard(card);
      });

      // Touch fallback: distinguish tap (small movement) from scroll-swipe
      var touchStartX = 0, touchStartY = 0, touchStartCard = null;
      track.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        var t = e.target;
        touchStartCard = (t && t.closest) ? t.closest('.portl-reel-card') : null;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (!touchStartCard) return;
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) { touchStartCard = null; return; }
        var dx = Math.abs(t.clientX - touchStartX);
        var dy = Math.abs(t.clientY - touchStartY);
        // Treat anything under 10px movement as a tap, even if the
        // browser later decides to swallow the synthetic click.
        if (dx < 10 && dy < 10) {
          // preventDefault on the underlying anchor's default nav.
          // Safe in passive listener — only blocks the synthetic click
          // by firing openModal first; we don't actually preventDefault
          // here (passive disallows it). The click listener above will
          // be deduped by lastOpenTs.
          openFromCard(touchStartCard);
        }
        touchStartCard = null;
      }, { passive: true });

      // ── Buttons ──
      if (prevBtn) prevBtn.addEventListener('click', function (e) {
        if (prevBtn.disabled) { e.preventDefault(); return; }
        prev();
      });
      if (nextBtn) nextBtn.addEventListener('click', function (e) {
        if (nextBtn.disabled) { e.preventDefault(); return; }
        next();
      });
      closers.forEach(function (btn) { btn.addEventListener('click', closeModal); });

      // ── Mute toggle — PERSISTENT across slide changes ──
      // The user's mute preference is stored on `modal._preferMuted`.
      // - Default open: unmuted (sound on)
      // - User taps mute → preferMuted = true → ALL subsequent slides start muted
      // - User taps unmute → preferMuted = false → ALL subsequent slides start unmuted
      // This avoids the "I muted one and the next one blasted again" UX problem.
      if (muteBtn && video) {
        // Initial state: unmuted by default
        modal._preferMuted = false;

        var setMuteState = function (muted) {
          video.muted = muted;
          // Fully clear/apply the muted CONTENT attribute + defaultMuted too.
          // The cold-load fallback path may have set the `muted` attribute and
          // defaultMuted=true; just flipping the .muted property can leave those
          // lingering and cause some browsers to re-mute on the next load().
          // Clearing them on unmute (and restoring full volume) makes the
          // Unmute button reliably enable sound across browsers/iOS.
          video.defaultMuted = muted;
          if (muted) {
            video.setAttribute('muted', '');
          } else {
            video.removeAttribute('muted');
            video.volume = 1;
          }
          modal._preferMuted = muted;       // persist across slides
          muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
        };
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          setMuteState(!video.muted);
          // Re-attempt play in case unmute paused the video
          if (!video.muted) {
            try {
              var p = video.play();
              if (p && typeof p.then === 'function') p.catch(function () {});
            } catch (err) {}
          }
        });
        // Sync icon state if video.muted changes via other means
        video.addEventListener('volumechange', function () {
          muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        });
      }

      // Tap the video itself toggles play/pause (replaces the iOS native
      // controls UI we just removed).
      if (video) {
        video.addEventListener('click', function () {
          if (video.paused) {
            modal._userPaused = false;
            try {
              var p = video.play();
              if (p && typeof p.then === 'function') p.catch(function () {});
            } catch (e) {}
          } else {
            // User explicitly paused — remember it so the cold-load retry
            // (retryOnce) doesn't re-play behind their back and flicker.
            modal._userPaused = true;
            video.pause();
          }
        });
      }

      // ── Keyboard ──
      document.addEventListener('keydown', function (e) {
        if (modal.hidden) return;
        if (e.key === 'Escape')     closeModal();
        else if (e.key === 'ArrowRight') next();
        else if (e.key === 'ArrowLeft')  prev();
      });

      // ── Touch swipe support on the stage ──
      // Mobile (≤768px): vertical swipe (TikTok / Reels style)
      //   • Swipe UP   → next reel
      //   • Swipe DOWN → previous reel
      // Desktop (>768px): horizontal swipe (matches arrow direction)
      //   • Swipe LEFT  → next, RIGHT → prev
      if (stage) {
        var startX = 0, startY = 0, isDragging = false;
        stage.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches[0]) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isDragging = true;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (!isDragging) return;
          isDragging = false;
          var t = (e.changedTouches && e.changedTouches[0]);
          if (!t) return;
          var dx = t.clientX - startX;
          var dy = t.clientY - startY;
          var isMobile = window.innerWidth <= 768;
          var THRESHOLD = 40;

          if (isMobile) {
            // Vertical swipe dominates
            if (Math.abs(dy) > THRESHOLD && Math.abs(dy) > Math.abs(dx)) {
              if (dy < 0) next();  // swipe UP   → next
              else        prev();  // swipe DOWN → prev
            }
          } else {
            // Horizontal swipe dominates
            if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
              if (dx < 0) next();  // swipe LEFT  → next
              else        prev();  // swipe RIGHT → prev
            }
          }
        }, { passive: true });

        // Mobile bonus: wheel-scroll inside modal also navigates (trackpad/scroll wheel)
        var wheelLock = 0;
        stage.addEventListener('wheel', function (e) {
          if (window.innerWidth > 768) return;
          var now = Date.now();
          if (now < wheelLock) return;
          if (Math.abs(e.deltaY) < 30) return;
          wheelLock = now + 500;
          if (e.deltaY > 0) next();
          else prev();
        }, { passive: true });
      }

      function openModal(idx) {
        refreshCards();
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        // Lock background scroll. The root scroll container in this theme is
        // <html> (body only has overflow-x:clip), so locking <body> alone
        // left the page scrollable behind the modal — lock both.
        document.documentElement.classList.add('portl-reel-modal-open');
        document.body.classList.add('portl-reel-modal-open');
        /* Notify the inline-video controller to pause the inline
           currentActive. Saves a decoder slot for the modal video
           and prevents audio mixer overlap. */
        try { root.dispatchEvent(new CustomEvent('portl-reels:modal-open')); } catch (e) {}
        loadIndex(idx);
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
      }
      function closeModal() {
        modal.classList.remove('is-open');
        try { video.pause(); } catch (e) {}
        setTimeout(function () {
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
          // Drop src + clear <source> children to free memory + stop downloads
          while (video.firstChild) video.removeChild(video.firstChild);
          video.removeAttribute('src');
          try { video.load(); } catch (e) {}
          document.documentElement.classList.remove('portl-reel-modal-open');
          document.body.classList.remove('portl-reel-modal-open');
          /* Resume inline autoplay on the carousel reel that's now
             at center (which may be the one the user just navigated
             to inside the modal via prev/next). */
          try { root.dispatchEvent(new CustomEvent('portl-reels:modal-close')); } catch (e) {}
        }, 250);
      }
    }

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }
    function sanitizeUrl(url) {
      url = String(url || '');
      // Allow only http(s) URLs to avoid javascript: injection
      if (!/^https?:\/\//i.test(url)) return '#';
      return url.replace(/"/g, '%22');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-split-feature"] && !Shopify.designMode) return;
  try {
    
  // iOS-safe autoplay for split-feature videos, with PERFORMANCE gating.
  // The HTML uses preload="none" + no autoplay — we only call .play()
  // when the video scrolls into the viewport, and pause on scroll-out.
  // Saves ~3-4MB of eager metadata fetch when the section is below fold.
  (function () {
    function attemptPlay(v) {
      try {
        var p = v.play();
        if (p && typeof p.then === 'function') p.catch(function () {});
      } catch (e) {}
    }
    function init(root) {
      root = root || document;
      var videos = root.querySelectorAll('[data-portl-split-video]');
      if (!videos.length) return;
      videos.forEach(function (v) {
        if (v.dataset.portlSplitInit === '1') return;
        v.dataset.portlSplitInit = '1';
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');

        if ('IntersectionObserver' in window) {
          var splitIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                attemptPlay(v);
                if (!v.__portlSplitWired) {
                  v.__portlSplitWired = true;
                  v.addEventListener('loadedmetadata', function () { attemptPlay(v); }, { once: true });
                  v.addEventListener('canplay',        function () { attemptPlay(v); }, { once: true });
                }
              } else {
                try { v.pause(); } catch (e) {}
              }
            });
          }, { threshold: 0.15, rootMargin: '200px 0px' });
          splitIO.observe(v);
        } else {
          /* No IntersectionObserver — preserve eager-play fallback. */
          attemptPlay(v);
          v.addEventListener('loadedmetadata', function () { attemptPlay(v); }, { once: true });
          v.addEventListener('canplay',        function () { attemptPlay(v); }, { once: true });
        }
      });
    }
    // TBT: below-fold section — defer init until it nears the viewport
    // instead of running its setup at DOMContentLoaded. init() unchanged.
    function whenVisible() {
      var els = document.querySelectorAll('[data-portl-split-video]');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { init(document); return; }
      var io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) { io.disconnect(); init(document); break; }
        }
      }, { rootMargin: '400px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenVisible, { once: true });
    } else {
      whenVisible();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-sticky-feature"] && !Shopify.designMode) return;
  try {
    
  // ──────────────────────────────────────────────────────────────
  // Click-driven scene cycler.
  //   • Arrows + dots advance/jump between scenes
  //   • Active title fades in, inactives fade out
  //   • Optional autoplay (paused on hover)
  //   • iOS-safe video autoplay
  // ──────────────────────────────────────────────────────────────
  (function () {
    function init(root) {
      root = root || document;
      var sections = root.querySelectorAll('[data-portl-sticky]');
      if (!sections.length) return;

      sections.forEach(function (section) {
        if (section.dataset.portlStickyInit === '1') return;
        section.dataset.portlStickyInit = '1';

        var titles  = section.querySelectorAll('[data-portl-sticky-title]');
        var dots    = section.querySelectorAll('[data-portl-sticky-dot]');
        var prevBtn = section.querySelector('[data-portl-sticky-prev]');
        var nextBtn = section.querySelector('[data-portl-sticky-next]');
        var video   = section.querySelector('[data-portl-sticky-video]');
        var count   = parseInt(section.getAttribute('data-scene-count') || '0', 10);
        var auto    = parseInt(section.getAttribute('data-autoplay')    || '0', 10);
        var videoAutoplay = section.getAttribute('data-video-autoplay') !== 'false';

        if (count <= 0) return;

        // iOS-safe video autoplay
        // PERFORMANCE: gate .play() behind IntersectionObserver so
        // the MP4 doesn't download until the section enters the
        // viewport. The HTML template now uses `preload="none"`
        // (no eager metadata fetch) and `autoplay` is removed, so
        // calling .play() here is what actually triggers the network
        // request. Section pauses on scroll-out → saves battery.
        if (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          var attemptPlay = function () {
            try {
              var p = video.play();
              if (p && typeof p.then === 'function') p.catch(function () {});
            } catch (e) {}
          };
          /* Expose a one-shot play so manual navigation can start the
             video when auto-play is OFF (admin: "Auto-play background
             video" unchecked → no scroll-triggered playback). */
          section.__portlPlayVideo = attemptPlay;

          if ('IntersectionObserver' in window) {
            var stIO = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  /* Only auto-play on scroll when enabled. When disabled the
                     video waits paused on its poster for a manual nav click. */
                  if (videoAutoplay) {
                    attemptPlay();
                    /* Wire metadata/canplay retries the first time we
                       enter viewport — some iOS builds refuse the first
                       play even when muted; these listeners catch it. */
                    if (!video.__portlStickyWired) {
                      video.__portlStickyWired = true;
                      video.addEventListener('loadedmetadata', attemptPlay, { once: true });
                      video.addEventListener('canplay',        attemptPlay, { once: true });
                    }
                  }
                } else {
                  try { video.pause(); } catch (e) {}
                }
              });
            }, { threshold: 0.15, rootMargin: '200px 0px' });
            stIO.observe(section);
          } else if (videoAutoplay) {
            /* No IntersectionObserver — preserve eager-play fallback. */
            attemptPlay();
            video.addEventListener('loadedmetadata', attemptPlay, { once: true });
            video.addEventListener('canplay',        attemptPlay, { once: true });
          }
        }

        var current = 0;
        var setActive = function (idx) {
          if (idx < 0) idx = 0;
          if (idx >= count) idx = count - 1;
          if (idx === current && section.dataset.portlStickyReady === '1') return;
          section.dataset.portlStickyReady = '1';
          current = idx;

          titles.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
          dots.forEach(function (el, i) {
            el.classList.toggle('is-active', i === idx);
            el.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
          if (prevBtn) prevBtn.disabled = idx <= 0;
          if (nextBtn) nextBtn.disabled = idx >= count - 1;
        };

        // Initial state
        setActive(0);

        // When auto-play is OFF, start the video on the first manual
        // navigation (arrow / dot / keyboard) — per the click-to-play brief.
        var playOnNav = function () {
          if (!videoAutoplay && section.__portlPlayVideo) section.__portlPlayVideo();
        };

        // Manual nav
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            stopAuto();
            playOnNav();
            var idx = parseInt(dot.getAttribute('data-portl-sticky-dot') || '0', 10);
            setActive(idx);
          });
        });
        if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); playOnNav(); setActive(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); playOnNav(); setActive(current + 1); });

        // Keyboard support when section is focused
        section.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft')  { setActive(current - 1); stopAuto(); playOnNav(); }
          if (e.key === 'ArrowRight') { setActive(current + 1); stopAuto(); playOnNav(); }
        });

        // Optional auto-rotate
        var timer = null;
        var startAuto = function () {
          if (!auto || auto < 1500) return;
          stopAuto();
          timer = setInterval(function () {
            setActive((current + 1) % count);
          }, auto);
        };
        var stopAuto = function () {
          if (timer) { clearInterval(timer); timer = null; }
        };
        section.addEventListener('mouseenter', stopAuto);
        section.addEventListener('mouseleave', startAuto);
        startAuto();
      });
    }

    // TBT: below-fold section — defer init until it nears the viewport
    // instead of running its setup at DOMContentLoaded. init() unchanged.
    function whenVisible() {
      var els = document.querySelectorAll('[data-portl-sticky]');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { init(document); return; }
      var io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) { io.disconnect(); init(document); break; }
        }
      }, { rootMargin: '400px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenVisible, { once: true });
    } else {
      whenVisible();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-studio-design"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReveal(root) {
      var cards = root.querySelectorAll('[data-sdesign-card]');
      if (!cards.length) return;

      if (!('IntersectionObserver' in window)) {
        cards.forEach(function (c) { c.setAttribute('data-in-view', 'true'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.setAttribute('data-in-view', 'true');
            io.unobserve(e.target);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px'
      });
      cards.forEach(function (c) { io.observe(c); });
    }

    function initAll() {
      document.querySelectorAll('.portl-sdesign[data-section-id]').forEach(initReveal);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.portl-sdesign[data-section-id]') : null;
      if (root) initReveal(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-studio-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      var items = root.querySelectorAll('[data-portl-sfaq-item]');
      items.forEach(function (item) {
        var btn    = item.querySelector('[data-portl-sfaq-toggle]');
        var answer = item.querySelector('[data-portl-sfaq-answer]');
        if (!btn || !answer) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          if (isOpen) {
            item.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }
    function initAll() {
      document.querySelectorAll('.portl-sfaq[data-section-id]').forEach(initFaq);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.portl-sfaq[data-section-id]') : null;
      if (root) initFaq(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-studio-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      var track = root.querySelector('[data-portl-sgal-track]');
      var prev  = root.querySelector('[data-portl-sgal-prev]');
      var next  = root.querySelector('[data-portl-sgal-next]');
      if (!track || !prev || !next) return;

      var originals = Array.prototype.slice.call(root.querySelectorAll('.portl-sgal__slide'));
      var n = originals.length;
      if (!n) return;

      // ─── Infinite loop via cloned copies ───────────────────────────────
      // Layout becomes [clone set][originals][clone set]. Because a clone is a
      // pixel-identical copy of its original, silently re-centering the scroll
      // from a clone to the matching original (once a swipe/scroll has settled)
      // is INVISIBLE — no flicker, no snap-back. Native scroll is untouched, so
      // mouse drag, touch swipe and trackpad all keep working. Loop only when
      // there is more than one slide.
      var looping = n > 1;
      var slides = originals;
      if (looping) {
        var leftFrag = document.createDocumentFragment();
        var rightFrag = document.createDocumentFragment();
        originals.forEach(function (sl) {
          var cl = sl.cloneNode(true);
          cl.setAttribute('data-clone', '1'); cl.setAttribute('aria-hidden', 'true'); cl.removeAttribute('id');
          leftFrag.appendChild(cl);
          var cr = sl.cloneNode(true);
          cr.setAttribute('data-clone', '1'); cr.setAttribute('aria-hidden', 'true'); cr.removeAttribute('id');
          rightFrag.appendChild(cr);
        });
        track.insertBefore(leftFrag, originals[0]);
        track.appendChild(rightFrag);
        slides = Array.prototype.slice.call(track.querySelectorAll('.portl-sgal__slide'));
      }

      // Arrows never dead-end while looping — always enabled.
      function updateButtons() {
        var atStart = false, atEnd = false;
        if (!looping) {
          var max = track.scrollWidth - track.clientWidth;
          atStart = track.scrollLeft <= 2;
          atEnd = max <= 0 || track.scrollLeft >= max - 2;
        }
        prev.disabled = atStart; next.disabled = atEnd;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      function centerDelta(slide) {
        var tr = track.getBoundingClientRect(), sr = slide.getBoundingClientRect();
        return (sr.left + sr.width / 2) - (tr.left + tr.width / 2);
      }
      // DOM index of the slide nearest the track centre.
      function centeredDom() {
        var tr = track.getBoundingClientRect(), tc = tr.left + tr.width / 2;
        var best = 0, bd = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var r = slides[i].getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - tc);
          if (d < bd) { bd = d; best = i; }
        }
        return best;
      }
      // Width of one full set = distance between a slide and its +n clone.
      function setWidth() { return looping ? (slides[n].offsetLeft - slides[0].offsetLeft) : 0; }

      function scrollToDom(idx, smooth) {
        if (!looping) idx = Math.max(0, Math.min(slides.length - 1, idx));
        var slide = slides[idx];
        if (!slide) return;
        track.scrollTo({ left: track.scrollLeft + centerDelta(slide), behavior: smooth ? 'smooth' : 'auto' });
        updateButtons();
      }

      // Instant scroll jump. The track's CSS sets `scroll-behavior: smooth`,
      // which would otherwise ANIMATE a `scrollLeft` change — turning the loop
      // reset into a visible slide-back. Temporarily forcing `auto` makes the
      // reposition a single, imperceptible frame between identical slides.
      function jumpBy(px) {
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft += px;
        track.style.scrollBehavior = prevBehavior;
      }

      // Re-center the middle set once the scroll has settled. The jump is by
      // exactly one set width, between identical clone/original → invisible.
      function recenter() {
        if (!looping) return;
        var dom = centeredDom(), sw = setWidth();
        if (sw <= 0) return;
        if (dom < n) { jumpBy(sw); }
        else if (dom >= 2 * n) { jumpBy(-sw); }
      }

      // Pre-recenter before each arrow move so rapid clicks can never run out of
      // the clone buffer (no dead-end), then step one slide.
      prev.addEventListener('click', function (e) {
        if (prev.disabled) { e.preventDefault(); return; }
        recenter(); scrollToDom(centeredDom() - 1, true);
      });
      next.addEventListener('click', function (e) {
        if (next.disabled) { e.preventDefault(); return; }
        recenter(); scrollToDom(centeredDom() + 1, true);
      });

      // ── Endless in EVERY input mode ────────────────────────────────────
      // Trackpad / wheel fire `wheel` events and scroll CONTINUOUSLY with no
      // natural settle — so while wheeling we recenter LIVE every frame the
      // moment the centred slide reaches a clone, keeping the track permanently
      // inside the middle set (it can never reach the physical scroll end).
      // Touch never fires `wheel`, so it is left to the debounced settle
      // recenter — setting scrollLeft mid-touch-momentum would fight iOS inertia
      // and, with scroll-snap, a swipe already snaps + settles one slide at a
      // time so the buffer is never exhausted.
      var wheeling = false, wheelTimer = null;
      track.addEventListener('wheel', function () {
        wheeling = true;
        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function () { wheeling = false; }, 200);
      }, { passive: true });

      var rafPending = false, settleTimer = null;
      track.addEventListener('scroll', function () {
        if (!rafPending) {
          rafPending = true;
          requestAnimationFrame(function () {
            rafPending = false;
            updateButtons();
            if (wheeling) recenter();
          });
        }
        clearTimeout(settleTimer);
        settleTimer = setTimeout(recenter, 100);
      }, { passive: true });

      // ── Mouse click-drag to scroll (native scroll containers don't do this).
      // A drag is bounded (≤ viewport width < one clone set), so we recenter
      // when it ends. Touch/pen keep native scrolling. A click fired right after
      // a real drag is suppressed so cards/links aren't triggered.
      var dragging = false, dragStartX = 0, dragStartLeft = 0, dragMoved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; dragMoved = false;
        dragStartX = e.clientX; dragStartLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 3) dragMoved = true;
        var pb = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = dragStartLeft - dx;
        track.style.scrollBehavior = pb;
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        recenter();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) {
        if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
      }, true);

      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();

      // Center the START slide once inside the middle set — the SAME lightweight
      // init the working modes carousel uses (center once, then leave it alone).
      //
      // ROOT CAUSE of this section behaving differently: the previous version
      // ALSO re-asserted this centering on `window.load` and `pageshow`, gated
      // only by a `userMoved` flag set on TRACK pointerdown — but NOT on arrow
      // clicks. A visitor navigating with the arrows never tripped the flag, so a
      // late image `load` (large hero images finishing) or a bfcache restore
      // snapped the track back to the start mid-session: the "internal reset".
      // We now re-center ONLY while the visitor has not interacted at all
      // (arrows, drag, or wheel), and never on load/bfcache.
      function startReal() { return (window.innerWidth >= 1024 && n > 1) ? 1 : 0; }
      function centerStart() {
        var domIdx = looping ? (n + startReal()) : startReal();
        var slide = slides[domIdx];
        if (!slide) return;
        jumpBy(centerDelta(slide));
        updateButtons();
      }
      var moved = false;
      function markMoved() { moved = true; }
      track.addEventListener('pointerdown', markMoved, { passive: true });
      track.addEventListener('wheel', markMoved, { passive: true });
      prev.addEventListener('click', markMoved);
      next.addEventListener('click', markMoved);
      centerStart();
      requestAnimationFrame(function () { if (!moved) centerStart(); });
    }

    function initAll() {
      document.querySelectorAll('.portl-sgal[data-section-id]').forEach(initGallery);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.portl-sgal[data-section-id]') : null;
      if (root) initGallery(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-studio-hero-pinned"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.portl-shp[data-section-id]').forEach(function (root) {
      var panels = root.querySelectorAll('[data-shp-panel]');
      if (!panels.length) return;

      var lastStage = -1;
      var lastPinState = '';
      var lastTransitioning = false;
      var stageChangeLockUntil = 0;

      // All 3 videos now have autoplay + preload=metadata so they're ALL
      // already playing silently in the background by the time the user
      // reaches each stage. No deferred arming needed.

      // Belt-and-braces: ensure all 3 videos are actually playing
      // (browsers throttle muted autoplay on videos behind opacity:0 — they
      // load metadata but never start playback, so the element renders black
      // when its stage activates). Manually firing play() bypasses this.
      // SKIP any <video data-shp-loop-deferred> — those are the
      // Stage-1 loop variant that must wait until the intro `ended`
      // event fires before starting (see the intro→loop handoff below).
      function ensurePlaying() {
        root.querySelectorAll('video').forEach(function (v) {
          if (v.hasAttribute('data-shp-loop-deferred')) return;
          if (v.paused || v.readyState < 2) {
            try { v.preload = 'auto'; } catch (e) {}
            var p = v.play();
            if (p && typeof p.then === 'function') p.catch(function () {});
          }
        });
      }

      // ── Stage 1 intro → loop handoff ──────────────────────────
      // Plays the non-looping intro once; when it ends, crossfades
      // to the looping background video. Fully self-contained — does
      // NOT touch stages 2 or 3.
      root.querySelectorAll('[data-shp-stage1-intro]').forEach(function (intro) {
        var stage1 = intro.closest('.portl-shp__vid--1');
        if (!stage1) return;
        var loop = stage1.querySelector('[data-shp-stage1-loop]');
        if (!loop) return;

        function activateLoop() {
          if (stage1.classList.contains('is-looping')) return; // idempotent
          stage1.classList.add('is-looping');
          loop.removeAttribute('data-shp-loop-deferred');
          try { loop.currentTime = 0; } catch (e) {}
          var p = loop.play();
          if (p && typeof p.then === 'function') p.catch(function () {});
        }

        intro.addEventListener('ended', activateLoop);
        // Safety nets: if the intro errors out or the browser blocks
        // autoplay so the intro never starts, fall back to the loop
        // so the hero never sits on a frozen poster frame.
        intro.addEventListener('error', activateLoop);
      });
      // Kick all videos into "playing" state on init AND when DOM is ready
      ensurePlaying();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ensurePlaying);
      }
      window.addEventListener('load', ensurePlaying);
      // Also nudge again after a short delay (covers slow-network mobile)
      setTimeout(ensurePlaying, 1000);
      setTimeout(ensurePlaying, 3000);

      function setStage(s) {
        if (s === lastStage) return;
        lastStage = s;
        root.setAttribute('data-stage', String(s));
        // Brief 250ms lock so the dark veil masks the start of the
        // 0.45s opacity crossfade between videos. Reduced from 550ms
        // (the long lock made the dark phase feel like a "black screen").
        stageChangeLockUntil = Date.now() + 250;
        ensurePlaying();
        setTimeout(requestEval, 260);
      }
      function setPinState(state) {
        if (state === lastPinState) return;
        lastPinState = state;
        root.setAttribute('data-pinned', state);
      }
      function setTransitioning(t) {
        if (t === lastTransitioning) return;
        lastTransitioning = t;
        root.setAttribute('data-transitioning', t ? 'true' : 'false');
      }

      // Main eval — runs on every panel intersection change.
      // Overlay is dark only while we're within the 250ms post-stage-change lock.
      function evaluate() {
        var withinStageLock = Date.now() < stageChangeLockUntil;
        setTransitioning(withinStageLock);
      }
      var evalRaf = null;
      function requestEval() {
        if (evalRaf == null) evalRaf = requestAnimationFrame(function () {
          evalRaf = null; evaluate();
        });
      }

      // Direct scroll-based stage calculator — no IntersectionObserver
      // (IO + sticky had timing issues on fast scrolls). This computes
      // section bounds + viewport center every scroll frame and picks the
      // panel whose midpoint is closest to viewport center.
      //
      //   Section layout: panel-1 (100vh) | panel-2 (170vh) | panel-3 (170vh)
      //   Panel midpoints from section top: 50vh, 185vh, 355vh
      //   Section total: 440vh
      var pinBg      = root.querySelector('.portl-shp__pin-bg');
      var pinOverlay = root.querySelector('.portl-shp__overlay-fixed');

      var rafScroll = null;
      function onScroll() {
        if (rafScroll != null) return;
        rafScroll = requestAnimationFrame(function () {
          rafScroll = null;
          var rect = root.getBoundingClientRect();
          var vh = window.innerHeight;

          // Pin lifecycle:
          //   active    → fixed, covering the viewport (scrolling the stages)
          //   releasing → absolute, anchored to the section bottom, so the
          //               WHOLE hero (video + content + cue) scrolls UP as
          //               one unit during the section's last viewport and the
          //               next section scrolls in beneath it (title first).
          //               No blind hold, no jump to the cards.
          //   after     → section fully out of view (hidden).
          var inSection = rect.top < vh && rect.bottom > 0;
          if (!inSection) {
            root.setAttribute('data-pinned', 'after');
            return;
          }
          if (rect.bottom < vh) {
            root.setAttribute('data-pinned', 'releasing');
          } else {
            root.setAttribute('data-pinned', 'active');
          }

          // Effective scroll offset INTO the section (0 at top, sectionH-vh at bottom)
          var scrolled = -rect.top;          // negative when section above viewport top
          if (scrolled < 0) scrolled = 0;

          // Pick the panel whose midpoint is closest to viewport center.
          // Viewport center in section coords = scrolled + vh/2.
          var center = scrolled + vh / 2;
          var p1Mid =  50 * vh / 100;
          var p2Mid = 185 * vh / 100;
          var p3Mid = 355 * vh / 100;
          var d1 = Math.abs(center - p1Mid);
          var d2 = Math.abs(center - p2Mid);
          var d3 = Math.abs(center - p3Mid);
          var stage = 1;
          if (d2 < d1 && d2 <= d3) stage = 2;
          else if (d3 < d1 && d3 < d2) stage = 3;
          setStage(stage);
          requestEval();
        });
      }
      // PERFORMANCE: gate the scroll/resize listeners on viewport
      // intersection. Without this, onScroll() fires globally on
      // every scroll event — even on PAGES that don't include this
      // section, because the listener is window-level. The
      // IntersectionObserver attaches the listeners only while the
      // pinned hero is within ±500px of the viewport (the section is
      // ~3-4 viewports tall, so we need generous rootMargin to keep
      // listening during the full pin lifecycle). This cuts ~100-150ms
      // TBT from pages that don't actually need the pin logic.
      if ('IntersectionObserver' in window) {
        var listening = false;
        var attachListeners = function () {
          if (listening) return;
          listening = true;
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll, { passive: true });
          onScroll(); // re-evaluate when attaching
        };
        var detachListeners = function () {
          if (!listening) return;
          listening = false;
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
        };
        var shpIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) attachListeners();
            else detachListeners();
          });
        }, { rootMargin: '500px 0px' });
        shpIO.observe(root);
        // Run once for initial state (so data-pinned + clip-path are
        // set correctly even if user starts above the section).
        onScroll();
      } else {
        // No IntersectionObserver — preserve original behavior.
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        onScroll();
      }

      // iOS autoplay unlock — first user gesture re-fires play() on every video
      function unlock() {
        root.querySelectorAll('video').forEach(function (v) {
          var p = v.play();
          if (p && typeof p.then === 'function') p.catch(function () {});
        });
        window.removeEventListener('touchstart', unlock);
        window.removeEventListener('click', unlock);
      }
      window.addEventListener('touchstart', unlock, { once: true, passive: true });
      window.addEventListener('click', unlock, { once: true });
    });
  })();

  /* ─── Watch in Action popup video modal ──────────────────────────
     Mirror of the Ultra Gym Live Demo popup behavior, scoped to the
     Studio hero. Click the Watch in Action button → opens modal,
     pauses hero stage videos, plays the popup video. Close → resumes
     hero. ESC, overlay click, X button all close. Body scroll lock
     uses position-fixed-with-restore (iOS-safe). Focus trap between
     close button and the video controls. */
  (function () {
    function lockBody() {
      if (document.body.dataset.portlShpModalLocked === '1') return;
      var scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.portlShpModalLocked = '1';
      document.body.dataset.portlShpModalScrollY = String(scrollY);
      document.body.classList.add('portl-shp-modal-lock');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function unlockBody() {
      if (document.body.dataset.portlShpModalLocked !== '1') return;
      var scrollY = parseInt(document.body.dataset.portlShpModalScrollY || '0', 10);
      document.body.classList.remove('portl-shp-modal-lock');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.portlShpModalLocked;
      delete document.body.dataset.portlShpModalScrollY;
      window.scrollTo(0, scrollY);
    }

    function bindModal(hero) {
      if (!hero || hero.dataset.portlShpModalBound === '1') return;
      var modal = hero.querySelector('[data-portl-shp-modal]');
      if (!modal) return;
      hero.dataset.portlShpModalBound = '1';

      var overlay = modal.querySelector('[data-portl-shp-modal-overlay]');
      var dialog = modal.querySelector('.portl-shp-modal__dialog');
      var closeBtn = modal.querySelector('[data-portl-shp-modal-close]');
      var modalVideo = modal.querySelector('[data-portl-shp-modal-video]');
      if (!dialog || !closeBtn || !modalVideo) return;

      /* Custom Mute/Unmute toggle (native controls are hidden). Mirrors the
         video's live muted state via `volumechange`, so it's correct when the
         open sequence auto-unmutes on `playing` and when the user taps it. */
      var soundBtn = modal.querySelector('[data-portl-shp-modal-sound]');
      function syncSoundBtn() {
        if (!soundBtn) return;
        var muted = modalVideo.muted;
        soundBtn.setAttribute('data-muted', muted ? 'true' : 'false');
        soundBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
        soundBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }
      if (soundBtn) {
        soundBtn.addEventListener('click', function (e) {
          e.preventDefault();
          modalVideo.muted = !modalVideo.muted;   /* volumechange repaints the icon */
        });
        modalVideo.addEventListener('volumechange', syncSoundBtn);
      }

      /* ── HLS primary + MP4 fallback (popup video strategy) ──────
           • Safari / iOS / iPad: native HLS — src set directly.
           • Chrome / Edge / Firefox / Android / Samsung Internet:
             hls.js, lazy-loaded from CDN on FIRST open only.
           • Any fatal HLS failure (script blocked, manifest error,
             network policy) → MP4 fallback: tear down, video.load()
             → the in-markup <source> MP4 tags take over.
           • Close → full teardown (destroy instance, drop src,
             load()) to free decoder + buffer memory. */
      var hlsSrc = modalVideo.getAttribute('data-hls-src');
      var hlsInstance = null;
      var loader = modal.querySelector('[data-portl-shp-modal-loader]');
      /* True only while the popup is open. Guards every play()/unmute path so a
         late-firing media event (canplay / loadeddata / playing / HLS retry)
         can't resume playback after Close — the iOS bug where audio kept
         playing in the background once the modal was dismissed. */
      var modalOpen = false;

      function showLoader() { if (loader) loader.classList.add('is-visible'); }
      function hideLoader() { if (loader) loader.classList.remove('is-visible'); }

      function fallbackToMp4() {
        if (hlsInstance) { try { hlsInstance.destroy(); } catch (e) {} hlsInstance = null; }
        modalVideo.removeAttribute('src');
        modalVideo.dataset.hlsReady = '';
        modalVideo.dataset.hlsFailed = '1';   /* skip HLS on future opens */
        try { modalVideo.load(); } catch (e) {}      /* <source> MP4s kick in */
        if (!modalOpen) return;                       /* don't resume a closed popup */
        try {
          var p = modalVideo.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } catch (e) {}
      }

      function ensureSource(done) {
        if (!hlsSrc || modalVideo.dataset.hlsFailed === '1' || modalVideo.dataset.hlsReady === '1') {
          done(); return;
        }
        if (modalVideo.canPlayType('application/vnd.apple.mpegurl')) {
          modalVideo.src = hlsSrc;
          modalVideo.dataset.hlsReady = '1';
          done(); return;
        }
        function attach() {
          if (window.Hls && window.Hls.isSupported()) {
            hlsInstance = new window.Hls();
            hlsInstance.loadSource(hlsSrc);
            hlsInstance.attachMedia(modalVideo);
            modalVideo.dataset.hlsReady = '1';
            hlsInstance.on(window.Hls.Events.MANIFEST_PARSED, done);
            hlsInstance.on(window.Hls.Events.ERROR, function (evt, data) {
              if (data && data.fatal) {
                if (window.console) console.warn('[portl-shp-modal] HLS fatal — MP4 fallback:', data.type, data.details);
                fallbackToMp4();
              }
            });
          } else {
            fallbackToMp4(); done();
          }
        }
        if (window.Hls) { attach(); return; }
        var sc = document.createElement('script');
        sc.src = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js';
        sc.async = true;
        sc.onload = attach;
        sc.onerror = function () { fallbackToMp4(); done(); };
        document.head.appendChild(sc);
      }

      function teardownStream() {
        if (hlsInstance) { try { hlsInstance.destroy(); } catch (e) {} hlsInstance = null; }
        if (hlsSrc && modalVideo.dataset.hlsReady === '1') {
          /* Free the decode pipeline + buffers (native Safari too).
             hlsReady resets so the next open re-attaches cheaply
             (hls.js script stays cached). */
          modalVideo.removeAttribute('src');
          modalVideo.dataset.hlsReady = '';
          try { modalVideo.load(); } catch (e) {}
        }
      }

      /* MP4 only: warm metadata at idle so first-click play() is
         instant on iOS. HLS fetches nothing until popup opens. */
      if (!hlsSrc) {
        try { modalVideo.load(); } catch (e) {}
      }

      /* Loader lifecycle — hide on first rendered frame. */
      modalVideo.addEventListener('playing', hideLoader);
      modalVideo.addEventListener('loadeddata', hideLoader);
      modalVideo.addEventListener('error', hideLoader);

      /* All hero stage videos. Pause on open, resume on close. */
      var stageVideos = hero.querySelectorAll('.portl-shp__videos video');
      var lastFocused = null;
      var pausedStageVideos = [];

      function pauseStageVideos() {
        pausedStageVideos = [];
        Array.prototype.forEach.call(stageVideos, function (v) {
          if (!v.paused && !v.ended) {
            pausedStageVideos.push(v);
            try { v.pause(); } catch (e) {}
          }
        });
      }
      function resumeStageVideos() {
        pausedStageVideos.forEach(function (v) {
          try {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } catch (e) {}
        });
        pausedStageVideos = [];
      }

      function openModal() {
        if (modal.classList.contains('is-open')) return;
        modalOpen = true;
        lastFocused = document.activeElement;

        pauseStageVideos();
        lockBody();
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        setTimeout(function () { closeBtn.focus(); }, 60);

        showLoader();   /* visible until first frame ('playing'/'loadeddata') */
        modalVideo.muted = true;
        modalVideo.volume = 1;
        syncSoundBtn();   /* show the muted icon immediately on open */
        function attemptPlay() {
          if (!modalOpen) return;   /* popup closed before the source was ready → don't play */
          try { modalVideo.currentTime = 0; } catch (e) {}
          var p = modalVideo.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function (err) {
              try { console.warn('[portl-shp-modal] play failed:', err); } catch (e) {}
            });
          }
        }
        /* Resolve the source first (no-op for MP4; attaches the HLS
           stream — natively or via hls.js — on first open). */
        ensureSource(function () {
          if (modalVideo.readyState >= 2) {
            attemptPlay();
            return;
          }
          if (!hlsSrc) {
            try { modalVideo.load(); } catch (e) {}
          }
          var onReady = function () {
            modalVideo.removeEventListener('canplay', onReady);
            modalVideo.removeEventListener('loadeddata', onReady);
            attemptPlay();
          };
          modalVideo.addEventListener('canplay', onReady);
          modalVideo.addEventListener('loadeddata', onReady);
          attemptPlay();
        });
        var onPlaying = function () {
          modalVideo.removeEventListener('playing', onPlaying);
          /* If 'playing' fires after the popup was closed (late buffer/segment),
             stop it instead of unmuting — otherwise iOS keeps the audio going. */
          if (!modalOpen) { try { modalVideo.pause(); } catch (e) {} return; }
          modalVideo.muted = false;
        };
        modalVideo.addEventListener('playing', onPlaying);
      }

      function closeModal() {
        if (!modal.classList.contains('is-open')) return;
        modalOpen = false;   /* set FIRST so any late/pending play() is suppressed */
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        /* Strategy-mandated close sequence:
           pause → destroy HLS instance → remove source → load()
           → browser frees decoder + buffer memory. MP4 (no HLS)
           keeps the lighter pause + rewind path. */
        try { modalVideo.pause(); } catch (e) {}
        teardownStream();
        if (!hlsSrc) {
          try { modalVideo.currentTime = 0; } catch (e) {}
        }
        modalVideo.muted = true;
        /* iOS Safari: a play() promise already in flight can resume playback a
           tick AFTER we pause here. Re-pause on the next tick (and mute) so the
           audio can't linger in the background once the popup is closed. */
        setTimeout(function () {
          if (modalOpen) return;
          try { modalVideo.pause(); } catch (e) {}
          try { modalVideo.muted = true; } catch (e) {}
        }, 0);
        hideLoader();
        unlockBody();
        resumeStageVideos();
        if (lastFocused && typeof lastFocused.focus === 'function') {
          try { lastFocused.focus(); } catch (e) {}
        }
      }

      /* Watch in Action CTA — preventDefault so the href is ignored
         and the modal opens instead. */
      var triggers = hero.querySelectorAll('[data-portl-shp-popup-trigger]');
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        });
      });

      closeBtn.addEventListener('click', closeModal);
      if (overlay) overlay.addEventListener('click', closeModal);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          e.preventDefault();
          closeModal();
        }
      });
      modal.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !modal.classList.contains('is-open')) return;
        var focusables = [closeBtn, modalVideo].filter(Boolean);
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    function initAll(root) {
      root = root || document;
      var heroes = root.querySelectorAll('.portl-shp[data-section-id]');
      heroes.forEach(function (hero) {
        if (hero.querySelector('[data-portl-shp-modal]')) bindModal(hero);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.portl-shp')) {
        e.target.querySelectorAll('.portl-shp[data-section-id]').forEach(function (h) {
          h.dataset.portlShpModalBound = '';
        });
        initAll(e.target);
      }
    });

    /* ── Scroll cue → smooth-scroll to the next content section ──────
       The "Scroll" cue/chevron is a button; clicking it advances the
       page to the section after the pinned hero. The cue auto-hides
       (and drops pointer-events) past stage 1, so it only fires while
       the hero banner is in view. Delegated so it survives section
       reloads in the theme editor. */
    document.addEventListener('click', function (e) {
      var cue = e.target.closest('[data-shp-scroll]');
      if (!cue) return;
      var sec = cue.closest('.shopify-section') || cue.closest('.portl-shp');
      var next = sec ? sec.nextElementSibling : null;
      while (next && next.getBoundingClientRect().height < 1) { next = next.nextElementSibling; }
      if (next) { next.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      else { window.scrollBy({ top: window.innerHeight, behavior: 'smooth' }); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-studio-modes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initModesSection(root) {
      var track = root.querySelector('[data-modes-track]');
      var pills = root.querySelectorAll('[data-pill-index]');
      var originals = Array.prototype.slice.call(root.querySelectorAll('.portl-smodes__slide'));
      var n = originals.length;
      if (!track || pills.length === 0 || n === 0) return;

      var isProgrammaticScroll = false;
      var resetScrollTimer = null;
      var settleTimer = null;
      var pillsCapsule = root.querySelector('[data-modes-pills]');
      if (pillsCapsule && pillsCapsule.style.transform) { pillsCapsule.style.transform = ''; }

      var dots    = root.querySelectorAll('[data-dot-index]');
      var prevBtn = root.querySelector('[data-modes-prev]');
      var nextBtn = root.querySelector('[data-modes-next]');

      // ─── Infinite loop via cloned copies ───────────────────────────────
      // Build [clone set][originals][clone set]. Each slide keeps a
      // data-real-index so pills / dots / arrows stay mapped to the REAL
      // workout (0..n-1) no matter which copy is on screen. Because a clone is
      // pixel-identical, silently recentering the scroll from a clone to its
      // original (after the gesture settles) is invisible — no flicker, no
      // snap-back. Native scroll is preserved → drag / swipe / trackpad work.
      var looping = n > 1;
      originals.forEach(function (sl, i) { sl.setAttribute('data-real-index', i); });
      var slides = originals;
      if (looping) {
        var lf = document.createDocumentFragment(), rf = document.createDocumentFragment();
        originals.forEach(function (sl) {
          var a = sl.cloneNode(true); a.setAttribute('data-clone', '1'); a.setAttribute('aria-hidden', 'true'); a.removeAttribute('id'); a.classList.remove('is-center'); lf.appendChild(a);
          var b = sl.cloneNode(true); b.setAttribute('data-clone', '1'); b.setAttribute('aria-hidden', 'true'); b.removeAttribute('id'); b.classList.remove('is-center'); rf.appendChild(b);
        });
        track.insertBefore(lf, originals[0]);
        track.appendChild(rf);
        slides = Array.prototype.slice.call(track.querySelectorAll('.portl-smodes__slide'));
      }

      var activeReal = 0;
      function realOf(el) { var v = parseInt(el.getAttribute('data-real-index'), 10); return isNaN(v) ? 0 : v; }

      // Pills + dots + arrow state — keyed to the REAL index. Arrows never
      // dead-end while looping.
      function highlight(realIdx) {
        activeReal = realIdx;
        pills.forEach(function (p, i) { var on = i === realIdx; p.classList.toggle('is-active', on); p.setAttribute('aria-selected', on ? 'true' : 'false'); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === realIdx); });
        if (prevBtn) prevBtn.disabled = looping ? false : realIdx <= 0;
        if (nextBtn) nextBtn.disabled = looping ? false : realIdx >= n - 1;
      }
      // The centered-card scale/opacity effect belongs to the DOM slide that is
      // actually in the middle (clone or original), not to a real index.
      function centerClass(domSlide) {
        slides.forEach(function (sl) { sl.classList.toggle('is-center', sl === domSlide); });
      }

      function centerDelta(slide) { var tr = track.getBoundingClientRect(), sr = slide.getBoundingClientRect(); return (sr.left + sr.width / 2) - (tr.left + tr.width / 2); }
      function centeredDom() {
        var tr = track.getBoundingClientRect(), tc = tr.left + tr.width / 2, best = 0, bd = Infinity;
        for (var i = 0; i < slides.length; i++) { var r = slides[i].getBoundingClientRect(); var d = Math.abs((r.left + r.width / 2) - tc); if (d < bd) { bd = d; best = i; } }
        return best;
      }
      function setWidth() { return looping ? (slides[n].offsetLeft - slides[0].offsetLeft) : 0; }
      // Instant scroll jump. The track's CSS sets `scroll-behavior: smooth`,
      // which would otherwise ANIMATE a `scrollLeft` change — turning the loop
      // reset into a visible slide-back. Temporarily forcing `auto` makes the
      // reposition a single, imperceptible frame between identical slides.
      function jumpBy(px) {
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft += px;
        track.style.scrollBehavior = prevBehavior;
      }
      // Invisible recenter to the middle set once scrolling has settled, then
      // re-assert the highlight + centered card on the now-centered slide.
      function recenter() {
        if (!looping) return;
        var dom = centeredDom(), sw = setWidth();
        if (sw <= 0) return;
        if (dom < n) { jumpBy(sw); }
        else if (dom >= 2 * n) { jumpBy(-sw); }
        var c = centeredDom();
        centerClass(slides[c]);
        highlight(realOf(slides[c]));
      }

      function scrollToDom(idx, smooth) {
        var slide = slides[idx];
        if (!slide) return;
        isProgrammaticScroll = true;
        track.scrollTo({ left: track.scrollLeft + centerDelta(slide), behavior: smooth ? 'smooth' : 'auto' });
        highlight(realOf(slide));
        centerClass(slide);
        clearTimeout(resetScrollTimer);
        resetScrollTimer = setTimeout(function () { isProgrammaticScroll = false; }, 700);
      }

      // Click pill → scroll to the NEAREST copy of that workout (shortest path,
      // which may cross the loop seam).
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var idx = parseInt(pill.getAttribute('data-pill-index'), 10);
          if (isNaN(idx) || idx < 0 || idx >= n) return;
          var cur = centeredDom(), best = -1, bd = Infinity;
          for (var i = 0; i < slides.length; i++) { if (realOf(slides[i]) === idx) { var d = Math.abs(i - cur); if (d < bd) { bd = d; best = i; } } }
          if (best >= 0) scrollToDom(best, true);
        });
      });

      // Track scroll → active pill via IntersectionObserver (mapped to real idx).
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (isProgrammaticScroll) return;
          var best = null;
          entries.forEach(function (e) { if (!best || e.intersectionRatio > best.intersectionRatio) best = e; });
          if (best && best.isIntersecting) { highlight(realOf(best.target)); centerClass(best.target); }
        }, { root: track, threshold: [0.5, 0.7, 0.9] });
        slides.forEach(function (sl) { io.observe(sl); });
      }

      // Arrows — pre-recenter (so rapid clicks never exhaust the clone buffer),
      // then step one DOM slide. Always enabled; loops via recenter.
      if (prevBtn) prevBtn.addEventListener('click', function () { recenter(); scrollToDom(centeredDom() - 1, true); });
      if (nextBtn) nextBtn.addEventListener('click', function () { recenter(); scrollToDom(centeredDom() + 1, true); });

      // ── Endless in EVERY input mode ────────────────────────────────────
      // Trackpad / wheel scroll continuously with no settle, so while wheeling
      // we recenter LIVE every frame the centred slide reaches a clone — the
      // track stays inside the middle set and never hits the scroll end. Touch
      // never fires `wheel`; it uses the debounced settle recenter (jumping
      // scrollLeft mid-touch-momentum would fight iOS inertia).
      var wheeling = false, wheelTimer = null, rafPending = false;
      track.addEventListener('wheel', function () {
        wheeling = true;
        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function () { wheeling = false; }, 200);
      }, { passive: true });
      track.addEventListener('scroll', function () {
        if (!rafPending) {
          rafPending = true;
          requestAnimationFrame(function () { rafPending = false; if (wheeling && !isProgrammaticScroll) recenter(); });
        }
        clearTimeout(settleTimer);
        settleTimer = setTimeout(recenter, 100);
      }, { passive: true });

      // ── Mouse click-drag to scroll (bounded gesture → recenter on end). Touch
      // keeps native scrolling; a click right after a real drag is suppressed.
      var dragging = false, dragStartX = 0, dragStartLeft = 0, dragMoved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; dragMoved = false;
        dragStartX = e.clientX; dragStartLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 3) dragMoved = true;
        var pb = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = dragStartLeft - dx;
        track.style.scrollBehavior = pb;
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        recenter();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) {
        if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
      }, true);

      // ── Initial active slide (admin "Default active workout") ──
      // Centered inside the MIDDLE set so it can loop both ways immediately.
      // Below the fold, so this instant scroll set is never visible.
      var startIdx = parseInt(track.getAttribute('data-default-index'), 10);
      if (isNaN(startIdx) || startIdx < 0 || startIdx >= n) startIdx = 0;
      var startDom = looping ? (n + startIdx) : startIdx;
      var _slide = slides[startDom];
      if (_slide) { jumpBy(centerDelta(_slide)); centerClass(_slide); }
      highlight(startIdx);
    }

    function initAll() {
      document.querySelectorAll('.portl-smodes[data-section-id]').forEach(initModesSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // Re-init on Shopify theme editor section reload
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.portl-smodes[data-section-id]') : null;
      if (root) initModesSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-studio-personalisation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Lazy-arm a deferred video: bump preload + call play(). src is already
    // set, so the poster shows reliably until the video starts playing.
    function armVideo(v) {
      if (v.dataset.spersArmed === '1') return;
      v.dataset.spersArmed = '1';
      try { v.preload = 'auto'; } catch (e) {}
      v.removeAttribute('data-spers-deferred');
      var p = v.play();
      if (p && typeof p.then === 'function') p.catch(function () {});
    }

    // IO #1: video play/pause + lazy arm
    var videoIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          armVideo(v);
          var p = v.play();
          if (p && typeof p.then === 'function') p.catch(function () {});
        } else if (v.dataset.spersArmed === '1') {
          v.pause();
        }
      });
    }, { threshold: 0.25, rootMargin: '200px 0px' }) : null;

    document.querySelectorAll('.portl-spers__video').forEach(function (v) {
      if (videoIO) videoIO.observe(v);
      else armVideo(v);
    });

    // IO #2: scroll-triggered fade-in for each card
    // Sets data-in-view="true" on each card the first time it enters viewport.
    // CSS handles the actual transform/opacity transition with stagger delays.
    var cardIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.setAttribute('data-in-view', 'true');
          cardIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }) : null;

    document.querySelectorAll('[data-spers-card]').forEach(function (c) {
      if (cardIO) cardIO.observe(c);
      else c.setAttribute('data-in-view', 'true'); // fallback: show immediately
    });
    // First-gesture autoplay unlock for iOS
    function unlock() {
      document.querySelectorAll('.portl-spers__video').forEach(function (v) {
        var p = v.play();
        if (p && typeof p.then === 'function') p.catch(function () {});
      });
      window.removeEventListener('touchstart', unlock);
      window.removeEventListener('click', unlock);
    }
    window.addEventListener('touchstart', unlock, { once: true, passive: true });
    window.addEventListener('click', unlock, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-studio-why"] && !Shopify.designMode) return;
  try {
    
  /* ═══════════════════════════════════════════════════════════════
     PRIMARY PINNER — vanilla JS, no dependencies.

     Sets `position: fixed` on the left text column via JS scroll
     handler whenever the section is in view. This is the GUARANTEED
     working mechanism because:
       • Doesn't depend on CSS sticky (which can fail silently due
         to ancestor overflow, transform, or contain rules)
       • Doesn't depend on GSAP loading (which can fail if the CDN
         is blocked or the asset file 404s)
       • Pure DOM measurement — works in every browser

     Runs immediately, doesn't wait for GSAP. CSS sticky and GSAP
     pin are kept as redundant backups (in the block below) but
     this is what actually pins the column for the user.
     ═══════════════════════════════════════════════════════════════ */
  (function () {
    function setupPinner(section) {
      var desktopWrap = section.querySelector('.portl-swhy__desk');
      if (!desktopWrap) return;
      var leftCol = desktopWrap.querySelector('.portl-swhy__col-text');
      var rows = section.querySelectorAll('[data-portl-swhy-row]');
      var photos = section.querySelectorAll('[data-portl-swhy-photo]');
      if (!leftCol || !rows.length || !photos.length) return;

      var lastActiveIdx = -1;
      var INNER_PADDING = 32;  /* matches --swy-px-d default */
      var GRID_GAP = 64;       /* matches gap: 4rem */

      function isDesktop() { return window.innerWidth >= 1024; }

      function updateActiveRow() {
        var viewportCenter = window.innerHeight / 2;
        var activeIdx = 0;
        var closestDist = Infinity;
        photos.forEach(function (photo, i) {
          var rect = photo.getBoundingClientRect();
          var photoCenter = (rect.top + rect.bottom) / 2;
          var dist = Math.abs(photoCenter - viewportCenter);
          if (dist < closestDist) {
            closestDist = dist;
            activeIdx = i;
          }
        });
        if (activeIdx === lastActiveIdx) return;
        lastActiveIdx = activeIdx;
        rows.forEach(function (row, i) {
          if (i === activeIdx) row.classList.add('active');
          else row.classList.remove('active');
        });
      }

      /* SINGLE source of truth: always compute fresh position based
         on current scroll state. No `isPinned` flag to get stuck out
         of sync. Every scroll tick either sets the pinned style or
         clears it — no in-between state. */
      function update() {
        if (!isDesktop()) {
          if (leftCol.style.position === 'fixed') leftCol.style.cssText = '';
          return;
        }

        var sectionRect = section.getBoundingClientRect();
        var shouldPin = sectionRect.top <= 0 && sectionRect.bottom > window.innerHeight;

        if (shouldPin) {
          /* IMPORTANT: position: fixed uses VIEWPORT coordinates,
             so don't add pageXOffset. getBoundingClientRect() is
             already viewport-relative. */
          var inner = section.querySelector('.portl-swhy__inner');
          var innerRect = (inner || section).getBoundingClientRect();
          var leftPos = innerRect.left + INNER_PADDING;
          var contentWidth = innerRect.width - (INNER_PADDING * 2);
          var pinWidth = (contentWidth - GRID_GAP) / 2;

          leftCol.setAttribute('data-portl-swhy-pinned', '1');
          leftCol.style.cssText =
            'position: fixed !important;' +
            'top: 0 !important;' +
            'left: ' + leftPos + 'px !important;' +
            'width: ' + pinWidth + 'px !important;' +
            'height: 100vh !important;' +
            'overflow: hidden !important;' +
            'text-align: left !important;' +
            'z-index: 5;';
        } else {
          if (leftCol.hasAttribute('data-portl-swhy-pinned')) {
            leftCol.removeAttribute('data-portl-swhy-pinned');
            leftCol.style.cssText = '';
          }
        }

        updateActiveRow();
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }

      function onResize() {
        /* Force-clear styles then re-run update so dimensions are
           freshly computed against the new viewport size. */
        leftCol.style.cssText = '';
        leftCol.removeAttribute('data-portl-swhy-pinned');
        update();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);

      /* Run once after layout settles */
      if (document.readyState === 'complete') {
        update();
      } else {
        window.addEventListener('load', update);
      }
      update();
    }

    document.querySelectorAll('.portl-swhy[data-section-id]').forEach(setupPinner);
  })();

  /* ──────────────────────────────────────────────────────────────
     Synchronized scrollytelling using GSAP + ScrollTrigger — EXACT
     same library + config as the reference HTML
     (portl.co/product/studio/index.html).

     Loads GSAP from jsDelivr lazily (only on pages that have this
     section). Once loaded, the desktop matchMedia branch creates
     one ScrollTrigger per image — `start: top 50%`, `end: bottom 50%`
     — that toggles the `.active` class on the matching text row.

     Plus an "edge guard" ScrollTrigger on the section itself that
     activates the first text when scrolling up past the top edge,
     and the last text when scrolling down past the bottom edge.

     This is a 1:1 port of the reference's <script> tag, just
     scoped to our section roots instead of a global document query.
     ────────────────────────────────────────────────────────────── */
  (function () {
    var roots = document.querySelectorAll('.portl-swhy[data-section-id]');
    if (!roots.length) return;

    /* GSAP + ScrollTrigger URLs — served from the theme's assets/
       folder via Shopify's CDN. URLs are emitted on the section
       root as data-gsap-url / data-st-url so the javascript
       block (which doesn't render Liquid) can still pick them up.
       Falls back to jsDelivr if the data attributes are missing
       (e.g., during local dev). */
    var firstRoot = roots[0];
    var GSAP_URL = firstRoot.getAttribute('data-gsap-url')
      || 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var ST_URL   = firstRoot.getAttribute('data-st-url')
      || 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        /* De-dupe: if another section already added this script tag,
           wait for it instead of injecting a second one. */
        var existing = document.querySelector('script[data-portl-gsap-src="' + src + '"]');
        if (existing) {
          if (existing.getAttribute('data-loaded') === '1') return resolve();
          existing.addEventListener('load', function () { resolve(); });
          existing.addEventListener('error', reject);
          return;
        }
        var s = document.createElement('script');
        s.src = src;
        s.setAttribute('data-portl-gsap-src', src);
        s.onload = function () { s.setAttribute('data-loaded', '1'); resolve(); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    function init() {
      if (!window.gsap || !window.ScrollTrigger) return;
      gsap.registerPlugin(ScrollTrigger);
      var mm = gsap.matchMedia();

      roots.forEach(function (root) {
        /* Trigger on the photo WRAPPERS (which always have 50vw
           height even with no image set) — falls back to imgs
           if wrappers aren't found. */
        var featureWrappers = root.querySelectorAll('[data-portl-swhy-photo]');
        var featureImgs = root.querySelectorAll('[data-portl-swhy-photo] img');
        var featureBoxes = root.querySelectorAll('[data-portl-swhy-row]');
        if (!featureWrappers.length || !featureBoxes.length) return;

        /* Desktop sticky-text + scrolling-images sync — EXACT port
           of the reference's `mm.add('(min-width: 1024px)', ...)`
           block. matchMedia auto-cleans up triggers when the
           breakpoint stops matching (e.g. user rotates to portrait). */
        mm.add('(min-width: 1024px)', function () {
          var triggers = [];

          /* Wait for images to fully load before measuring positions —
             without this, ScrollTrigger calculates start/end against
             empty image elements and misfires. Matches the reference. */
          var imgPromises = Array.prototype.map.call(featureImgs, function (img) {
            if (img.complete && img.naturalWidth > 0) return Promise.resolve();
            return new Promise(function (resolve) {
              img.addEventListener('load', resolve);
              img.addEventListener('error', resolve);
            });
          });

          Promise.all(imgPromises).then(function () {
            ScrollTrigger.refresh();

            /* NOTE: GSAP pin REMOVED — the vanilla JS pinner at
               the top of this file handles all pinning. Having
               both GSAP and vanilla JS try to pin the same element
               caused intermittent "sometimes works" failures
               because they fight each other on every scroll tick
               (both set position:fixed with slightly different
               offsets). The vanilla JS pinner is the single source
               of truth for pinning now. */

            /* Toggle .active class on text row as matching photo
               wrapper crosses viewport center. Using wrappers
               instead of inner <img loading="lazy" decoding="async"> so this works even if the
               admin hasn't set images yet. */
            Array.prototype.forEach.call(featureWrappers, function (wrapper, i) {
              var featureBox = featureBoxes[i];
              if (!featureBox) return;
              triggers.push(ScrollTrigger.create({
                trigger: wrapper,
                /* Writes a NON-visual class only. The vanilla updateActiveRow()
                   pinner is the SINGLE source of truth for the `.active` card
                   (closest image to viewport center = exactly one). Having GSAP
                   also toggle `.active` let two rows be carded at once. */
                toggleClass: { targets: featureBox, className: 'is-swhy-inview' },
                start: 'top 50%',
                end: 'bottom 50%',
                invalidateOnRefresh: true
              }));
            });

            /* Edge guard — matches reference exactly */
            triggers.push(ScrollTrigger.create({
              trigger: root,
              start: 'top+=720px bottom',
              end: 'bottom center',
              invalidateOnRefresh: true,
              onUpdate: function (self) {
                var direction = self.direction;
                var isActive = self.isActive;
                if (direction === -1 && !isActive) {
                  if (featureBoxes[0]) featureBoxes[0].classList.add('is-swhy-inview');
                } else if (direction === 1 && !isActive) {
                  if (featureBoxes[featureBoxes.length - 1]) {
                    featureBoxes[featureBoxes.length - 1].classList.add('is-swhy-inview');
                  }
                }
              }
            }));
          });

          return function cleanup() {
            triggers.forEach(function (t) { t.kill(); });
          };
        });
      });

      /* Debounced refresh on resize — matches reference */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { ScrollTrigger.refresh(); }, 250);
      });
    }

    /* CDN fallbacks — used if local theme asset files 404 (e.g.,
       gsap.min.js / ScrollTrigger.min.js not pushed yet, or CDN
       cache miss). */
    var CDN_GSAP = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var CDN_ST   = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

    function loadWithFallback(primaryUrl, fallbackUrl) {
      return loadScript(primaryUrl).catch(function () {
        console.warn('[portl-swhy] primary URL failed:', primaryUrl, '— falling back to CDN');
        return loadScript(fallbackUrl);
      });
    }

    /* Sequential load: gsap.min.js must finish before ScrollTrigger.min.js
       executes (ST is a plugin and references the global `gsap`). */
    function ensureLoaded() {
      if (window.gsap && window.ScrollTrigger) return Promise.resolve();
      if (window.gsap) return loadWithFallback(ST_URL, CDN_ST);
      return loadWithFallback(GSAP_URL, CDN_GSAP).then(function () {
        return loadWithFallback(ST_URL, CDN_ST);
      });
    }

    ensureLoaded().then(init).catch(function (err) {
      console.error('[portl-swhy] GSAP load failed:', err);
      /* Fallback: keep the default first-row .active class so the
         user sees the first text block even if GSAP can't load. */
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-tabbed-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-id]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-portl-tab-target]');
      if (!tabs.length) return;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-portl-tab-target');
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          root.querySelectorAll('.portl-tabbed__panel').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.id === target);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-ultra-accessories"] && !Shopify.designMode) return;
  try {
    
  // ─── IO-gated autoplay for the accessories video ─────────────
  //
  // Markup keeps the `autoplay` attribute as a no-JS fallback. On
  // init we immediately pause + cache the desired-play state, then
  // play/pause based on viewport intersection.
  //
  // Why: this section is below-the-fold on UltraGym Explore. Without
  // the IO gate, iOS Safari was eagerly fetching data for both the
  // desktop and mobile <video> elements during the initial page load,
  // contending with the hero video's bandwidth. The fix matches the
  // pattern already in use by portl-video-feature.liquid.
  (function () {
    function init(root) {
      root = root || document;
      var videos = root.querySelectorAll('[data-portl-ua-video]');
      if (!videos.length) return;

      videos.forEach(function (v) {
        if (v.dataset.portlUaInit === '1') return;
        v.dataset.portlUaInit = '1';
        v.muted = true;
        v.defaultMuted = true;

        // Pause the just-started playback so iOS stops fetching data
        // for an offscreen video. IO will resume when in viewport.
        try { v.pause(); } catch (e) {}

        var attempt = function () {
          try {
            var p = v.play();
            if (p && typeof p.then === 'function') p.catch(function () {});
          } catch (e) {}
        };

        if ('IntersectionObserver' in window) {
          var firstHit = false;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                attempt();
                if (!firstHit) {
                  v.addEventListener('loadedmetadata', attempt, { once: true });
                  v.addEventListener('canplay',        attempt, { once: true });
                  firstHit = true;
                }
              } else {
                try { v.pause(); } catch (err) {}
              }
            });
          }, { threshold: 0.1, rootMargin: '200px 0px' });
          io.observe(v);
        } else {
          // No IO support — fall back to eager play
          attempt();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-video-feature"] && !Shopify.designMode) return;
  try {
    
  // ──────────────────────────────────────────────────────────────
  // Click-to-toggle play/pause for video feature blocks.
  //
  // Each block can render TWO <video> elements (desktop + mobile);
  // CSS hides the inactive one with display: none. The hidden video
  // is automatically paused by the browser (display: none stops
  // playback in modern engines) so we don't double-decode.
  //
  // To pick the "visible" video at any moment we use
  // getBoundingClientRect() — the hidden frame returns 0 width/height
  // because `display: none`. We also re-check on resize so rotation
  // / window-resize switches the active video correctly.
  //
  // iOS-safe autoplay defaults: muted + playsinline + retry on
  // metadata + first-interaction unlock.
  // ──────────────────────────────────────────────────────────────
  (function () {
    function isVisible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function visibleVideo(videos) {
      for (var i = 0; i < videos.length; i++) {
        if (isVisible(videos[i])) return videos[i];
      }
      // Fall back to the first video if none report visible (e.g. SSR /
      // section just rendered and not yet laid out).
      return videos[0] || null;
    }

    function attemptPlay(v) {
      if (!v) return;
      try {
        v.muted = true;
        v.defaultMuted = true;
        var p = v.play();
        if (p && typeof p.then === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function init(root) {
      root = root || document;
      var blocks = root.querySelectorAll('[data-portl-video-feature]');
      if (!blocks.length) return;

      blocks.forEach(function (block) {
        if (block.dataset.portlVfInit === '1') return;
        block.dataset.portlVfInit = '1';

        var videos = block.querySelectorAll('[data-portl-vf-video]');
        var toggle = block.querySelector('[data-portl-vf-toggle]');
        if (!videos.length) return;

        // `block` IS the .portl-video-feature__video wrapper (the
        // [data-portl-video-feature] attribute is on the same element), which
        // is where the is-playing class + its CSS live. The play/pause icon
        // must follow the VISIBLE video's real state only — the hidden
        // (other-viewport) autoplay video can keep reporting "playing", which
        // froze the icon on Pause even after the user paused. (Actual fix.)
        function syncPlayState() {
          var vis = visibleVideo(videos);
          if (vis && !vis.paused && !vis.ended) {
            block.classList.add('is-playing');
          } else {
            block.classList.remove('is-playing');
          }
        }

        // iOS-safe defaults on EVERY video element (desktop + mobile)
        videos.forEach(function (v) {
          v.muted = true;
          v.defaultMuted = true;
          v.setAttribute('muted', '');
          v.setAttribute('playsinline', '');
          v.setAttribute('webkit-playsinline', '');

          // Per-video play/pause class toggling so the poster fades
          // when the visible video starts.
          v.addEventListener('play',  syncPlayState);
          v.addEventListener('pause', syncPlayState);
          v.addEventListener('ended', syncPlayState);
        });

        // If autoplay is intended, kick the VISIBLE video on init +
        // re-kick on metadata/canplay (iOS often refuses early plays).
        //
        // PERFORMANCE: gate the initial play behind IntersectionObserver
        // so iOS doesn't queue MP4 downloads for videos far below the
        // fold. Without this, iPhones reported slow loading because the
        // browser was eagerly pulling video data for sections still
        // 2–3 screens away. We also pause when scrolled out — saves
        // battery and decoder cycles on mobile.
        var anyAutoplay = false;
        videos.forEach(function (v) { if (v.hasAttribute('autoplay')) anyAutoplay = true; });
        if (anyAutoplay) {
          var startActive = function () { attemptPlay(visibleVideo(videos)); };

          if ('IntersectionObserver' in window) {
            var inViewport = false;
            var ioFired = false;
            var io = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                inViewport = entry.isIntersecting;
                if (inViewport) {
                  if (!ioFired) {
                    // First time entering viewport — wire metadata/canplay
                    // retries (iOS sometimes refuses the first play even
                    // when muted; these listeners catch the retry).
                    videos.forEach(function (v) {
                      v.addEventListener('loadedmetadata', startActive, { once: true });
                      v.addEventListener('canplay',        startActive, { once: true });
                    });
                    ioFired = true;
                  }
                  startActive();
                } else {
                  // Pause when scrolled out — preserves CPU/battery on
                  // mobile. The next intersection re-plays.
                  videos.forEach(function (v) {
                    try { v.pause(); } catch (e) {}
                  });
                }
              });
            }, { threshold: 0.15, rootMargin: '200px 0px' });
            io.observe(block);
          } else {
            // No IntersectionObserver support → fall back to eager play
            // (preserves the original behavior on ancient browsers).
            startActive();
            videos.forEach(function (v) {
              v.addEventListener('loadedmetadata', startActive, { once: true });
              v.addEventListener('canplay',        startActive, { once: true });
            });
          }

          // Re-kick on viewport changes (orientation / resize crossing
          // the 1024px breakpoint swaps which video is visible).
          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(startActive, 200);
          });
        }

        // Click anywhere on the block (or the toggle button) to play/pause
        // the currently-visible video.
        var onToggle = function (e) {
          e.preventDefault();
          var v = visibleVideo(videos);
          if (!v) return;
          if (v.paused) {
            attemptPlay(v);
          } else {
            v.pause();
          }
        };
        if (toggle) toggle.addEventListener('click', onToggle);
        block.addEventListener('click', function (e) {
          if (e.target.closest('[data-portl-vf-toggle]')) return;
          onToggle(e);
        });
      });
    }

    // TBT: below-fold section — defer init until it nears the viewport
    // instead of running its setup at DOMContentLoaded. init() unchanged.
    function whenVisible() {
      var els = document.querySelectorAll('[data-portl-video-feature]');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { init(document); return; }
      var io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) { io.disconnect(); init(document); break; }
        }
      }, { rootMargin: '400px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenVisible, { once: true });
    } else {
      whenVisible();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-video-hero"] && !Shopify.designMode) return;
  try {
    
  // ──────────────────────────────────────────────────────────────
  // Stage shrink trigger
  //   • IntersectionObserver: when the section is in the upper half
  //     of the viewport (user has scrolled past 30% of it), shrink.
  //     Reverses when scrolled back. Matches WP `data-aos-once="false"`.
  //   • iOS-safe video autoplay
  // ──────────────────────────────────────────────────────────────
  (function () {
    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      root = root || document;
      var stages = root.querySelectorAll('[data-portl-video-stage]');
      if (!stages.length) return;

      stages.forEach(function (stage) {
        if (stage.dataset.portlVhInit === '1') return;
        stage.dataset.portlVhInit = '1';

        // iOS-safe autoplay
        var video = stage.querySelector('[data-portl-video-hero-video]');
        if (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          var attemptPlay = function () {
            try {
              var p = video.play();
              if (p && typeof p.then === 'function') p.catch(function () {});
            } catch (e) {}
          };
          attemptPlay();
          video.addEventListener('loadedmetadata', attemptPlay, { once: true });
          video.addEventListener('canplay',        attemptPlay, { once: true });
        }

        if (prefersReducedMotion) return;

        var section = stage.closest('.portl-video-hero');
        if (!section || !('IntersectionObserver' in window)) return;

        // FLICKER FIX retained — see prior commit history for reasoning.
        // State machine:
        //   • Section top ≤ vh*0.33 → SHRINK
        //   • Section top  > vh*0.33 AND intersecting → UN-SHRINK
        //   • Section NOT intersecting → DO NOTHING
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var rect = entry.boundingClientRect;
            var vh = window.innerHeight || document.documentElement.clientHeight;
            var topPastThird = rect.top <= (vh * 0.33);
            if (topPastThird) {
              stage.classList.add('is-shrunk');
            } else if (entry.isIntersecting) {
              stage.classList.remove('is-shrunk');
            }
          });
        }, {
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        });
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portl-why-choose-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-id]').forEach(function (root) {
      var items = root.querySelectorAll('[data-portl-wcs-item]');
      var photoImg = root.querySelector('[data-portl-wcs-photo-img]');
      if (!items.length || !photoImg) return;

      function setActive(idx) {
        items.forEach(function (it, i) {
          it.classList.toggle('is-active', i === idx);
        });
        var newSrc = items[idx].getAttribute('data-portl-wcs-image');
        if (newSrc && newSrc !== photoImg.getAttribute('src')) {
          photoImg.style.opacity = '0';
          setTimeout(function () {
            photoImg.setAttribute('src', newSrc);
            photoImg.style.opacity = '1';
          }, 200);
        }
      }

      // Hover triggers (desktop)
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { setActive(i); });
        it.addEventListener('focusin',    function () { setActive(i); });
      });

      // Scroll-driven (when user scrolls past each item, activate it)
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio >= 0.5) {
              var idx = Array.prototype.indexOf.call(items, e.target);
              if (idx >= 0) setActive(idx);
            }
          });
        }, { threshold: [0.5, 0.75], rootMargin: '-20% 0px -40% 0px' });
        items.forEach(function (it) { io.observe(it); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
